export const languageResourceEs = {
  translation: {
    NomLogiciel: 'OpenCash',
    language: 'es',
    success: 'Éxito',
    error: 'Error',
    message_error_rib: 'Adjunte un documento tipo RIB para la nueva cuenta',
    DescriptionLogiciel:
      'Comunicación bancaria, medios de pago, gestión de caja...',
    pdfViewer: {
      Title: 'Vista previa',
    },
    label_title_liste: 'Lista de Etiquetas',
    ListSmartTags: 'Lista de SmartTags',
    find_smart_tags: 'Buscar un SmartTags por código',
    ListBanque: 'Lista de Bancos',
    find_banque: 'Buscar un banco por código, nombre...',
    find_label: 'Buscar una etiqueta por valor, sección...',
    lecture_seule: ' (Sólo lectura)',
    'List of companies': 'Lista de empresas',
    State: 'Estado',
    None: 'Ninguno',
    Name: 'Nombre',
    Code: 'Código',
    update_timestamp: 'Fecha de modificación',
    Edit: 'Editar',
    Delete: 'Eliminar',
    Import: 'Importar',
    Export: 'Exportar',
    New: 'Nuevo ',
    Element: 'elemento',
    Elements: 'elementos',
    View: 'Ver',
    History: 'Historial',
    Statement: 'Extracto',
    Back: 'Cancelar',
    Selection: 'Selección',
    Ok: 'Ok',
    Print: 'Imprimir',
    Entity: 'Entidad',
    refresh: 'Actualizar',
    'New company': 'Nueva empresa',
    'Fax number': 'No. Fax',
    'Phone number': 'No. Teléfono',
    'Legal informations': 'Aviso legal',
    Address: 'Dirección',
    'Country code': 'País',
    'Closing date': 'Fecha de cierre',
    Duplicate: 'Duplicar',
    Download: 'Descargar',
    Restart: 'Reiniciar',
    'Upload image': 'Descargar una imagen',
    'Update company successfully': 'Actualizar la empresa con éxito',
    'Update company failed': 'Fallo de la actualización de la empresa',
    Save: 'Guardar',
    'Company detail': 'Detalle de la empresa',
    '4Eyes State': '4Eyes estado',
    'Liste des lots': 'Lista de lotes',
    Emetteur: 'Emisor',
    'N remise': '# remesa',
    Montant: 'Importe',
    Comment: 'Comentario',
    Devise: 'Divisa',
    pour1: 'Por 1',
    Add: 'Añadir',
    Reissue: 'Emitir de nuevo',
    Origine: 'Origen',
    Statut: 'Estado',
    Confirmation: 'Confirmación',
    Valider: 'Validar',
    'Valider-New': 'Validar y nuevo',
    nextinvoicebutton: 'Siguientes descuentos',
    Fermer: 'Cerrar',
    'Recherche grp tiers': 'Buscar un grupo de terceros por código, nombre...',
    'Groupe de tiers': 'grupo de terceros',
    details: 'detalles',
    Suppression: '¿Desea eliminar ',
    Confirmer: 'Confirmar',
    Annuler: 'Cancelar',
    Creer: 'Crear',
    RechercherSociete: 'Buscar una empresa por código, nombre...',
    ComboEtat: '- Estado -',
    ComboFlux: '- Flujo -',
    ComboOrigine: '- Origen -',
    ComboStatut: '- Estado -',
    ComboGrpTiers: '- Grupo de terceros -',
    Signature: 'Firma',
    'Nb Operations': 'No.',
    Rappro: 'Conciliación',
    RechercheLot: 'Buscar un lote por número de lote, número de divisa...',
    RechercheTiers:
      'Buscar un tercero por código, nombre, número de cuenta, código de identificación de la empresa...',
    Groupe: 'Grupo',
    'New tiers': 'Creación de un nuevo tercero',
    'Details tiers': 'Ficha del tercero',
    General: 'General',
    IBAN: 'Datos bancarios',
    code_society: 'Empresa',
    'Adresse tiers': 'Dirección del tercero',
    'Banque inter': 'Banco intermediario',
    Expand: 'Expandir',
    Nom: 'Apellido',
    Prenom: 'Nombre',
    Naissance: 'Fecha de nacimiento',
    PNaissance: 'País de nacimiento',
    VNaissance: 'Ciudad de nacimiento',
    Company: 'Empresa',
    Rules: 'Reglas',
    NCompte: 'No. de cuenta',
    AutoEmetteur: 'Autorizar cuenta emisora',
    AutoTiers: 'Autorizar cuenta de terceros',
    'Fiche du compte': 'Ficha de la cuenta',
    'Informations complémentaires': 'Información adicional',
    Collapse: 'Colapsar',
    Action: 'Acciones',
    NoData: 'Ningún dato disponible',
    Loading: 'Cargando',
    'n° mobile': 'No. móvil',
    prenom: 'Nombre',
    nom: 'Apellido',
    etat_user: 'Estado usuario',
    Etat_user_entite: 'Estado entidad usuario',
    'N° demande': '#',
    'Type de demande': 'Tipo de solicitud',
    'Validation date': 'Validación / Rechazo',
    'Request type': 'tipo de solicitud',
    'Short name': 'nombre (corto)',
    valideur: 'aprobador',
    'Request date': 'fecha de solicitud',
    Applicant: 'solicitante',
    titleChange: 'Cambio de filial o de ámbito',
    Perim: 'Buscar un alcance',
    Fil: 'Buscar una entidad',
    scope: 'Alcance',
    entity: 'Entidad',
    account_management: {
      account_list: 'Lista de cuentas bancarias',
      search_txt:
        'Buscar una cuenta por código, nombre, número de cuenta, código de empresa, nombre de empresa...',
      account_detail: 'Visualización del extracto de cuenta',
      operation: 'operaciones',
      search_detail: 'Buscar una operación por referencia, código, texto',
    },
    bool: {
      yes: 'Si',
      no: 'No',
    },
    calendar: {
      today: 'Hoy',
      yesterday: 'Ayer',
      tomorrow: 'Mañana',
      last7Days: 'Últimos 7 días',
      week: 'Esta semana',
      mounth: 'Este mes',
      lastMonth: 'Mes pasado',
      last30days: 'Últimos 30 días',
      year: 'Este año',
      lastYear: 'Año pasado',
      mon: 'Lu.',
      tue: 'Ma.',
      we: 'Mi.',
      thu: 'Ju.',
      fri: 'Vi.',
      sa: 'Sá.',
      sun: 'Do.',
      formatdate: 'DD/MM/AAAA',
      clear: 'Retirar',
      last_tree_mounth: 'Trimestre pasado',
      current_tree_mounth: 'Trimestre actual',
      first_quarter: 'T1',
      second_quarter: 'T2',
      third_quarter: 'T3',
      fourth_quarter: 'T4',
      first_semestre: 'S1',
      second_semestre: 'S2',
      placeholder: 'DD/MM/AAAA - DD/MM/AAAA',
      placeholder_dateMonth: 'DD/MM',
      placeholder_yearOnly: 'AAAA - AAAA',
      fullCalendarTitle: 'Calendario Completo',
      month: 'Mes',
      day: 'Día',
      addEvent: 'Agregar Evento',
      editEvent: 'Editar Evento',
      saveEvent: 'Guardar Evento',
      updateEvent: 'Actualizar Evento',
      eventTitle: 'Título del Evento',
      eventDescription: 'Descripción del Evento',
      eventTitlePlaceholder: 'Ingrese el título del evento...',
      eventDescriptionPlaceholder:
        'Ingrese la descripción del evento (opcional)...',
      confirmDelete:
        '¿Está seguro de que desea eliminar el evento "{{title}}"?',
      back: 'Volver',
      january: 'Ene',
      february: 'Feb',
      march: 'Mar',
      april: 'Abr',
      may: 'May',
      june: 'Jun',
      july: 'Jul',
      august: 'Ago',
      september: 'Sep',
      october: 'Oct',
      november: 'Nov',
      december: 'Dic',
    },
    treepicker: {
      placeholder: 'Buscar',
    },
    data_grid: {
      start: 'Mín.',
      end: 'Máx.',
      noDataToExport: 'Ninguna dato a exportar',
      pagination: 'Resultados por páginas',
      indexpagination: 'de',
      showpagination: 'Mostrar',
      diff_showpagination: 'Showing',
      diffindex: 'of',
    },
    Pays: 'País',
    login: {
      hometitle: 'OpenCash | Autenticación',
      login: 'Login',
      forgotpassword: '¿Olvidó su contraseña? ',
      reset: 'Restablecer',
      saveCredentials: 'Recordar',
      loginFailed: 'Login/contraseña incorrectos Por favor, inténtelo de nuevo',
      signin: 'Iniciar sesión',
      username_required: 'Dirección de correo obligatoria',
      password_required: 'Contraseña obligatoria',
      enter_email: 'Escriba su dirección de correo electrónico',
      reset_password: 'Restablecer contraseña',
      back_to: 'Volver al',
      language: 'Preferencia de idioma',
      confirm_password: 'Confirmación de contraseña',
      pwd: 'Contraseña',
      confirm_error: 'Las contraseñas no coinciden',
      reset_password_label: 'Restablecer contraseña',
      send_mail: 'Enviar un correo electrónico',
      confirm_new_pwd: 'Confirmar la nueva contraseña',
      current_password_required: 'La contraseña actual es obligatoria',
      current_pwd: 'Contraseña actual',
      generic_error: 'Se ha producido un error, inténtelo de nuevo',
      info_pwd_label:
        'Su contraseña ha caducado. Debe introducir una nueva contraseña',
      new_pwd: 'Nueva contraseña',
      password_min_length: 'La contraseña debe contener al menos 8 caracteres',
      password_must_match: 'Las contraseñas no coinciden',
      password_updated_success: 'Su contraseña se ha actualizado correctamente',
      update: 'Cambiar la contraseña',
      update_pwd_label: 'Actualización de contraseña',
      updating: 'Actualizando...',
    },
    creation_date: 'Fecha de creación',
    execution_date: 'Fecha de ejecución',
    composant_document: {
      add_title: 'Creación de un nuevo documento',
      edit_title: 'Ficha documento',
      txt_errorfile: 'Todos los campos son obligatorios excepto la fecha final',
    },
    notification: {
      title: 'Notificaciones',
      empty: 'Notificaciones vacías',
      show_not_seen: 'Solo mostrar las no leídas',
      mark_as_read: 'Marcar como leído',
      clear_all: 'Borrar todo',
    },
    dashboard: {
      widget: {
        users: {
          title: 'Usuarios',
          header_title: 'Activos',
          left_title: 'Signatario solo',
          middle_title: 'Signatarios doble',
          right_title: 'Móviles',
          other_title: '',
        },
        jobs: {
          title: 'Trabajos',
          header_title: 'Hoy',
          left_title: 'ToDo',
          middle_title: 'Done',
          right_title: 'Failed',
          other_title: '',
        },
        deleted_batches: {
          title: 'Lista de lotes rechazados o eliminados',
          numlot: 'No. Lote',
          compte: 'Cuenta',
          montant: 'Importe',
          devise: 'Divisa',
          status: 'Estado',
          date: 'Fecha de rechazo',
          date_execution: 'Fecha de ejecución',
          user: 'Inicio de sesión',
        },
        treasury_reconciliation: {
          title: 'Conciliación de tesorería',
          header_title: 'Movimientos bancarios recibidos hoy',
          left_title: 'Movimientos sin conciliar',
          middle_title: 'Previsiones vencidas',
          right_title: 'Previsiones provisionales',
        },
        treasury_account_control: {
          title: 'Control cuentas de caja',
          header_title: 'Cuentas gestionadas en caja',
          left_title: 'Cuentas Ok',
          middle_title: 'Cuentas KO',
          right_title: 'Saldo en valor OK',
          other_title: 'Saldo en valor KO',
        },
        statistic_statements: {
          title: 'Extractos de cuenta',
          header_title: 'Cuentas gestionadas',
          left_title: 'Cuentas OK',
          middle_title: 'Cuentas KO',
          right_title: '',
          other_title: '',
          tabs: {
            releves_compte: 'Extractos de cuenta',
            comptes_erreur: 'Cuentas en error',
          },
          datagrid: {
            code: 'Código',
            solde: 'Saldo',
            devise: 'Divisa',
            date: 'Fecha de saldo',
            status: 'Estados',
            fault: 'Bloqueo',
            compte: 'Nombre de la Cuenta',
            banque: 'Banco',
          },
        },
        current_account: {
          treasury: {
            title: 'Cuentas corrientes de tesorería',
          },
          associate: {
            title: 'Cuentas corrientes de socios',
          },
          central: {
            title: 'Cuenta corriente centralizadora',
          },
          tabs: {
            graph: 'Gráfica',
            list: 'Lista',
            total: 'Total',
          },
          datagrid: {
            nom: 'Nombre',
            date: 'Fecha',
            montant: 'Importe',
            currency: 'Divisa',
          },
        },
        received_files: {
          header_title: 'Archivo recibido',
          datagrid: {
            flow: 'Flujo',
            bank: 'Banco',
            file_format: 'File Format',
            date: 'Fecha de recepción',
          },
        },
        maps_flows: {
          title: 'Reparto de los flujos',
          filters: {
            placeholder: 'Tipo de filtro',
            country: 'País',
            currency: 'Divisa',
          },
          currency: {
            placeholder: 'Selección de una divisa',
          },
        },
        statistics_flows: {
          title: 'Estadísticas de flujos',
        },
        comparative_flows: {
          title: 'Evolución de flujos',
        },
        currencyRate: {
          titleRate: 'Tasa',
          titleCurrency: 'Tasas de divisas',
          favori: 'Favoritos',
          all: 'Todas',
          column: {
            name: 'Nombre',
            date: 'Fecha',
            currency: 'Tasa',
          },
        },
        repository: {
          title: 'Repositorio',
          header_title: '',
          left_title: 'Empresas',
          middle_title: 'Cuentas',
          right_title: 'Terceros',
          other_title: '',
        },
        '4eyes': {
          title: 'Validación 4 Ojos',
          header_title: 'validaciones',
          left_title: 'terceros',
          middle_title: 'repositorio',
          right_title: 'usuarios',
          other_title: 'perfiles',
        },
        accounting_export: {
          title: 'Exportación Contable',
        },
        active_signatory: {
          title: 'Lista Signatarios Activos',
          name: 'Nombre',
        },
        active_users: {
          title: 'Lista Usuarios Activos',
        },
        events: {
          title: 'Registro de Eventos',
        },
        treasury_report: {
          title: 'Impresión Estado',
          print: 'Imprimir',
          etat: 'Posponer',
        },
        treasury_zoom_report: {
          title: 'Impresión Estado Zoom',
        },
        workflow: {
          title: 'Portafirmas de validación',
          header_title: 'Lotes',
          left_title: 'No asignado(s)',
          middle_title: 'Fraud Monitor',
          right_title: 'Portafirmas 1',
          other_title: 'Portafirmas 2',
        },
        management: {
          onglet: 'Tab',
          save: 'Guardar el tablero',
          modify: 'Desbloquear el tablero',
          list: 'Selección de widget',
          modal: {
            title: 'Lista de widgets',
            add: 'Añadir',
            delete: 'Eliminar',
          },
          tab_error: ' (Pestaña con error)',
        },
        error: {
          errorWidget: 'Error al carga',
          text: 'Ha ocurrido un error al cargar',
          delete: 'No puede eliminar una pestaña abierta',
        },
        groupPosition: {
          title: 'Análisis Grupos',
          column: {
            group: 'Grupo',
            forecast: 'Previsiones',
            balance: 'Saldos',
            liquid_investment: 'Inversiones liquidas',
            current_account: 'Cuentas Corrientes',
            proper_treasury: 'Tesorería propia',
            illiquid_investment: 'Inversiones no líquidas',
            internal_lending: 'Préstamo interco',
            external_lending: 'Préstamo Externo',
            net_treasury: 'Tesorería neta',
          },
        },
        accountStatements: {
          byCompany: {
            title: 'Extractos de cuenta por empresa',
            column: {
              societe: 'Empresa',
              montant: 'Importe',
              devise: 'Divisa',
              date: 'Fecha',
            },
          },
          byBank: {
            title: 'Extractos de cuenta por banco',
          },
          byCurrency: {
            title: 'Extractos de cuenta por divisa',
          },
        },
        treasury_object: {
          '30_days': '30D',
          '60_days': '60D',
          '90_days': '90D',
          label: 'Dentro de :',
          investments: 'Vencimientos inversiones',
          debts: 'Vencimientos deudas',
          column: {
            name: 'Referencia',
            due_date: 'Fecha de vencimiento',
            amount: 'Importe',
            currency: 'Moneda',
          },
        },
        certificate: {
          title: 'Vencimiento de los certificados',
          column: {
            user_id: 'UserID',
            connector: 'Conector',
            signature_date: 'Fecha de vencimiento autofirmada',
            signature_date_3skey: 'Fecha de vencimiento de la firma',
          },
        },
        signatory_book: {
          title: 'Mi Libro de Firmantes',
          header_title: 'Lotes',
          all_signed: 'No hay lotes para firmar',
        },
        rules_statements_alert: {
          title: 'Alerta sobre extractos de cuenta',
          columns: {
            code_compte: 'Código cuenta',
            montant: 'Importe',
            devise: 'Divisa',
            category: 'Categoría',
            label: 'Texto',
            op_date: 'Fecha Op.',
            rule_code: 'Código regla',
            update_timestamp: 'Fecha de modificación',
          },
        },
        balance: {
          balance_value_on_date: 'Saldo en valor al {{date}}',
          solde: 'Saldo',
          solde_operation: 'Saldos y Previsiones',
          prevision: 'Previsiones',
          affiche: 'Mostrar',
        },
        treasury_transaction_balance: {
          title: 'Tesorería - Saldo por operación',
          affiche: 'Mostrar',
          devise: 'Divisa',
          label: 'Descripción',
        },
      },
    },
    component_document: {
      titleImportfile: 'Documento pdf',
      importfile: 'Importando archivo...',
      btnNameEdit: 'Ficha Documento',
      btnNameAdd: 'Documento',
      docName: 'Nombre documento',
      docType: 'Tipo de documento',
      docEtat: ' Estado',
      dateEnd: 'Fecha final',
      dateStart: 'Fecha inicial',
      erroValidationChamp:
        'Todos los campos son obligatorios excepto la fecha final',
      errorFormatfile: 'Importe un archivo en formato pdf',
      titleError: 'Error',
      placeholderDocName: '- Si vacío nombre cargado automáticamente',
      nbFileAccepted: 'Un archivo PDF aceptado',
      other_file_type: 'Por favor, inserte un archivo de tipo PDF',
    },
    idleModal: {
      title: 'Su sesión está a punto de expirar',
      expiration:
        'Su sesión está a punto de expirar. Su sesión cerrará automáticamente.',
      question: '¿Desea extender su sesión?',
      remaining: 'Le queda {{remainingTime}} segundos para extender su sesión',
      button: 'Extender sesión',
    },
    datagrid: {
      pageText: 'Página',
      ofText: ' sobre ',
      perPageText: 'Resultados por página',
      showingText: 'Mostrar ',
      clearAll: 'Borrar todos los filtros',
      clear: 'Borrar el filtro',
      showFilteringRow: 'Mostrar los filtros',
      hideFilteringRow: 'No mostrar los filtros',
      enable: 'Activado',
      disable: 'Desactivado',
      sortAsc: 'Orden ascendiente',
      sortDesc: 'Orden descendiente',
      unsort: 'Sin orden',
      group: 'Combinar',
      ungroup: 'Separar',
      lockStart: 'Inmovilizar al principio',
      lockEnd: 'Inmovilizar al final',
      unlock: 'No inmovilizar',
      columns: 'Columnas',
      autoresizeThisColumn: 'Cambiar el tamaño de esta columna',
      autoresizeAllColumns: 'Cambiar el tamaéno de todas las columnas',
      autoSizeToFit: 'Autoajuste',
      contains: 'Contiene',
      startsWith: 'Empieza por',
      endsWith: 'Termina por',
      notContains: 'No contiene',
      inlist: 'Está en la lista',
      notinlist: 'No está en la lista',
      neq: 'No coincide con',
      inrange: 'En el rango',
      notinrange: 'No está en el rango',
      eq: 'Coincide con',
      notEmpty: 'No vacío',
      empty: 'Está vacío',
      lt: 'Mas pequeño que',
      lte: 'Más pequeño o igual que',
      gt: 'Más grande que',
      gte: 'Más grande o igual que',
      before: 'Mas pequeño que',
      beforeOrOn: 'Más pequeño o igual que',
      afterOrOn: 'Más grande o igual que',
      after: 'Más grande que',
      start: 'De',
      end: 'A',
      dragHeaderToGroup: 'Arrastrar aquí para unir',
      noRecords: 'string',
      calendartodayButtonText: 'Hoy',
      calendarclearButtonText: 'Borrar',
      calendarokButtonText: 'Validar',
      calendarcancelButtonText: 'Cancelar',
    },
    cash: {
      flux: {
        audit: 'Auditoría',
        attribution: 'Asignación',
        signer: 'Firmar',
        comment: {
          title: 'Comentario del lote {{batchId}}',
          columns: {
            date: 'Fecha',
            comment: 'Comentario',
            type: 'Tipo',
            login: 'Login',
          },
          add: 'Añadir un comentario',
        },
        validate: 'Validar el control',
        relaunch: 'Ejecutar de nuevo el fraud monitor',
        print: 'Imprimir',
        slip: 'Registro',
        edit: '¿Seguro que desea editar las operaciones de este lote y cambiarlo al modo entrada',
        remettre: 'Cambiar a modo Entrada',
        visualiserPDF: 'Justificante',
        unauthorize_view:
          'La visualización del detalle no está autorizada para este tipo de flujo',
        detail: {
          title: {
            remittance: 'Detalle de la remesa {{remittance_number}}',
            operation: 'Operación',
            facture: 'Detalle de las facturas {{remittance_number}}',
          },
          columns: {
            beneficiary_name: 'Beneficiario',
            reference_label: 'Referencia/Texto',
            print: 'Visualizar',
            number: 'No.',
            amount: 'Importe',
            currency: 'Divisa',
            ara: 'ARA',
            reject: 'Rechazo',
            rules: 'Reglas',
            fraud_monitor: 'Fraud monitor',
            choice: 'Elección',
            delete: 'Eliminación',
            vsr: 'Estado VSR',
          },
          buttons: {
            tracking: 'Tracker',
            print: 'Imprimir Notificación',
            back: 'Volver',
            validate: 'Confirmar el control',
            validateChoice: 'validar elección',
            refuse: 'Rechazar el lote',
            invoice: 'Facturas',
          },
          champ_titles: {
            state: 'Estado',
            flow: 'Flujo',
            creation_date: 'Fecha de creación',
            execution_date: 'Fecha de ejecución',
            emitter: 'Emisor',
            operation_number: 'No.',
            amount: 'Importe remesa',
            status: 'Estado',
            reason: 'Motivo',
            origin_amount: 'Importe Origen',
            fee: 'Gastos',
            fee_type: 'Tipo de gastos',
            tracker_number: 'No. tracker',
            confirmation_date: 'Fecha confirmada',
            amount_credited: 'Importe Acreditado',
            label: 'Etiqueta',
            send: 'Enviado el',
            societe: 'Empresa',
            compte: 'Cuenta',
            ibanBban: 'IBAN/BBAN',
            lot_number: 'No. Lote',
            origine: 'Origen',
            author: 'Login',
          },
          tracking_status: {
            ACSC: 'Confirmación de débito, prueba de la iniciación del pago.',
            G001: 'Pago en curso. Pago transferido a un agente no gpi o a un MI (sistema de intercambio interbancario local) no compatible.',
            G005: 'Pago en curso. Entregado al banco beneficiario como gpi.',
            G006: 'Pago en curso. Entregado al banco beneficiario como no gpi.',
            Gxxx: 'Pago en curso.',
            ACCC: 'El acreedor ha sido acreditado.',
            RJCT: 'Rechazado',
            PDNG: 'En curso',
          },
          process: {
            treated: 'Tratado',
            waiting: 'Esperando',
            credited: 'Acreditado',
          },
          copy: 'Copiar enlace.',
          copied: '¡Copiado!',
          invoice: {
            champ_titles: {
              IBAN: 'IBAN',
              reference: 'Referencia',
              label: 'Etiqueta',
              montant: 'Monto',
              devise: 'Divisa',
              tiers: 'Tercero',
              ibanBban: 'IBAN/BBAN',
            },
            columns: {
              client_reference: 'Referencia Cliente',
              supplier_reference: 'Referencia Proveedor',
              invoice_number: 'N° Factura',
              date_fact: 'fecha de factura',
            },
          },
          coller: '¡Pegar!',
        },
        EditRemise: 'Modificación de la fecha de ejecución de la remesa {{id}}',
        operation: 'Editar las operaciones',
        FraudMonitor: {
          table: {
            title: 'Lista de lotes en control',
            buttons: {
              audit: 'Auditoría',
              validate: 'Validar el control',
              print: 'Imprimir',
            },
            columns: {
              batche_number: 'No. lote',
              remittance_number: 'No. remesa',
              flow: 'Flujo',
              state: 'Estado',
              transmitter: 'Cuenta',
              login: 'Login',
              date: 'Fecha',
              operation_number: 'No.',
              amount: 'Importe',
              currency: 'Divisa',
              origin: 'Origen',
              status: 'Estado',
            },
            modal: {
              title: {
                audit: 'Auditoría del lote No. {{batche_number}}',
              },
              columns: {
                date: 'Fecha',
                login: 'Login',
                action: 'Acción',
              },
              buttons: {
                buttons: 'Cerrar',
              },
            },
          },
          fiche: {},
        },
        Cheque: {
          table: {
            title: 'Lista de lotes de cheques a imprimir',
            columns: {
              batche_number: 'No. lote',
              remittance_number: 'No. remesa',
              flow: 'Flujo',
              state: 'Estado',
              transmitter: 'Cuenta',
              login: 'Login',
              date: 'Fecha',
              operation_number: 'No.',
              amount: 'Importe',
              currency: 'Divisa',
              origin: 'Origen',
              status: 'Estado',
              check_print: 'Imprimir cheques',
            },
            apercu: {
              title: 'Vista previa de los cheques a imprimir',
              button: 'Validar impresión',
            },
            range: {
              title: 'Rango de números de cheques',
              next: 'Próximo número',
              last: 'Último número',
              first_op: 'N° primera operación',
              last_op: 'N° última operación',
              account_divider: 'Configuración de la cuenta',
              update: 'Modificar el intervalo de cheques',
              error:
                'El intervalo introducido es superior al autorizado.\nAumente el rango de su cuenta.',
              button: 'Rango',
            },
            modal: {
              title: {
                audit: 'Auditoría del lote No. {{batche_number}}',
              },
              columns: {
                date: 'Fecha',
                login: 'Login',
                action: 'Acción',
              },
              buttons: {
                buttons: 'Cerrar',
              },
            },
            message:
              '¿Ha impreso el(los) cheque(s)? Después de la validación no podrá imprimir el(los) cheque(s).',
          },
          fiche: {},
        },
        Integration: {
          table: {
            title: 'Importación manual de archivos',
            addfile: 'Añadir',
            labelmodel: 'Plantilla de importación',
            choosefile: 'Selección de archivos',
            import_placeholder: 'Ninguna',
            smartag: 'SmartTags',
          },
        },
        GestionLots: {
          header: {
            title: 'Lista de lotes',
          },
          columns: {
            flow: 'Flujo',
            state: 'Estado',
            account: 'Cuenta',
            login: 'Login',
            date: 'Fecha',
            count: 'No. operaciones',
            montant: 'Importe',
            devise: 'Divisa',
            origin: 'Origen',
            status: 'Estado',
            pdf_files: 'PDF',
            comment: 'Com.',
            signing: 'Firma',
            lot_number: 'No. lote',
            remittance_number: 'No. remesa',
            amount_max: 'Max',
            amount_min: 'Min',
            source_file_name: 'Nombre del archivo',
            smarttag: 'SmartTags',
            date_transmission: 'Fecha de transmisión',
          },
          modal: {
            title: 'Detalle de la remesa {{remittance_num}}',
            audit: 'Auditoría del lote No. {{batche_number}}',
            titleDelete:
              'Comentario para la eliminación del lote No. {{batche_number}}',
            buttonDelete: 'Eliminar',
          },
          attributionModal: {
            message_infos_type_pdf: 'Solo se permiten archivos PDF',
            title:
              'Asignación de los signatarios del lote No. {num_attribution}}',
            state_signature: 'Estado firma',
            flux: 'Flujo',
            created_date: 'Fecha de creación',
            operationNumber: 'No. operaciones',
            amount: 'Importe',
            currency: 'Divisa',
            name: 'Nombre',
            one_signature: 'Firma 1',
            college: 'Colegio',
            niveau: 'Niveles',
            two_signature: 'Firma 2',
            justificated_piece: 'Justificante',
            attributed: 'Asignar',
            alert_file: 'Sólo puede seleccionar hasta 3 archivos.',
            columns: {
              level: 'Nivel',
              signataire1: 'Signatario 1',
              signataire2: 'Signatario 2',
              signataire: 'Signatario {{nb}}',
              college1: 'Colegio 1',
              college2: 'Colegio 2',
            },
            title_document_validation: 'Asignación de firmantes',
          },
        },
        HistoriqueLots: {
          actions: {
            writing_generate: 'Generación de los asientos contables',
            message: '¿Desea reenviar el lote al banco?',
          },
          header: {
            title: 'Historial de lotes',
            advance_search_button: 'Búsqueda avanzada',
            launch_search: 'Iniciar búsqueda',
            recherche_suppl: '- Búsqueda específica -',
            advanced_title: 'Búsqueda avanzada para operaciones',
            search: 'Buscar lotes por tercero, motivo, referencia...',
            transmission_date: 'Fecha Envío',
            exec_date: 'Fecha Ejecución',
            recherche_signature: '- Firmantes -',
          },
          columns: {
            pdf_files: 'PDF',
            lot_number: 'No. lote',
            remise_number: 'No. remesa',
            flow: 'Flujo',
            state: 'Estado',
            emetteur: 'Cuenta',
            login: 'Login',
            date: 'Fecha',
            operation_number: 'No.',
            montant: 'Importe',
            devise: 'Divisa',
            origine: 'Origen',
            status: 'Estado',
            ack: 'ACK',
            delivrance: 'Emisión',
            psr: 'Protocolo PSR',
            ara1: 'ARA 1',
            transaction_ref: 'Referencia por transacción',
            account_number: 'No. cuenta',
            third_party: 'Terceros',
            montant_lot: 'Importe lote',
            code_countrie: 'Código país',
            ara_operation: 'ARA Operación',
            valid_1: 'Validador 1',
            valid_2: 'Validador 2',
            sign_1: 'Firmante 1',
            sign_2: 'Firmante 2',
            reject_reason: 'Motivo de rechazo',
            road_name: 'Nombre de calle',
            road_number: 'Número de calle',
            city: 'Ciudad',
            postal_code: 'Código postal',
            town: 'Ciudad',
            bp: 'Apartado postal',
            district: 'Distrito',
            region: 'Región',
            reference: 'Referencia',
            reason: 'Descripción',
          },
        },
        Signature: {
          header: {
            title: 'Mi portafirmas electrónico',
          },
          table: {
            sign: 'Firmar',
            reject: 'Rechazar',
          },
          modal: {
            commentTitle: 'Comentario para el rechazo del lote {{name}}',
            refusTitle: 'Rechazar',
            titleOTP: 'Firma OTP',
            titleEbics: 'Firma Ebics TS',
            sendOTP: 'Firmar el lote',
            sendEbics: 'Firmar electrónicamente',
            cancel: 'Cancelar',
            champOTP:
              'Introduzca el código recibido por SMS o el código de un solo uso',
            champEbics: 'Introducir la contraseña de la llave',
            validate: 'Validar la firma',
            decline: 'Rechazar',
            comment: 'Comentario',
            message_confirm_signin: '¿Te gustaría firmar este lote',
            lot_selec: 'Número de lotes  :',
            total: 'Suma aritmética :',
            mobile_action:
              '¿Ha validado la firma en su aplicación móvil Swift "Digital ID" ?',
            verif_code:
              'Confirme el siguiente código de verificación en su aplicación móvil:',
            progression:
              'Progreso de la firma del lote: {{signedNb}}/{{totalNb}}',
          },
          fiche: {},
        },
        Saisie: {
          fiche: {
            title: {
              new_title: 'Nuevo lote de {{code}}',
              edit_title: 'Modificación del lote no. {{id}} de {{code}}',
              operation: 'Lista de operaciones',
              timeline: 'Selección fecha Vencimiento',
            },
            champ_titles: {
              account: 'Cuenta emisora',
              currency: 'Divisa de las operaciones',
              execution_date: 'Fecha de ejecución',
            },
            buttons: {
              save: 'Crear el lote',
              back: 'Cancelar',
              send_to_validate: 'Enviar para validación',
              timeline: 'Calendario de vencimientos',
              by_list: 'Introducción de datos mediante lista',
            },
            columns: {
              thirdparty: 'Terceros',
              account: 'No. cuenta',
              amount: 'Importe',
              currency: 'Divisa',
              reference: 'Referencia',
            },
            modal: {
              title: 'Introducción de datos mediante lista',
              columns: {
                code: 'Código',
                name: 'Nombre',
                account: 'No. cuenta',
                amount: 'Importe',
                currency: 'Divisa',
                note: 'Nota',
              },
              champ_titles: {
                reference: 'Referencia común',
                reason: 'Motivo común',
              },
            },
          },
          table: {
            title: 'Lista de lotes siendo registrados',
            columns: {
              batch_number: 'No. lote',
              flow: 'Flujo',
              account: 'Cuenta',
              operation_number: 'No.',
              amount: 'Importe',
              currency: 'Divisa',
              execution_date: 'Fecha ejecución',
              creation_date: 'Fecha de creación',
              update_date: 'Fecha de modificación',
            },
            buttons: {
              new: 'Nuevo Lote',
              delete: '¿Confirma la eliminación',
            },
          },
          timeline: {
            title: {
              general: 'Lista de los calendarios de vencimientos',
              operations_list: 'Lista de operaciones',
            },
            columns: {
              rum: 'RUM',
              debtor_code: 'Código deudor',
              debtor_name: 'Nombre del deudor',
              next_due_date: 'Próximo vencimiento',
              type: 'Tipo',
              sequence: 'Secuencia',
              reason: 'Motivo',
              reference: 'Referencia',
              amount: 'Importe',
            },
            champ_titles: {
              date: 'Fecha de pago',
              sample_number: 'Número de la domiciliacón de la cartera',
              amount: 'Suma de la cartera',
              reason: 'Motivo',
              reference: 'Referencia',
            },
            buttons: {
              addTo: 'añadir al lote',
              validate: 'Validar',
            },
          },
          operation: {
            title: {
              new_title: 'Añadir una operación',
              edit_title: 'Operación {{name}}',
              address_thirdparty: 'Dirección del tercero',
              informations: 'Información adicional',
              bank: 'Datos bancarios',
              intermediary_bank: 'Banco intermediario',
              fournisseur_bank: 'Dirección proveedor',
              fournisseur_structure_bank: 'Dirección estructurada proveedor',
            },
            champ_titles: {
              reference: 'Referencia',
              amount: 'Importe',
              name: 'Nombre',
              reason: 'Motivo',
              country: 'País',
              account_number: 'No. de cuenta',
              bank_name: 'Denominación',
              bic: 'BIC',
              address: 'Dirección',
              clearing: 'Clearing',
              clearing_id: 'Identificador Clearing',
              type: 'Tipo',
            },
            buttons: {
              save: 'Validar',
              back: 'Cancelar',
              search: 'Buscar',
              import_amount: 'Cantidades de carga',
              excel_export: 'exportación Excel',
            },
            placeholder: {
              search: 'Buscar un tercero por código, nombre, IBAN...',
            },
            modal: {
              title: 'Selección de terceros',
              buttons: {
                add: 'Validar',
                close: 'Cancelar',
              },
              columns: {
                group: 'Grupo',
                type: 'Tipo',
                code: 'Código',
                name: 'Nombre',
                account: 'No. cuenta',
                thirdparty: 'Terceros',
                rum: 'RUM',
                reference: 'Referencia',
                analysis_note: 'Nota Análisis Terceros',
                bic: 'BIC',
                code_pays: 'Código de País',
                code_pays_tiers: 'Código de País Tercero',
              },
            },
          },
        },
        Analyse: {
          search: {
            state: '- Estado -',
            scope: '- Ámbito - ',
            company: '- Empresa -',
            bank: '- Banco -',
            pays: '- País -',
            devise: '- Divisa -',
            flux: '- Flujo - ',
            category: '- Categoría - ',
          },
          graph: {
            societe: 'Distribución de los flujos por empresa',
            banque: 'Distribución de los flujos por banco',
            type: 'Distribución de los flujos por tipo',
          },
          table: {
            title: 'Análisis de Flujos',
          },
          onglet: {
            graphe: 'Gráfico de flujo',
            analyse: 'Análisis de flujo',
          },
        },
        send: 'Enviar',
        ModalSendMessage: {
          title: 'Enviar correo',
          template_email: 'Plantilla de correo',
          email: 'correo electrónico',
        },
        EditRemiseMultiple:
          'Modificación de la fecha de ejecución de los pagos',
        Intégration: {
          fiche: {},
          table: {},
        },
      },
      statement: {
        RelevesCompte: {
          header: {
            title: 'Lista de cuentas bancarias',
            buttons: {
              export: 'Exportar',
              import: 'Importar',
              releve_inco: 'Extracto desconocido',
            },
          },
          filters: {
            state: '-Estado-',
            scope: '-Alcance-',
            companies: '-Empresa-',
            bank: '-Banco-',
            country: '-País-',
            devise: '-Divisa-',
            format: '-Formato-',
            services:
              '<Selección del servicio para la integración mediante trabajo>',
          },
          searchInput: {
            caption:
              'Buscar una cuenta por código, nombre, número de cuenta, código de empresa, nombre de empresa...',
          },
          modal: {
            titles: {
              import: 'Importación manual de un extracto',
              export: 'Exportación de extractos de cuenta',
            },
            buttons: {
              export: 'Exportar',
              drag_file: 'Añadir o colocar archivos aquí',
              drag_one_file: 'Añadir o colocar un archivo aquí',
              send: 'Enviar',
            },
            champ_titles: {
              job: 'Integración mediante Trabajo',
            },
          },
          columns: {
            state: 'Estado',
            code: 'Código',
            name: 'Nombre',
            iban: 'IBAN',
            company: 'Empresa',
            bank: 'Banco',
            solde: 'Saldo',
            devise: 'Divisa',
            date: 'Fecha de saldo',
            operation_number: 'No. movimientos',
            intraday_number: 'No. intradías',
            alternative_account: 'Cuenta alternativa',
            solde_consolide: 'Saldo en moneda de consolidación',
            devise_consolide: 'Moneda de consolidación',
            pays_compte: 'País del banco',
            pays_soc: 'País de la empresa',
            domiciliation: 'Denominación',
          },
          search_advanced_releve: {
            category_search: 'Categoría',
            label_search: 'Buscar una etiqueta',
          },
          tab: {
            graphTitle: 'Gráfico de Estados de Cuenta',
            releverTitle: 'Análisis de Estados de Cuenta',
          },
        },
        DetailRelevesCompte: {
          header: {
            title: 'Visualización del extracto de cuenta {{code}} - {{iban}}',
            print: 'Imprimir',
            relever_electro: 'Extractos electrónicos',
            generation: 'Generación Asientos',
            calendar: 'Último día laborable',
            search: 'Buscar...',
          },
          filters: {
            state: '-Estado-',
            scope: '-Alcance-',
            companies: '-Empresa-',
            bank: '-Banco-',
            country: '-País-',
            devise: '-Divisa-',
          },
          searchInput: {
            caption:
              'Buscar una cuenta por código, nombre, número de cuenta, código de sociedad, número de sociedad...',
          },
          columns: {
            label: 'Texto',
            complementary_label: 'Texto adicional',
            reference: 'Referencia',
            tiers: 'Terceros',
            document_number: 'No. Documento',
            category: 'Categoría',
            transaction_code: 'Código',
            devise: 'Divisa',
            operation_date: 'Fecha de operación',
            value_date: 'Fecha de valor',
            debit: 'Cargo',
            credit: 'Abono ',
            currency: 'Divisa',
            payer_name: 'Nombre del pagador',
            beneficiary_name: 'Nombre del beneficiario',
            exempted: 'Exento',
          },
          columns_electro_relever: {
            title: 'Lista de extractos de cuenta electrónicos',
            num_doc: 'No. documento',
            date: 'Fecha inicial',
            date_fin: 'Fecha final',
            date_add: 'Fecha de añadidura ',
          },
          modal: {
            title: 'Detalle de la operación',
          },
        },
        FraisBancaire: {
          table: {
            title: 'Gastos bancarios',
            bankList_placeholder: '- Banco -',
            search: 'Buscar',
            society_List_placeholder: '- Empresa -',
            group_compte_list: '- Grupo de cuentas -',
          },
          columns: {
            frais: 'Texto',
            nb_op: 'No. operaciones',
            verif: 'Tarificación ',
            balance: 'Base/Suma ',
            currency: 'Divisa',
            amount: 'Gastos',
            total: 'Total',
          },
          columns_detail_assiette: {
            code_compte: 'Código de cuenta',
            date_opération: 'Fecha de operación',
            label_complet: 'Etiqueta completa',
            code_category: 'Código de categoría',
            code_opération: 'Código de operación',
            code_nature_present: 'Código de naturaleza',
            montant: 'Monto',
            devise: 'Divisa',
            date_operation: 'Fecha operación',
          },
        },
        retourFichier: {
          title: 'Detalles del archivo devuelto',
          table: {
            title: 'Lista de archivos devueltos',
            column: {
              nId: 'Número de identificación',
              flux: 'Flujo / Código de cuenta',
              nomFIle: 'Nombre del fichero / IBAN',
              banque: 'Banco / Nº de operaciones',
              fileFormat: 'Formato de fichero / Importe',
              receptions: 'Recibo / Remesa',
            },
          },
          fiche: {
            flux: 'Flujo',
            emmetteur: 'Remitente',
            reference: 'Referencias',
            data_r: 'Fecha de recepción',
            date_remise: 'Fecha Remise',
            nb: 'Nb',
            montantRemise: 'Importe de entrega',
            table: {
              num: 'N°',
              tier: 'Terceros',
              ultimateT: 'Ultimate Terceros',
              code: 'Códigos',
              ref: 'Referencia/Etiqueta',
              montant: 'Importe',
              devise: 'Moneda',
            },
          },
        },
        analyse: {
          title: 'Saldos bancarios',
          entity: 'Empresa',
          benefBank: 'Banco',
          location: 'País',
          currency: 'Divisa',
          consolidation: 'Consolidación',
        },
        agios: {
          column: {
            state: 'Estado',
            code: 'Código',
            name: 'Nombre',
            banque: 'Banco',
            company: 'Empresa',
            iban: 'IBAN',
            devise: 'Divisa',
            taux_debit: 'Tasa débito',
            taux_credit: 'Tasa crédito',
          },
          drawer: {
            titleDrawer: 'Resultado del cálculo de los agios',
            titleCalcul: 'Cálculo de Agios',
            compte: 'Cuentas',
            periode: 'Período',
            titleResult: 'Resultado',
            assiete: 'Base Deudor',
            int: 'Intereses Deudor',
            assiCredit: 'Base Acreedor',
            intCredit: 'Intereses Acreedor',
            titleDetail: 'Detalle Cálculo',
            accountNbr: 'Número de cuentas:',
            imp: 'Imprimir',
            column: {
              date: 'Fecha',
              nbJ: 'Días',
              position: 'Posición',
              tauxDeb: 'Tasa de interés deudor',
              int_deb: 'Intereses deudores',
              tauxCred: 'Tasa de interés acreedor',
              intCredit: 'Intereses acreedores',
            },
          },
          calcul: 'Iniciar el cálculo',
          title: 'Cálculo de Agios',
        },
        mobileBank: {
          title: 'Lista de movilidades bancarias',
          titleVisu: 'Lista de operaciones',
          action: {
            misAJourTiers: 'Actualizar Terceros',
            exported: 'Exportar',
            stateTraiter: "Cambiar a estado 'Tratado'",
            stateNonTraiter: "Cambiar a estado 'No Tratado'",
          },
          column: {
            state: 'Estado',
            majTiers: 'Actualizar Terceros',
            export: 'Exportar',
            userTraitement: 'Usuario tratamiento',
            date: 'Fecha',
            dateMandat: 'Fecha mandato',
            nameOrigin: 'Nombre origen',
            ibanOrigine: 'IBAN origen',
            nouvNom: 'Nuevo Nombre',
            nouvIban: 'Nuevo IBAN',
            bicOrigin: 'BIC origen',
            nouvBic: 'Nuevo BIC',
            visualisation: 'Visualización',
            timestamp_creation: 'Fecha creación',
          },
          columnVisu: {
            type: 'Tipo',
            end_to_end_id: 'EndToEndId',
            reason: 'Motivo',
            ics: 'I.C.S',
            rum: 'RUM',
          },
          modal_confirm: {
            maj_tiers: '¿Desea actualizar los Terceros?',
            export: '¿Desea exportar las movilidades?',
            traite: "¿Desea cambiar las movilidades a estado 'Tratado'?",
            no_traite: "¿Desea cambiar las movilidades a estado 'No Tratado'?",
          },
        },
        anaysePlacement: {
          titleFinanciers: 'Inversiones por institución financiera',
          titleTYpe: 'Distribución por tipo',
          societe: 'Inversiones por empresa',
          addPlacement: 'Añadir estados de cuenta',
          title: 'Análisis de inversiones',
        },
        alert_account: {
          table: {
            header: {
              title: 'Lista de alertas de extractos de cuenta',
              load_search: 'Iniciar búsqueda',
            },
            columns: {
              state: 'Estado',
              account: 'Cuenta',
              label: 'Texto',
              reference: 'Referencia',
              nature: 'Naturaleza',
              category: 'Categoría',
              op_date: 'Fecha op.',
              value_date: 'Fecha Valor',
              amount: 'Importe',
              currency: 'Divisa',
              type: 'Tipo',
              entry_number: 'No. Asiento',
              nature_code: 'Código Naturaleza',
              integration_date: 'Fecha de integración',
              ics: 'ICS',
              rum: 'RUM',
              transaction_code: 'Código operación',
              rule_code: 'Código Regla',
              company: 'Empresa',
              exempted: 'Exento',
              debit: 'Débito',
              credit: 'Crédito',
            },
          },
        },
        unknowAccount: {
          header: {
            title: 'Lista de Extractos desconocidos',
          },
          columns: {
            state: 'Estado',
            unknow_account: 'Cuenta desconocida',
            solde: 'Saldo',
            devise: 'Divisa',
            date_solde: 'Fecha de saldo',
            nb_mvt: 'Nº movimientos',
          },
          label: {
            delete: 'Eliminar los movimientos temporales',
            black_liste: 'Ignorar el extracto de esta cuenta',
            search: 'Buscar cuentas bancarias',
            unknow: 'Quitar de la lista negra',
            delete_account: '¿Desea eliminar los movimientos temporales?',
            search_id: '¿Desea buscar las cuentas bancarias?',
            add_blackList: '¿Desea ignorar el extracto de esta cuenta?',
            add_unknow: '¿Desea quitar de la lista negra?',
          },
        },
      },
      referentiel: {
        Comptes: {
          fiche: {
            titles: {
              edit_title: 'Ficha de la cuenta {{code}} - {{iban}}',
              new_title: 'Creación de una nueva cuenta',
              view_title: 'Ficha de la cuenta',
              bank_infos: 'Datos bancarios',
              settings: 'Ajustes',
              plus_infos: 'Información adicional',
              accounting_zone: 'Zonas contables',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
              history: 'Historial',
              close: 'Cerrar',
            },
            tabs: {
              flow: 'Flujo',
              check: 'Cheque',
              account: 'Contab. ',
              contacts_agence: 'Contactos agencia',
            },
            champ_titles: {
              company: 'Empresa',
              code: 'Código',
              state: 'Estado',
              name: 'Nombre',
              country: 'País',
              account_num: 'No. de cuenta',
              bic: 'BIC',
              bank: 'Banco',
              devise: 'Divisa',
              domiciliation: 'Denominación',
              emetteur: 'Autorizar cuenta emisora',
              tiers: 'Autorizar cuenta de terceros',
              custom: {
                custom_1: 'Custom1',
                custom_2: 'Custom2',
                custom_3: 'Custom3',
                custom_4: 'Custom4',
                custom_5: 'Custom5',
              },
              balance_continuity_check: 'Continuidad fecha de saldo',
              alternative_account: 'No. de cuenta alternativa',
              sender_code: 'No. emisor',
              sender_code_vcom: 'No. emisor VCOM',
              fileformat: 'FileFormat extracto de cuenta',
              number_next: 'Próximo No. cheque',
              number_end: 'Último No. cheque ',
              cmc7_1: 'Línea CMC7 1',
              cmc7_2: 'Línea CMC7 2',
              account_info: 'Información cuenta',
              accounting: 'Cuenta contable',
              journal: 'Código ',
              auxiliary: 'Subcuenta',
              customize1: 'Custom1',
              customize2: 'Custom2',
              customize3: 'Custom3',
              customize4: 'Custom4',
              customize5: 'Custom5',
              customize6: 'Personalizado6',
              customize7: 'Personalizado7',
              customize8: 'Personalizado8',
              customize9: 'Personalizado9',
              customize10: 'Personalizado10',
              default_placeholder: '<Contacto agencia principal por defecto>',
              contact_agence: 'Contacto Agencia',
              contactFlux: 'Contacto Flujo',
              contactPouvoir: 'Contacto Poder',
              zone_payable: 'Zona "A pagar" del cheque',
              autorise_operation: 'Operación de cambio autorizada',
            },
          },
          table: {
            header: {
              title: 'Lista de cuentas',
              new_account: 'Nuevo',
            },
            filters: {
              state: '-Estado-',
            },
            searchInput: {
              caption: 'Buscar una cuenta por código, nombre o empresa',
            },
            buttons: {
              rib_print: 'Imprimir documento de identificación bancaria',
            },
            columns: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              bank: 'Banco',
              iban: 'IBAN',
              company: 'Empresa',
              devise: 'Divisa',
              date: 'Fecha de modificación',
              pays: 'País Banco',
            },
          },
        },
        Echéancier: {
          fiche: {
            title: {
              edit_title: 'Ficha del formato {{code}}',
              view_title: 'Ficha de un calendario de vencimientos',
              new_title: 'Creación de un nuevo vencimiento',
              date_manage: 'Gestión Fecha',
              mandate: 'Mandato',
              flow_custom: 'Campo de flujo ',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
            },
            champ_titles: {
              mandate: 'Mandato',
              flow: 'Flujo',
              value_date: 'Fecha de valor',
            },
          },
          table: {
            header: {
              title: 'Lista de calendarios de vencimientos',
              new_timeline: 'Nuevo',
            },
            columns: {
              state: 'Estado',
              company_rum: 'Empresa/RUM',
              code_tiers: 'Tercero deudor',
              nom_tiers: 'Nombre tercero deudor',
              amount: 'Importe',
              reason: 'Motivo',
              expiry_date: 'Fecha 1er vencimiento',
              next_expiry_date: 'Fecha próximo vencimiento',
              last_expiry_date: 'Fecha último vencimiento',
              periodicity: 'Periodicidad',
              flow: 'Flujo',
            },
          },
        },
        GroupesTiers: {
          fiche: {
            title: {
              edit_title: 'Ficha del grupo',
              view_title: 'Ficha del grupo {{code}}',
              new_title: 'Creación de un nuevo grupo',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
            },
            champ_titles: {
              name: 'Nombre',
              code: 'Código',
            },
          },
          table: {
            header: {
              title: 'Lista de grupos de terceros',
              new_thirdpartygroup: 'Nuevo',
            },
            columns: {
              code: 'Código',
              name: 'Nombre',
              date: 'Fecha de modificación',
            },
          },
        },
        Mandats: {
          fiche: {
            title: {
              edit_title: 'Ficha del mandato {{variable}}',
              view_title: 'Ficha del mandato {{variable}}',
              new_title: 'Creación de un nuevo mandato',
              contact: 'Contacto',
              amendments: 'Modificaciones',
              doc: 'Documentos',
              history: 'Historial',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              new: 'Nuevo',
              create: 'Crear',
            },
            modal: {
              title: {
                doc: 'Documento',
              },
              buttons: {
                join: 'Adjuntar',
                cancel: 'Cancelar',
              },
              champ_titles: {
                doc_type: 'Tipo de documento',
                doc_name: 'Nombre documento',
                state: 'Estado',
                start_date: 'Fecha inicial',
                end_date: 'Fecha final',
                pdf_doc: 'Documento PDF',
                type: 'Tipo',
              },
              pdf_file_message:
                'Por favor seleccione un justificante en formato pdf',
              doc_type: 'Debe ',
              doc_name: 'Debe especificar el nombre del documento',
            },
            columns: {
              status: 'Estado',
              state: 'Estado',
              withdrawal_date: 'Fecha domiciliación',
              unpaid_date: 'Fecha impagos',
              reason: 'Motivo',
              representation: 'Representación',
              amount: 'Importe',
              reference: 'Referencia',
              start_date: 'Fecha Inicio',
              end_date: 'Fecha Fin',
              date: 'Fecha',
              doc_name: 'Nombre Documento',
              doc_type: 'Tipo Documento',
              visualisation: 'Visualización',
            },
            champ_titles: {
              company: 'Empresa',
              internal_code: 'Código interno',
              descrip: 'Descripción del contrato',
              interne: 'Referencia interna',
              state: 'Estado',
              rum: 'Referencia Única del Mandato (RUM)',
              payment: 'Pago',
              NumContrat: 'No. contrato',
              email: 'Dirección de correo',
              fax: 'Fax',
              name: 'Apellido',
              first_name: 'Nombre',
              payment_type: 'Tipo de pago',
              mandate_type: 'Tipo de mandato',
              sequence_type: 'Tipo de secuencia',
              creation_date: 'Fecha de creación',
              closing_date: 'Fecha de cierre',
              signature_date: 'Fecha de firma',
              third_party_code: 'Código tercero deudor',
              third_party_name: 'Nombre tercero deudor',
              prev_rum: 'Antigua RUM',
              updated_state: 'Estado Mandato modificado',
            },
          },
          table: {
            header: {
              title: 'Lista de mandatos',
              new_mandat: 'Nuevo',
            },
            columns: {
              state: 'Estado',
              company_rum: 'Empresa/RUM',
              type: 'Tipo',
              sequence: 'Secuencia',
              signing: 'Firma',
              code_tiers: 'Tercero deudor',
              nom_tiers: 'Nombre tercero deudor',
              code: 'Código',
            },
          },
        },
        Scopes: {
          fiche: {
            title: {
              edit_title: 'Fecha del alcance {{name}}',
              view_title: 'Fecha del alcance {{name}}',
              new_title: 'Creación de un nuevo alcance',
              user_member_list: 'Lista de usuarios miembros',
              companies_member_list: 'Lista de empresas miembros',
              accounts_member_list: 'Lista de cuentas miembros',
              tiersGrp_member_list: 'Lista de grupos de terceros miembros',
              list_flux: 'Lista de flujos',
            },
            modal: {
              user_list: 'Selección de usuarios',
              company_list: 'Selección de empresas',
              account_list: 'Selección de cuentas',
              third_party_group_list: 'Selección de grupos de terceros',
              flux_list: 'Selección de flujos',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
              add: 'Añadir',
              close: 'Cancelar',
              history: 'Historial',
            },
            champ_titles: {
              code: 'Código',
              name: 'Apellido',
              first_name: 'Nombre',
              state: 'Estado',
              new: 'Nuevo',
              iban: 'IBAN',
            },
          },
          table: {
            header: {
              title: 'Lista de alcances',
              new_scope: 'Nuevo',
            },
            columns: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              date: 'Fecha de modificación',
              flux: 'Flujo',
              devise: 'Divisa',
            },
          },
        },
        Societes: {
          fiche: {
            title: {
              edit_title: 'Ficha de la empresa',
              new_title: 'Creación de una nueva empresa',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
              history: 'Historial',
            },
            champ_titles: {
              name: 'Nombre',
              code: 'Código',
              fax_num: 'No. Fax',
              tel_num: 'No. Teléfono',
              legal_infos: 'Aviso legal',
              state: 'Estado',
              adresse: 'Dirección',
              country: 'País',
              cloture_date: 'Fecha de cierre',
              logo: 'Logotipo',
              date: 'Fecha de modificación',
              title_adress: 'Dirección de la empresa',
              title_infos_complet: 'Información adicional',
              button_charge_adress_structure: 'Cargar dirección estructurada',
              title_adress_structure: 'Dirección estructurada de la empresa',
              capital: 'Capital',
              capital_currency: 'Moneda de capital',
              title_list_mandant: 'Lista de mandantes',
              ordre: 'Orden',
              type_mandat: 'Tipo de vínculo con el mandante',
              mandat_name: 'Nombre del mandante',
              fonction: 'Función',
              date_start: 'Fecha de inicio',
              date_end: 'Fecha de finalización',
              long_name: 'Nombre largo',
              tva: 'No. IVA',
              form_legacy: 'Forma Jurídica',
            },
            columns: {
              state: 'Estado',
            },
            modal_mandant: {
              title: 'Ficha del mandante',
              ordre: 'Orden',
              type_mandat: 'Tipo de vínculo con el mandante',
              mandat_name: 'Mandante',
              nomination: 'Nombramiento',
              comment: 'Comentario',
              date_start: 'Fecha de inicio',
              date_end: 'Fecha de finalización',
              type_mandant: 'Tipo de mandante',
              function: 'Función',
              modal_add_user: {
                title: 'Selección de un usuario',
                state: 'Estado',
                login: 'Inicio de sesión',
                name: 'Nombre',
                last_name: 'Apellido',
              },
              modal_add_society: {
                title: 'Selección de una empresa',
                state: 'Estado',
                name: 'Nombre',
                code: 'Código',
                society: 'Empresa',
              },
            },
          },
          table: {
            header: {
              title: 'Lista de empresas',
              new_company: 'Nuevo',
            },
            columns: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              date: 'Fecha de modificación',
              ics: 'ICS',
              country: 'País',
            },
          },
          drawer: {
            title: 'Gestión',
            gestion_fx: 'Gestión FX',
            companyb2b: 'Empresa B2B',
            holdingb2b: 'Holding B2B',
          },
        },
        Tiers: {
          fiche: {
            title: {
              edit_title: 'Ficha del tercero',
              view_title: 'Ficha del tercero {{lastname}}',
              new_title: 'Creación de un nuevo tercero',
              bank_infos: 'Datos bancarios',
              third_address: 'Dirección del tercero',
              intermediate_bank: 'Banco intermediario',
              text_lecture_seule:
                'Sólo lectura - Modificación 4 Ojos en espera',
              title_adress: 'Dirección del banco',
              title_adress_structure_banque: 'Dirección estructurada del banco',
              title_adress_tiers: 'Dirección del tercero',
              title_adress_structure_tiers:
                'Dirección estructurada del tercero',
              title_adress_bank_intermediaire:
                'Dirección del banco intermediario',
              title_adress_structure_bank_intermediare:
                'Dirección estructurada del banco intermediario',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
              checkAccount: 'Verificar la cuenta',
              checkBic: 'Verificar el BIC',
            },
            champ_titles: {
              grp: 'Grupo',
              state: 'Estado',
              type: 'Tipo',
              code: 'Código',
              name: 'Nombre',
              siret: 'Código de identificación del establecimiento',
              tva: 'IVA',
              country: 'País',
              account_num: 'No. de cuenta',
              devise: 'Divisa',
              clearing: 'Clearing',
              clearing_id: 'Código de compensación / Código bancario',
              domiciliation: 'Denominación',
              adresse: 'Dirección',
              country_code: 'Código País',
              prenom: 'Nombre',
              birth_date: 'Fecha de nacimiento',
              country_birth: 'País de nacimiento',
              city_birth: 'Ciudad de nacimiento',
              mail: 'Correo electrónico',
              tiersType: 'Tipo de pago tercero',
            },
            list_operation: {
              title: 'Lista de operaciones',
              button_title: 'Operaciones',
              montant: 'Importe',
              currency: 'Divisa',
              date: 'Fecha de operación',
              label: 'Texto',
              lot_number: 'N° de lote',
              remittance_number: 'N° de remesa',
              flow: 'Flujo',
              onglet_operation: 'Operación',
              onglet_mandat: 'Mandato',
              onglet_timeline: 'Línea de tiempo',
              onglet_analyse: 'Análisis',
              button_contre_appel: 'Contrallamada',
              title_commentaire_panel: 'Comentario',
              confirm_message:
                '¿Confirma que ha realizado la contrallamada de este Tercero?',
            },
          },
          table: {
            header: {
              title: 'Lista de terceros',
              new_third: 'Nuevo',
            },
            columns: {
              state: 'Estado',
              type: 'Tipo',
              code: 'Código',
              name: 'Nombre',
              account_num: 'No. de cuenta',
              devise: 'Divisa',
              grp: 'Grupo',
              country: 'País',
              date: 'Fecha de modificación',
              control: 'Control',
              thirdparty_country_code: 'País del tercero',
              siret: 'SIRET',
              tva: 'IVA',
              type_payement: 'Tipo de pago',
            },
          },
        },
        validation4Yeux: {
          title: 'Selección de aprobadores 4 Ojos',
          alert: 'Por favor seleccione un aprobador 4 Ojos',
          columns: {
            login: 'Login',
            last_name: 'Apellido',
            first_name: 'Nombre',
          },
        },
        Bank: {
          invalidIBAN:
            'IBAN no válido. Formato: {{default_form}}, Ejemplo: {{example}}',
          invalidBIC: 'Bic no válido',
          invalidBBAN:
            'BBAN no válido. Formato: {{default_form}}, Ejemplo: {{example}}',
          invalidIBAN_simple: 'IBAN no válido',
          invalidBBAN_simple: 'BBAN no válido',
          bbanInfos: ' Formato: {{default_form}}, Ejemplo: {{example}}',
        },
      },
      settings: {
        filialeusers: {
          modal: {
            title: 'Selección de un usuario',
          },
          fiche: {
            title: {
              edit_title: 'Ficha de un usuario {{name}}',
              new_title: 'Creación de un nuevo usuario',
              view_title:
                'Ficha del perfil de un usuario {{name}} (Sólo lectura - Modificación 4 Ojos en espera)',
              group_users: 'Miembro de',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              history: 'Historial',
              reinitialise: 'Reinicializar TOTP',
              reinitialise_pwd: 'Reinicializar Contraseña',
              message_confirm_pwd: '¿Desea reinicializar la contraseña?',
            },
            placeholder: 'Selección de un usuario',
            login: 'Login',
            email: 'Dirección de correo',
            name: 'Apellido',
            prenom: 'Nombre',
            langue: 'Idioma',
            smart: 'Smart-tags',
            nPhone: 'Teléfono',
            nFax: 'Fax',
            nMobile: 'Móvil',
          },
          table: {
            header: {
              title: 'Lista de usuarios',
              new_user: 'Nuevo',
              list_pouvoir: 'Lista de poderes del usuario',
              detail_pouvoir: 'Lista detallada de poderes',
              title_button: 'Impresión de Resumen de Poderes',
            },
            columns: {
              user_entity_state: 'Estado usuario entidad',
              user_state: 'Estado',
              login: 'Login',
              name: 'Apellido',
              prenom: 'Nombre',
              email: 'Dirección de correo',
              nMobile: 'No. móvil',
              date: 'Fecha de modificación',
            },
          },
        },
        groupusers: {
          fiche: {
            title: {
              edit_title: 'Ficha del perfil de usuario {{name}}',
              new_title: 'Creación de un perfil de usuario',
              view_title:
                'Ficha del perfil de un usuario {{name}} (Sólo lectura - Modificación 4 Ojos en espera)',
              members: 'Miembros',
              authorizations: 'Autorizaciones',
              flow: 'Flujo',
              accounting: 'Contabilidad',
              accounting_export: 'Exportación contable',
              setting: 'Ajustes',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              history: 'Historial',
              create: 'Crear',
            },
            champ_titles: {
              code: 'Código',
              state: 'Estado',
              name: 'Nombre',
              users: 'Usuarios',
              users_grp: 'Perfiles de usuarios',
              smart_tag: 'SmartTags',
            },
            columns: {
              login: 'Login',
              name: 'Apellido',
              first_name: 'Nombre',
              state: 'Estado',
              flow: 'Flujo',
              readings: 'Extractos',
              repository: 'Repositorio',
              settings: 'Ajustes',
              treatments: 'Procesamientos',
              accounting: 'Contabilidad',
              accounting_export: 'Exportación contable',
              rates_and_currencies: 'Tasas y Divisas',
            },
          },
          modal: {
            title: 'Seleccionar una empresa',
            buttons: {
              add: 'Añadir',
              close: 'Cancelar',
            },
          },
          table: {
            header: {
              title: 'Lista de perfiles de usuarios',
              new_groupuser: 'Nuevo',
              synthesis: 'Síntesis perfiles usuarios',
              export_droit: 'Exportación Excel de Derechos',
            },
            columns: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              date: 'Fecha de modificación',
            },
          },
        },
        SmartTags: {
          fiche: {
            title: {
              edit_title: 'Ficha de un Smart Tag {{code}}',
              create: 'Creación de un nuevo Smart Tag',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              archive: 'Archivar',
            },
            champ_titles: {
              users: 'Usuarios',
              users_grp: 'Perfiles de usuarios',
            },
          },
          table: {
            header: {
              title: 'Lista de SmartTags',
            },
            columns: {
              code: 'Código',
            },
          },
        },
        FourYeux: {
          fiche: {
            title: {
              default: 'Solicitud aprobada',
              creation: 'Solicitud de creación',
              modification: 'Solicitud de modificación',
              suppression: 'Solicitud de eliminación',
              revoke: 'Cancelar la solicitud',
            },
            buttons: {
              back: 'Volver',
              save: 'Aprobar la solicitud',
              refuse: 'Denegar la solicitud',
              create: 'Crear',
              revoke: 'Cancelar la solicitud',
              alert: 'Consulte el documento RIB antes de confirmar.',
            },
            champ_titles: {
              initiale: 'Ficha inicial',
              demande: 'Solicitud de modificación',
            },
          },
          table: {
            header: {
              title: '4Ojos validación',
            },
            columns: {
              code: 'Código',
              state: 'Estado',
              libelle: 'Texto',
              date: 'Fecha de modificación',
              demand_number: '#',
              demand_type: 'Tipo de solicitud',
              short_name: 'Nombre (largo)',
              denomination: 'Denominación',
              demandeur: 'Solicitante',
              demand_date: 'Fecha de solicitud',
              validator: 'Aprobador',
              validation_date: 'Validación / Rechazo',
            },
          },
        },
        pouvoirSignature: {
          table: {
            header: {
              title: 'Lista de los poderes signatarios',
              synthese: 'Resumen de poderes signatarios',
            },
          },
          fiche: {
            title_form: 'Ficha del poder',
            title_create: 'Creación de un poder signatario',
            code: 'Código',
            code_placeholder: 'Código del poder signatario',
            name: 'Nombre',
            name_placeholder: 'Nombre del poder signatario',
            type: 'Tipo',
            etat: 'Estado',
            flux: 'Flujo',
            devise: 'Divisa',
            titleTab1: 'Colegio de signatarios',
            titleTab2: 'Lista de empresas miembros',
            titleTab3: 'Lista de cuentas miembros',
            table_colleg_signature: {
              coll1: 'Colegio 1',
              coll2: 'Colegio 2',
              niveau: 'Nivel',
              type: 'Tipo de umbral',
              seuil: 'Umbral inf.',
              seuil_sup: 'Umbral sup.',
              ordre: 'Orden',
              pouvoir_descr: 'Descripción',
            },
            table_societe_member: {
              code: 'Código',
              name: 'Nombre',
              state: 'Estado',
            },
            table_compte_member: {
              code: 'Código',
              name: 'Nombre',
              iban: 'IBAN',
              state: 'Estado',
            },
            modalSignature: {
              title: 'Añadir colegios de signatarios',
              add: 'Añadir',
              cancel: 'Cancelar',
              niv_signature: 'Nivel de firma',
              college_1: 'Colegio 1',
              college_2: 'Colegio 2',
              college: 'Colegio {{nb}}',
              ordre: 'Orden',
              type_seuil: 'Tipo de umbral',
              seuil_inf: 'Umbral inferior',
              seuil_supp: 'Umbral superior',
              error_colleg1: 'Elija un colegio 1',
              error_threshold: 'Valor(es) de umbral incorrecto(s)',
              pouvoir_descr: 'Descripción del poder',
            },
            modal_company_member: {
              title: 'Selección de empresas',
            },
            modal_compte_member: {
              title: 'Selección de cuentas bancarias',
            },
            buttons: {
              back: 'Cancelar',
            },
            signatoryType: 'Tipo de firmante',
          },
        },
        college: {
          table: {
            header: {
              title: 'Lista de colegios de signatarios',
              synthese: 'Resumen de colegios signatarios',
            },
            columns: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              electronic_signature: 'Firma electrónica',
              date: 'Fecha de modificación',
            },
          },
          fiche: {
            title: {
              edit_title: 'Ficha del colegio {{code}}',
              new_title: 'Creación de un nuevo colegio de signatarios',
              signatories: 'Signatarios',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              history: 'Historial',
            },
            champ_titles: {
              code: 'Código',
              name: 'Nombre',
              state: 'Estado',
              signature: 'Firma',
            },
            columns: {
              state: 'Estado',
              first_name: 'Nombre',
              name: 'Apellido',
              login: 'Login',
            },
          },
          modal: {
            title: 'Seleccionar un usuario',
            buttons: {
              add: 'Añadir',
              close: 'Cancelar',
            },
          },
          history: {
            title: {
              edit_title: 'Historial de modificaciones de la ficha: {{time}}',
            },
            columns: {
              state: 'Estado 4Ojos',
              timestamp_creation: 'Fecha creación',
              update_timestamp: 'Fecha validación',
              login_creation: 'Creación',
              login_validation: 'Validación',
            },
            buttons: {
              back: 'Cancelar',
            },
          },
        },
      },
      treatment: {
        jobs: {
          message: '¿Desea ejecutar de nuevo el trabajo',
          header: {
            title: 'Lista de Trabajos',
          },
          columns: {
            job_number: 'No. de Trabajo',
            status: 'Estado',
            type: 'Tipo',
            priority: 'Prioridad',
            recursive: 'Recurrente',
            date: 'Fecha de creación',
            programmation_date: 'Programado el',
            start_date: 'Inicio del procesamiento',
            end_date: 'Finalización del procesamiento',
            error_code: 'Código de error',
            server: 'Servidor',
            description: 'Descripción',
          },
          change_failed: '¿Desea pasar el trabajo a Failed?',
          change_failed_placeholder: 'Paso a Failed',
          relance_placeholder: 'Relanzar',
        },
        controle: {
          header: {
            title: 'Lista de solicitudes de control',
            add: 'Control de terceros',
          },
          columns: {
            etat: 'Estado',
            date_envoye: 'Fecha de envío',
            type: 'Tipo',
            libelle: 'Texto',
            login: 'Login',
            nb: 'No.',
            ok: 'Ok',
            di: 'Diam.',
            nok: 'NOK',
            vis: 'Visualización',
            nb_high_risk: 'N.º Muy arriesgado',
            nb_no_verif: 'N.º No verificado',
            nb_risk: 'N.º Arriesgado',
            nb_verif: 'N.º Verificado',
          },
          newSSid: {
            thirdG: 'Grupo de terceros',
            thirdP: 'Tercero unitario',
            placeholder: 'Indicar las 3 primeras letras del tercero buscado',
          },
        },
        details: {
          title: 'Lista de solicitudes de verificación',
          fermer: 'Cerrar',
          titleDrawer: 'Motivo',
          columns: {
            state: 'Estado',
            code: 'Código',
            name: 'Nombre',
            nCompte: 'No. Cuenta',
            idEnv: 'Código de identificación del establecimiento / IVA',
            typeT: 'Tipo tercero',
            codeP: 'Código país',
            noteP: 'Nota Análisis',
            reason: 'Motivo',
            date_analyse: 'Fecha de solicitud',
          },
        },
      },
      accounting: {
        writing: {
          fiche: {
            title: {
              edit_title: 'Ficha del asiento {{libelle}}',
              view_title: 'Ficha del asiento',
              new_title: 'Creación de un nuevo asiento',
              caracteristic: 'Características',
              accounting_caracteristic: 'Características Contabilidad',
              reconciliation: 'Conciliación contable',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
            },
            champ_titles: {
              account: 'Cuenta',
              placeholder_account: 'Seleccionar el Código cuenta',
              libelle: 'Texto',
              operation_date: 'Fecha Operación',
              writing_number: 'No. Asiento',
              category: 'Categoría',
              state: 'Estado',
              amount: 'Importe',
              writing_type: 'Tipo Asiento',
              code_sens: 'Código Orden',
            },
            placeholder: {
              amount: 'Importe de la operación',
              category: 'Introducir el Código Categoría',
              writing_number: 'Número asiento',
            },
          },
          table: {
            header: {
              title: 'Lista de asientos',
              error_selected: 'Error',
              txt_error: 'Los asientos seleccionados no tienen el mismo estado',
              visualisation: 'Visualización de sesión ',
            },
            filters: {
              state: '-Estado-',
              scope: '- Alcance -',
              title: 'Modificación en masa de los asientos',
              operationDate: 'Fecha operación',
              category: '-  Categoría -',
              title_import: 'Importación de los asientos',
              selected_file: 'Seleccionar los archivos',
              aucun_file: 'Ningún archivo seleccionado',
            },
            columns: {
              state: 'Estado',
              libelle: 'Texto',
              montant: 'Importe',
              devise: 'Divisa',
              categorie: 'Categoría',
              operation_date: 'Fecha operación',
              reference: 'No. asiento',
              account: 'Cuenta',
              company: 'Empresa',
              code_sens: 'Orden',
              writing_type: 'Tipo asiento',
              modif: 'Modificación',
              user: 'Usuario',
              opening_balance: 'Saldo inicial',
              ending_balance: 'Saldo final',
              session_entries_id: 'IDSesión',
            },
          },
          action: {
            title: 'Acción',
            edit_masse: 'Modificación masa',
            print: 'Imprimir',
            importer: 'Importar',
          },
          visu_session: {
            title: 'Lista de sesiones',
            columns: {
              id: 'ID',
              account: 'Cuenta',
              date: 'Fecha',
              opening_balance: 'Saldo inicial',
              ending_balance: 'Saldo final',
              devise: 'Divisa',
              state: 'Estado',
            },
            activate: 'Cambiar a «Activa»',
            confirm_validation_msg:
              '¿Desea activar la sesión de asientos contables',
          },
        },
        rules: {
          fiche: {
            title: {
              edit_title: 'Ficha de la regla {{code}}',
              view_title: 'Ficha de la regla {{code}}',
              new_title: 'Creación de una nueva Regla',
              rapprochement_criteria: 'Criterios de Conciliación',
              operation_linked: 'Lista de los códigos de operación vinculados',
              members: 'Lista de miembros',
              rappro: 'Conciliación por importe',
              modal_title: 'Lista de sociedades',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              new: 'Nuevo',
              create: 'Crear',
            },
            champ_titles: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              order: 'Orden',
              category: 'Categoría',
              mode: 'Modo',
              rapprochement_by_date: 'Conciliación por fecha',
              rapprochement_by_label: 'Conciliación por texto',
              rapprochement_by_ref: 'Conciliación por referencia',
              date_difference: 'Diferencia Fecha',
              detail_flux: 'Detalle flujo borrador',
              placeholder_detail_flux: 'Detalle',
              download_model: 'Descargar modelo excel',
            },
            columns: {
              code: 'Código',
              name: 'Nombre',
            },
            error_critere:
              'Por favor seleccione al menos un criterio de conciliación para validar esta regla',
          },
          table: {
            header: {
              title: 'Lista de reglas',
              new_rule: 'Nuevo',
            },
            columns: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              date: 'Fecha de modificación',
              automanuel: 'Auto Manual',
              order: 'Orden',
            },
          },
        },
        historique: {
          title: 'Historial de conciliación',
          show_details: 'visualización Detalle',
          session_selection: 'Selección Sesión',
          deraprochement: 'Desconciliación sesión',
          scope: 'Alcance',
          company: 'Empresa',
          code: 'Introducir el código',
          mvt_bancaire: 'Movimientos bancarios conciliados',
          ecriture_rapprochement: 'Asientos contables conciliados',
          category: 'Categoría',
          writing_date: 'Fecha Asiento',
          rappro_date: 'Fecha Concil.',
          columns: {
            account: 'Cuenta',
            category: 'Cat.',
            date: 'Fecha Op.',
            label: 'Texto',
            amount: 'Importe',
          },
          modal: {
            title: {
              session_list: 'Lista de sesiones',
            },
            buttons: {
              visualize: 'Visualizar',
            },
            columns: {
              date_num: 'Fecha/Num.',
              user: 'Usuario',
              mvt_number: 'No. Mtos.',
              wrt_number: 'No. Asientos',
              nb_mvt: 'Nº movimiento',
              nb_prevision: 'Nº previsión',
            },
          },
          detail: {
            columns: {
              account: 'Cuenta',
              amount: 'Importe',
              label: 'Texto',
              date: 'Fecha valor',
              op_date: 'Fecha Op.',
              category: 'Categoría',
              gap: 'Diferencia',
              state: 'Estado',
              sel: 'Sel.',
              referency: 'No. asiento',
            },
            buttons: {
              validate: 'Desconciliar',
              save: 'Validar',
              back: 'Volver',
            },
            titles: {
              general: 'Conciliación - Detalle',
              movement: 'Movimientos bancarios conciliados',
              detail: 'Conciliación',
              writing: 'Asientos contables conciliados',
            },
            champ_titles: {
              number: 'No.',
              movement_total: 'Total Movimientos',
              gap: 'Diferencia',
              writtingTotal: 'Total Asientos',
            },
          },
          message: '¿Desea reenviar el lote al banco?',
        },
        rapprochement: {
          header: {
            title: 'Conciliación',
            manuel: 'Regla manual',
            montant: 'Importe 1/1',
            montantNN: 'Importe N/N',
            rapprocher: 'Conciliar',
            comment: 'Comentarios',
            eclatement: 'Desglose',
            date_cloture: 'Fecha cierre',
            title_rappro: 'Conciliación - Detalle',
            total_movements: 'Total Movimientos',
            gap: 'Diferencia',
            total_entries: 'Total asientos',
            number: 'No.',
            nodata: 'Ningún dato',
            message_validation:
              'Atención, no todas las cuentas tienen la misma fecha de cierre. Se seleccionó la fecha más pequeña.',
          },
          modal: {
            titles: {
              burst: 'Desglose del asiento',
              comment: 'Comentarios sobre el movimiento',
            },
            comment: 'Comentario',
            new: 'Nuevo',
            total: 'Total Entrado',
            rest: 'Resto a desglosar',
          },
          cards: {
            closed_banking_infos: 'Movimientos bancarios a conciliar',
            closed_writing: 'Asientos a conciliar',
          },
          columns: {
            title: {
              account: 'Cuenta',
              cat: 'Cat.',
              currency: 'Div.',
              account_id: 'Código Op.',
              op_date: 'Fecha Op.',
              label: 'Texto',
              date: 'Fecha',
              hour: 'Hora',
              comment: 'Comentario',
              referency: 'No. asiento',
              login: 'Login',
              amount: 'Importe',
              ref: 'Referencia',
              direction: 'Orden',
              reconcil_number: 'No. documento',
              com: 'Com.',
              company: '- Empresa -',
              account_code: '- Código Cuenta -',
              category: '- Categoría -',
              entry_type: 'Tipo de asiento',
              creation_timestamp: 'Fecha de creación',
              complementary_label: 'Etiqueta complementaria',
              group_compte: '- Grupo Cuenta -',
            },
          },
          footer: {
            total_forecasts: 'Total Asientos',
          },
          detail: {
            table_mvt: {
              sel: 'Sel.',
              cat: 'Categoría',
              op_date: 'Fecha Op.',
              amount: 'Importe',
              ref: 'Referencia',
              dat: 'Fecha Op.',
            },
            table_rappro: {
              account: 'Cuenta',
              diff: 'Diferencia',
              state: 'Estado',
            },
          },
        },
        consultation: {
          table: {
            header: {
              title: {
                general: 'Consulta de los saldos contables',
                selecte_date: 'Selección fecha',
              },
              champ_titles: {
                scope: 'Alcance',
                company: 'Empresa',
                start_date: 'Fecha Inicio',
                end_date: 'Fecha Fin',
              },
              select: {
                account: '- Cuenta -',
                company: '- Empresa -',
                scope: '- Alcance -',
              },
            },
            buttons: {
              init: 'Inicializar',
              close: 'Cerrar',
              add: 'validar',
              print: 'Imprimir',
              print1: 'Movimientos sin conciliar',
              print2: 'Asientos no conciliados',
              print3: 'Asientos periodo',
            },
            columns: {
              history: {
                bank_balance: 'Saldo bancario',
                movement_number: 'No. mvtos.',
                amount: 'Total movimientos no conciliados',
                number_writing: 'No. escrit.',
                sum_amount: 'Total asientos no conciliados',
                accounting_balance: 'Saldo contable',
                currency: 'Divisa',
                current_date: 'Fecha ',
                imp: 'Estado de cierre',
              },
              table: {
                account_code: 'Código',
                name: 'Nombre',
                society_code: 'Empresa',
                balance_date: 'Fecha Cierre',
                book_balance: 'Saldo Cierre',
                valid_closing_date: 'Última fecha Cierre aprobada ',
                valid_closing_balance: 'Último Saldo Cierre aprobado',
              },
            },
          },
          detail: {
            title: {
              init: 'Inicialización del saldo contable',
              info: 'Selección de la información de cierre',
              mouvement: 'Selección de los movimientos no conciliados',
              writing: 'Creación de asientos contables no conciliados',
              sub_info: 'Seleccione los movimientos bancarios no conciliados',
              sub_info_writing: 'Cree las asientos contables no conciliados',
              bank_balance: 'Saldo bancario al {{date}}',
              accounting_balance: 'Saldo Contable al {{date}}',
              validation: 'Validación de una inicialización contable',
              element_selected:
                'Movimientos bancarios no conciliados seleccionados: ( {{nbr}} elementos ) ',
              tooltip: 'Ver los elementos seleccionados',
            },
            buttons: {
              next: 'Siguiente',
              add: 'Añadir',
              save: 'Validar',
              print: 'Mostrar',
            },
            error: {
              date: 'La fecha de operación no debe superar la fecha elegida',
            },
            columns: {
              category: 'Categoría',
              date: 'Fecha Operación',
              label: 'Texto',
              amount: 'Importe',
              operation_date: 'Fecha op.',
              currency: 'Divisa',
              modification: 'Modificación',
            },
            champ_titles: {
              balance_date: 'Fecha Saldo',
              balance_accounting: 'Saldo contable',
              account: 'Código cuenta',
              total: 'Total movimientos no conciliados',
              number: 'No.',
              total_writing: 'Total asientos no conciliados',
              operation_date: 'Fecha Operación',
              label: 'Texto',
              category: 'Categoría',
              amount: 'Importe',
              total_movement_not_reconciled: 'Total Movimientos no conciliados',
              number_movement_not_reconciled:
                'No. de movimientos no conciliados',
              total_writing_not_reconciled: 'Total asientos no conciliados',
              number_writing_not_reconciled: 'No. de asientos no conciliados',
              difference_balance: 'Diferencia con el saldo introducido',
            },
          },
        },
        closure: {
          select: {
            account: '- Cuenta -',
            company: '- Empresa -',
            scope: '- Alcance -',
          },
          table: {
            title: 'Cierre contable',
            closing: 'Cerrar',
            state: 'Estado',
            code: 'Código',
            bank_balance: 'Saldo bancario',
            operation_number: 'No. operaciones',
            sum_operation_non_reconcil: 'Total movimientos no conciliados',
            entry_number: 'No. asientos',
            sum_entry_non_reconcil: 'Total asientos no conciliados',
            accounting_balance: 'Saldo contable',
            currency: 'Divisa',
            current_date: 'Fecha saldo',
            closing_state: 'Estado de cierre',
            modal: {
              title: 'Cierre de cuenta',
              confirm_closing: '¿Desea cerrar esta(s) cuenta(s)?',
              next_date: 'Próxima fecha de cierre',
            },
          },
          error: 'Las cuentas seleccionadas no tienen la misma fecha de cierre',
          unselected_error: 'Debe seleccionar al menos una cuenta',
          history: {
            bank_balance: 'Saldo Bancario',
            movement_number: 'Número de movimientos',
            non_reconcil_movement: 'Total movimientos no conciliados',
            accounting_entries_number: 'Número de asientos',
            non_reconcil_entries: 'Total de asientos no conciliados',
            accounting_balance: 'Saldo contable',
            currency: 'Moneda',
            current_balance_date: 'Fecha de cierre',
            cancel_closing: 'Cancelar cierre',
            state: 'Estado de cierre',
            confirm_closing:
              'Va a cancelar este cierre y volver a la sesión de conciliación anterior. ¿Desea continuar?',
            last_closing: 'Último cierre',
            user: 'Usuario',
          },
          action: 'Acción',
          export_excl: 'Exportar Detalles',
          imprime_detail: 'Imprimir detalle',
        },
        movement: {
          title: 'Lista de movimientos no coincidentes',
        },
      },
      accounting_export: {
        rules: {
          fiche: {
            title: {
              edit_title: 'Ficha de la generación regla {{code}}',
              view_title: 'Ficha de la generación regla',
              new_title: 'Creación de una nueva regla',
              treso_criteria: 'Criterio Tesorería',
              releve_criteria: 'Criterio Extracto',
              flow_criteria: 'Criterio Flujo',
              filter_condition_imputation: 'Condición filtro ',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              add: 'Añadir',
            },
            champ_titles: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              mode: 'Generación del borrador',
              validation: 'Validación del borrador',
              type: 'Tipo',
              interface_generation: 'Interfaz generación',
              export_interface: 'Interfax exportación',
              event: 'Evento',
              category: 'Categoría',
              direction_type: 'Tipo Sentido ',
              direction: 'Sentido ',
              flow: 'Flujo',
              sub_type: 'Subtipo',
              all_wording: 'Todos los textos (Predeterminado)',
              find_wording: 'Texto buscado',
              accounting_account: 'Cta. contable',
              grouping: 'Agrupación',
            },
          },
          table: {
            header: {
              title: 'Lista de Reglas',
              new_groupuser: 'Nuevo',
            },
            filters: {
              state: '-Estado-',
              interface_generation: '-Interfaz generación-',
            },
            columns: {
              title: {
                state: 'Estado',
                code: 'Código',
                name: 'Nombre',
                date: 'Fecha de modificación',
                interface_generation: 'Interfaz generación',
                export_interface: 'Interfaz exportación',
                category_flux: 'Categoría/Flujo',
                auto_manuel: 'Auto/Manual',
              },
            },
          },
        },
        brouillards: {
          table: {
            header: {
              title: 'Lista de generaciones de borradores',
              show: 'Visualizar',
            },
            modal: {
              title: 'Lista de sesiones',
              buttons: {
                show: 'Visualizar',
                close: 'Cancelar',
              },
            },
          },
          alert: 'Seleccione una regla para la visualización',
          detail: {
            Number: 'Número',
            title: 'Generación Visualización',
            Back: 'Volver',
            fog_validate: 'Validar Borrador',
            getting_file: 'Recuperación archivo',
            session: 'Modificación masiva',
          },
          columns: {
            generation_interface: 'Generación Interfaz',
            rule: 'Regla',
            event_type: 'Tipo Evento',
            event_subtype: 'Subtipo Evento',
            category_flux: 'Categoría/Flujo',
            company: 'Empresa',
            account: 'Cuenta',
            amount_value: 'Importe',
            currency: 'Divisa',
            accounting_date: 'Fecha contable',
            creating_date: 'Fecha creación',
            title_modal: 'Modificar un asiento',
          },
        },
        interfaces: {
          fiche: {
            title: {
              new_title: 'Creación de una interfaz de generación',
              edit_title:
                'Ficha de la interfaz de generación en formato {{code}}',
              general: 'General',
              company: 'Lista de empresas miembros',
              account: 'Lista de cuentas miembros',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              add: 'Añadir',
              close: 'Cerrar',
            },
            modal: {
              title: {
                info: 'Lista de palabras claves',
                company: 'Selección de empresas',
                account: 'Selección de cuentas bancarias',
              },
              information: {
                now: 'Fecha del día formato AAMMDD',
                year: 'Año en 2 caracteres seguido de la fecha',
                hour1: 'Hora en formato HHMMSS',
                hour2: 'Hora en formato HHMMSSCCC',
                bank_name: 'Nombre del banco',
                interface_code: 'Código de la interfaz',
              },
            },
            champ_titles: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              connector: 'Conector',
              file_format: 'Formato del archivo',
              naming: 'Nombramiento',
              mode_generation: 'Generación modo',
            },
          },
          table: {
            header: {
              title: 'Lista de interfaces de generación',
            },
            columns: {
              code: 'Código',
              name: 'Nombre',
              format: 'Formato',
              connector: 'Conector',
              state: 'Estado',
              update_timestamp: 'Fecha modificación',
            },
          },
        },
      },
      ratecurrency: {
        currency: {
          currencyTitle: 'Ficha de la divisa {{name}}',
          detailsColumns: {
            cours: 'Tasa',
            last_update: 'Última actualización',
            update_timestamp: 'Fecha',
          },
          header: {
            title: 'Lista de divisas',
          },
          columns: {
            cours: 'Tasa',
            name: 'Nombre',
            favorite: 'Favoritos',
            update_timestamp: 'Última actualización',
            code: 'Código',
          },
          modal: {
            message: '¿Desea marcar como favorito',
            message_unfav: 'Ya no quiere como favorito',
          },
        },
        rates: {
          rateTitle: 'Ficha del tipo director {{name}}',
          detailsColumns: {
            cours: 'Tasa',
            last_update: 'Última actualización',
            update_timestamp: 'Fecha',
          },
          header: {
            title: 'Lista de tipos directores',
          },
          columns: {
            cours: 'Tasa',
            name: 'Nombre',
            favorite: 'Favoritos',
            update_timestamp: 'Última actualización',
          },
          modal: {
            message_fav: '¿Desea marcar como favorito',
            message_unfav: 'Ya no quiere como favorito',
          },
        },
        placeholder: {
          add_favory: 'Marcar como favorito',
          remove_favory: 'Quitar de favoritos',
        },
      },
    },
    administration: {
      communication: {
        chiffrement: {
          table: {
            title: ' Lista de cifrados',
            delete_msg: '¿Seguro que desea eliminar la cuenta',
            headerTitle: {
              code: 'Código',
              encrypt_type: 'Tipo Cifrado',
              start_date: 'Fecha de inicio',
              end_date: 'Fecha de vencimiento',
            },
          },
          fiche: {
            title: 'Creación de un nuevo cifrado',
            edit: 'Ficha del cifrado {{code}}',
            code: 'Código',
            error: 'Error',
            error_msg: 'Campo obligatorio',
            type_chiffrement: 'Tipo Cifrado',
            extension: 'Extensión GPG',
            cle_chiffrement: 'Key-ID GPG',
            pass_phrase: 'Passphrase GPG',
            placeholder_type: '- Tipo -',
            type_naming: 'Tipo de nominación',
          },
          widget_chiffrement: {
            title: 'Fechas de cifrado GPG',
            table: {
              code: 'Código',
              date_start: 'Fecha de inicio',
              date_end: 'Fecha de vencimiento',
              groupe: 'Grupo',
            },
          },
        },
        fichiers_teletransmis: {
          modal: {
            title: {
              visualisation: 'Visualización del archivo ',
            },
            buttons: {
              close: 'Cerrar',
            },
            columns: {
              tag: 'Etiqueta',
              value: 'Valor',
            },
          },
          table: {
            header: {
              title: 'Lista de archivos transmitidos',
            },
            filters: {
              search: {
                place_holder: 'Buscar un archivo por contenido...',
              },
              flow: 'Flujo',
            },
            columns: {
              flux: 'Flujo',
              file_name: 'Nombre de archivo',
              banque: 'Banco',
              file_format: 'Formato del archivo',
              reference: 'Referencia',
              date_transmission: 'Fecha de transmisión',
              size: 'Tamaño ',
            },
          },
        },
        post_traitement: {
          table: {
            header: {
              title: 'Lista de Post Procesamientos',
            },
            columns: {
              code: 'Código',
              name: 'Nombre',
              update_timestamp: 'Fecha de modificación',
              posttraitement_action: 'Acción',
            },
          },
          fiche: {
            title: {
              new_title: 'Creación de un nuevo ',
              edit_title: 'Ficha del post-procesamiento {{code}}',
              ftp: 'Envío FTP',
              file_import: 'Importación de archivos',
              services: 'Servicios',
            },
            modal: {
              title: {
                services: 'Selección de servicios',
                info: 'Lista de palabras claves',
                member: 'Selección de miembros',
              },
              information: {
                now: 'Fecha del día formato AAMMDD',
                year: 'Año en 2 caracteres seguido de la fecha',
                hour1: 'Hora en formato HHMMSS',
                hour2: 'Hora en formato HHMMSSCCC',
                bank_name: 'Nombre del banco',
                interface_code: 'Código de la interfaz',
                flux_code: 'Código del flujo',
                fileformat: 'FileFormat del archivo recibido',
                filename: 'Nombre del archivo recibido',
              },
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              add: 'Añadir',
              close: 'Cerrar',
            },
            placeholder: {
              naming: 'Nombramiento del archivo remoto',
              connector: 'Conector',
              import_interface: 'Interfaz de importación',
              record_size: 'Tamaño de los registros (caso de las líneas fijas)',
            },
            champ_titles: {
              code: 'Código',
              name: 'Nombre',
              file_format: 'FileFormat',
              retraitement: 'Ajuste',
              record_size: 'Tamaño de los registros',
              connector: 'Conector',
              naming: 'Nombramiento',
              import_interface: 'Interfaz de importación',
              filter: 'Filtro',
              select: 'Selección',
              noeud: 'Nodo XML',
              balise: 'Etiqueta de registro de archivo plano',
              position: 'Posición información de cuenta',
              longuer: 'Longitud información de cuenta',
              member: 'Miembros',
            },
            columns: {
              bank: 'Banco',
              flow: 'Flujo',
              code: 'Código',
              name: 'Nombre',
              file_format: 'FileFormat',
            },
          },
        },
        fraud_monitor: {
          table: {
            title: 'Lista de las reglas de Fraud Monitor',
            columns: {
              state: 'Estado',
              type: 'Tipo',
              code: 'Código',
              name: 'Nombre',
              flow: 'Flujo',
              update_timestamp: 'Fecha de modificación',
            },
          },
          fiche: {
            title: {
              new_fraud_monitor:
                'Creación de una nueva regla de verificación de Fraud Monitor',
              edit_fraud_monitor: 'Ficha del fraud monitor {{code}}',
              detail: 'Detalle',
              filtre: 'Filtro',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              add: 'Añadir',
            },
            placeholder: {
              currency: 'Divisa',
              country: 'País',
              flow: 'Todos los flujos',
              selectFiliale: 'Todas las entidades',
              selectSociete: 'Todas las empresas',
              selectBanque: 'Todos los bancos',
              selectFlux: 'Todos los flujo',
              selectPays: 'Todos los países',
              selectDevise: 'Todas las monedas',
            },
            champ_titles: {
              code: 'Código',
              name: 'Nombre',
              flow: 'Flujo',
              state: 'Estado',
              rule_type: 'Tipo de regla',
              period: 'Periodo en curso',
              approval: 'Aprobación',
              filiale: 'Entidad',
              societe: 'Empresa',
              banque: 'Banco',
              pays: 'País',
              devise: 'Divisa',
              origin: 'Origen',
              inclus: 'Incluido',
              exclus: 'Excluido',
              tiers_name: 'Nombre Lista de Terceros',
            },
          },
        },
        connector: {
          table: {
            title: 'Lista de conectores',
            services: 'Lista de servicios',
            columns: {
              code: 'Código',
              state: 'Estado',
              mode: 'Modo',
              name: 'Nombre',
              partner: 'Socio',
              bank: 'Banco',
              type: 'Tipo',
              update_timestamp: 'Fecha de modificación',
              planning_status: 'Estado de planificación',
              recurrency: 'Recurrencia',
              frequence: 'Frecuencia',
            },
            test_ftp: {
              test: 'Probar la conexión',
              path: 'Ruta',
            },
          },
          fiche: {
            title: {
              edit: 'Ficha del conector {{code}}',
              new: 'Creación de un nuevo conector',
              services: 'Servicios',
              ebics: 'Ebics',
              ftp: 'FTP',
              swift_net: 'SwiftNet',
              bureau: 'Service Bureau',
              user_id: 'UserID',
              certificat: 'Certificados',
            },
            buttons: {
              add: 'Añadir',
              validate: 'Validar',
              export: 'Exportar',
              import: 'Importar',
              close: 'Cancelar',
              generate_SSH: 'Generar par de llaves SSH',
              migrate: 'BTF Mapping',
            },
            champ_titles: {
              state: 'Estado',
              code: 'Código',
              mode: 'Modo',
              name: 'Nombre',
              proxy: 'Proxy',
              protocol: 'Protocolo',
              partner: 'Socio',
              bank: 'Banco',
              subsidiary: 'Filial (opcional)',
              host_id: 'HostID',
              partner_id: 'PartnerID',
              order_id: 'OrderID',
              url: 'URL',
              urlauth: 'URL de autenticación',
              version: 'Versión',
              login: 'Login',
              password: 'Contraseña',
              host: 'Host',
              ftp_protocole: 'Protocolo',
              transmit: 'Emisión',
              reception: 'Recepción',
              emergency_host: 'Backup host',
              port: 'Puerto ',
              transfer_mode: 'Modo de transferencia',
              encryption: 'Cifrado FTP',
              component: 'Componente FTP',
              encryption_gpg: 'Cifrado GPG Emisión',
              encryption_gpg_reception: 'Cifrado GPG Recepción',
              responder_dn: 'Responder DN',
              responder_bic: 'Responder BIC',
              requestor_dn: 'Requestor DN',
              requestor_bic: 'Requestor BIC',
              service_name: 'Service Name',
              file_info: 'FileInfo',
              ack_responder: 'Ack Responder',
              compression: 'Compression',
              delivery_notification: 'Delivery Notification',
              connector: 'Conector',
              bulk_payment_pricing: 'Bulk Payment Pricing',
              bulk_paument_plafond: 'Bulk Payment Plafond',
              payload: 'Payload',
              payload_ext: 'Extension payload',
              passphrase_lau: 'Passphrase LAU',
              companion_file: 'Companion file',
              extension: 'Extensión',
              authentification: 'Autenticación',
              ssh_key: 'Clave SSH',
              api_method: 'Método API',
              api_body: 'Parámetro API',
              api_username: 'Nombre de Usario',
              api_authorization_type: 'Autorización',
              api_header: 'Encabezado',
              domain: 'Dominio',
              grantype: 'Tipo de autorización del grante',
              url_auth: 'URL de autenticación',
              ssh_type: 'Tipo de clave SSH',
              AuthAPIType: 'Tipo de Autenticación',
              AuthAPIBody: 'Cuerpo de Autenticación',
            },
            columns: {
              flow: 'Flujo',
              code: 'Código',
              name: 'Nombre',
              electronic_signature: 'Firma electrónica',
              file_format: 'FileFormat',
              file_type: 'FileType',
              beginning_hour: 'Hora inicio',
              end_time: 'Hora finalización',
              user_id: 'UserId',
              login: 'Login',
              alias: 'Alias',
              serial_number: 'No. serie',
              expiration_date: 'Fecha Exp. Autofirmados',
              expiration_date_signature: 'Fecha Exp. Firma',
              ini: 'INI',
              hia: 'HIA',
              hpb: 'HPB',
            },
            placeholder: {
              encryption_none: 'Ningún cifrado',
            },
            modal: {
              title: {
                newService: 'Añadir un servicio',
                editService: 'Modificación de un servicio',
                newUserId: 'Añadir un UserID',
                editUserId: 'Modificación de un UserID',
                loading: 'cargando...',
                import: 'Importación de los certificados',
                gestionEbics: 'Gestión Ebics',
                newCertificat: 'Agregar un certificado',
                editCertificat: 'Modificar un certificado',
              },
              tabs: {
                general: 'General',
                planning: 'Planificación',
                immediate_execution: 'Ejecución inmediata',
              },
              buttons: {
                certificateBackup: 'Recuperación del certificado SConnect',
              },
              champ_titles: {
                flow: 'Flujo',
                code: 'Código',
                name: 'Nombre',
                electronic_signature: 'Firma electrónica',
                file_format: 'FileFormat / Request Type',
                messaging: 'mensajería',
                file_type: 'FileType',
                FileLogicalName: 'File Logical Name',
                meaning: 'Sentido',
                user_id: 'UserId',
                login: 'Login',
                certificate: 'Certificado',
                certificate_base_64: 'Certificado Base 64',
                password: 'Contraseña de los certificados importados',
                certificateA: 'Certificado A00',
                certificateE: 'Certificado E00',
                certificateX: 'Certificado X00',
                planning_status: 'Estado de la planificación',
                beginning_hour: 'Fecha de inicio',
                end_time: 'Fecha de finalización',
                recurring: 'Recurrente',
                frequency: 'Frecuencia (min.)',
                ebics_msg_namevalue: 'Valor del nombre del mensaje',
                ebics_service_container: 'Contenedor de servicio',
                ebics_service_name: 'Nombre del servicio',
                ebics_service_option: 'Opción de servicio',
                ebics_service_scope: 'Ámbito del servicio',
                ebics_msg_name_variant: 'Variante',
                ebics_msg_name_version: 'Versión',
                ebics_format: 'Formato',
                beginning_date: 'Fecha de inicio',
                end_date: 'Fecha de fin',
              },
              columns: {
                CERT: 'Generación de los certificados autofirmados',
                HEV: 'Recuperación de la versión del servidor Ebics',
                INI: 'Envío de la clave de firma A00',
                HIA: 'Envío de las claves de firma y de autenticación',
                Impression: 'Impresión de las cartas de inicialización Ebics',
                HPB: 'Recuperación de los certificados de cifrado y de autenticación del socio',
                HCA: 'Renovación de certificados autofirmados',
                HCS: 'Renovación de certificados autofirmados y certificados de clave',
              },
              HCS: {
                next: 'Siguiente',
                previous: 'Anterior',
                step: 'Paso',
                wait: 'Renovación de los certificados actuales ...',
                nextStep:
                  'Ahora inserte su clave antigua e introduzca su contraseña y haga clic en Siguiente para continuar',
                step1: {
                  txt1: 'Está a punto de renovar sus certificados autofirmados. Debe hacerlo tres meses antes de la fecha de vencimiento del certificado.',
                  txt2: '¡Atención! No todos los bancos gestionan este método de renovación. Si este es el caso, debe restablecer los certificados manualmente.',
                  txt3: 'Inserte su nueva clave y haga clic en Siguiente para continuar',
                },
              },
            },
          },
        },
      },
      interfaces: {
        imports: {
          table: {
            title: 'Lista de interfaces de importación',
            columns: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              flow: 'Flujo',
              format: 'Formato',
              import_type: 'Tipo de importación',
              entity_selection: 'Selección entidad',
              updated_date: 'Fecha de modificación',
              type: 'Tipo',
            },
            title_modal_import: 'Agregar interfaz de exportación',
            message_modal_confirm:
              'El flujo ya existe. ¿Desea modificar los elementos de este flujo?',
          },
          fiche: {
            title: {
              edit_import: 'Ficha de la interfaz de importación {{code}}',
              new_import: 'Creación de una nueva interfaz de importación',
              entity_list: 'Lista de entidades',
              general: 'General',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              add: 'Añadir',
              close: 'Cerrar',
            },
            modal: {
              title: 'Selección de entidades',
            },
            champ_titles: {
              code: 'Código',
              description: 'Descripción',
              type: 'Tipo',
              flow: 'Flujo',
              import_type: 'Tipo importación',
              state: 'Estado',
              file_format: 'Formato del archivo',
              encryption: 'Cifrado',
              entity_selection: 'Selección entidad',
              no_encryption: 'Ningún cifrado',
              duplicate: 'Control de duplicados',
              email_rules: 'Correos electrónicos de error',
            },
            columns: {
              state: 'Estado',
              code: 'Código',
              name: 'Name',
            },
          },
          detail: {
            table: {
              title: 'Lista de los registros de la interfaz',
              buttons: {
                back: 'Volver',
              },
              columns: {
                database_field: 'Campo database',
                registration: 'Registro',
                heading: 'Sección',
                default_value: 'Valor predeterminado',
                method: 'Método',
                update_timestamp: 'Fecha de modificación',
              },
            },
            fiche: {
              title: {
                edit: 'Ficha del registro',
                new: 'Creación de un nuevo registro',
              },
              champ_titles: {
                database_field: 'Campo database',
                heading: 'Sección',
                method: 'Método',
                correspondence: 'Correspondencia',
                default_value: 'Valor predeterminado',
                order: 'Orden',
              },
              buttons: {
                back: 'Cancelar',
                save: 'Validar',
              },
            },
          },
        },
        exports: {
          table: {
            title: 'Lista de las interfaces de exportación',
            columns: {
              code: 'Código',
              name: 'Nombre',
              format: 'Formato',
              updated_date: 'Fecha de modificación',
            },
            title_modal_import: 'Agregar interfaz de exportación',
            message_modal_confirm:
              'La interfaz de exportación ya existe. ¿Desea modificar los elementos de esta interfaz?',
          },
          fiche: {
            title: {
              edit_export: 'Ficha de la interfaz de exportación {{code}}',
              new_export: 'Creación de una nueva interfaz de exportación',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
            },
            champ_titles: {
              code: 'Código',
              description: 'Descripción',
              type: 'Tipo',
              file_format: 'Formato del archivo',
              formatting: 'Formato',
            },
          },
          detail: {
            table: {
              title: 'Lista de los registros de la interfaz',
              buttons: {
                back: 'Volver',
              },
              columns: {
                database_field: 'Campo database',
                registration: 'Registro',
                heading: 'Sección',
                default_value: 'Valor predeterminado',
                method: 'Método',
                update_timestamp: 'Fecha de modificación',
                comment: 'Comentario',
              },
            },
            fiche: {
              title: {
                edit: 'Ficha del registro',
                new: 'Creación de un nuevo registro',
              },
              champ_titles: {
                database_field: 'Campo database',
                heading: 'Sección',
                method: 'Método',
                correspondence: 'Correspondencia',
                default_value: 'Valor predeterminado',
                order: 'Orden',
              },
              buttons: {
                back: 'Cancelar',
                save: 'Validar',
              },
            },
          },
          detailIsPdf: {
            table: {
              title: 'Creación de un nuevo registro',
              buttons: {
                back: 'Volver',
              },
              columns: {
                champs: 'Campo',
                heading: 'Sección',
                database: 'Database',
                chp_dtb1: 'Campo 1',
                chp_dtb2: 'Campo 2',
                chp_dtb3: 'Campo 3',
                chp_dtb4: 'Campo 4',
                chp_dtb5: 'Campo 5',
                chp_dtb6: 'Campo 6',
                chp_dtb7: 'Campo 7',
                chp_dtb8: 'Campo 8',
                method: 'Método',
                mask: 'Máscara',
                mise_en_page: 'Sobrecarga de la maquetación',
                polise: 'Fuente',
                taille: 'Tamaño',
                alignement: 'Alineación',
                gras: 'Negrita',
                soulign: 'Subrayado',
              },
            },
          },
        },
        formats: {
          table: {
            title: 'Lista de los formatos de archivos',
            columns: {
              code: 'Código',
              name: 'Nombre',
              type: 'Tipo',
              updated_date: 'Fecha de modificación',
              length: 'Longitud reg.',
              separator: 'Separador',
              comment: 'Comentario',
            },
            buttons: {
              import: 'Importar',
            },
            modal: {
              title: 'Importación de un formato',
              champ_titles: {
                upload: 'Upload',
              },
            },
          },
          fiche: {
            title: {
              edit_format: 'Ficha del formato {{code}}',
              new_format: 'Creación de un nuevo formato',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
            },
            champ_titles: {
              code: 'Código',
              name: 'Nombre',
              type: 'Tipo',
              length: 'Longitud reg.',
              separator: 'Separador',
              multi: 'Multi-Chèques por página',
              offset: 'Offset',
              header: 'Con cabecera',
            },
          },
          detail: {
            table: {
              title: 'Lista de registros del formato',
              buttons: {
                back: 'Volver',
              },
              columns: {
                order: 'Orden',
                code: 'Código',
                type: 'Tipo',
                update_timestamp: 'Fecha de modificación',
                length: 'Longitud reg.',
                separator: 'Separador',
              },
            },
            fiche: {
              title: {
                edit: 'Ficha de registro {{code}}',
                new: 'Creación de un nuevo registro',
              },
              champ_titles: {
                code: 'Código',
                type: 'Tipo',
                order: 'Orden',
              },
              buttons: {
                back: 'Cancelar',
                save: 'Validar',
              },
            },
          },
          heading: {
            table: {
              title: 'Lista de campos',
              buttons: {
                back: 'Volver',
              },
              columns: {
                order: 'Orden',
                label: 'Texto',
                type: 'Tipo',
                position: 'Posición',
                length: 'Longitud',
                update_timestamp: 'Fecha de modificación',
              },
            },
            fiche: {
              title: {
                edit: 'Ficha del registro',
                new: 'Creación de un nuevo registro',
                propriety: 'Propiedades',
                visu_export_comptable:
                  'Visualización para Exportación Contable',
              },
              champ_titles: {
                label: 'Texto',
                type: 'Tipo',
                order: 'Orden',
                mask: 'Máscara',
                separator: 'Separador',
                line_if_item: 'Línea si sección',
                position: 'Posición {{cord}}',
                length: 'Longitud',
                height: 'Altura',
                thickness: 'Grosor',
                visible: 'Visible Visualización',
                field_length: 'Longitud Visualización',
              },
              buttons: {
                back: 'Cancelar',
                save: 'Validar',
              },
            },
          },
        },
        import_rule: {
          table: {
            header: {
              title: 'Lista de reglas de importación',
            },
            modal: {
              remove: {
                title: '¿Seguro que desea eliminar esta regla de importación',
              },
            },
            columns: {
              state: 'Estado',
              connector: 'Conector',
              partner: 'Socio',
              import_interface: 'Interfaz de importación',
              format: 'Formato',
              condition: 'Condición',
              extension: 'Extensión',
              directory: 'Catálogo',
            },
          },
          fiche: {
            title: {
              create_import_rule: 'Creación de nuevas reglas de importación',
              edit_import_rule: 'Modificación de las reglas de importación',
              conditions: 'Condiciones',
            },
            champ_titles: {
              state: 'Estado',
              connector: 'Conector ERP',
              import_interface: 'Interfaz de importación',
              type: 'Tipo',
              treatment_after_import: 'Procesar después de importar',
              file_name: 'Nombre del archivo',
              directory: 'Catálogo',
              extension: 'Extensión del archivo',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
            },
          },
        },
        export_rule: {
          table: {
            header: {
              title: 'Lista de reglas de exportación',
            },
            modal: {
              remove: {
                title: '¿Seguro que desea eliminar esta regla de exportación',
              },
            },
            columns: {
              state: 'Estado',
              rule_code: 'Código Regla',
              rule_name: 'Nombre Regla',
              method: 'Método',
              periodicity: 'Periodicidad',
              launch_time: 'Hora Ejecución',
              last_launch: 'Ultima Ejecución',
              file_name: 'Nombre Archivo',
              update_timestamp: 'Fecha de modificación',
              extension: 'Extensión',
              directory: 'Catálogo',
            },
          },
          fiche: {
            title: {
              create_export_rule: 'Creación de nuevas reglas de Exportación',
              edit_export_rule:
                'Modificación de las reglas de exportación {{code}}',
              conditions: 'Condiciones',
              request_content: 'Contenido Solicitud',
            },
            champ_titles: {
              state: 'Estado',
              rule_code: 'Código Regla',
              rule_name: 'Nombre Regla',
              method: 'Método',
              periodicity: 'Periodicidad',
              end_point: 'End Point',
              type: 'Tipo',
              file_name: 'Nombre del archivo',
              directory: 'Catálogo',
              extension: 'Extensión del archivo',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
            },
          },
        },
        flux: {
          table: {
            title: 'Lista de los flujos',
            headerTitle: {
              code: 'Código',
              nom: 'Nombre',
              type: 'Tipo',
              support: 'Soporte',
              process_signature: 'Proceso de firma',
              confidential: 'Confidencialidad',
              interface_export: 'Interfaz de exportación',
              date: 'Fecha de modificación',
            },
            title_modal_confirm: 'Agregar flujos',
            list_missing_champ: 'Campos faltantes: ',
          },
          fiche: {
            title: 'Creación de un nuevo flujo',
            code: 'Código',
            nom: 'Nombre',
            type: 'Tipo',
            support: 'Soporte',
            creation_title_fiche: 'Creación de un nuevo flujo',
            edit_tile_fiche: 'Ficha del flujo',
            flow_code_placeholder: 'Código del Flujo',
            flow_nom_placeholder: 'Nombre del Flujo',
            caracteristique: {
              title: 'Características',
              flux_confidentiel: 'Flujo confidencial',
              process_signature: 'Proceso firma',
              interface_export: 'Interfaz de exportación predeterminada',
              methode_attribution: 'Método de asignación',
              controle_mandat: 'Verificación Mandato',
              control_date: 'Gestión de fecha',
              autorisation: 'Autorización para dividir el lote',
              type_doc: 'Tipo de documento',
            },
            masque_saisie: {
              title: 'Máscaras entrada',
              coordonne_bank: 'Datos bancarios',
              bank_intermediaire: 'Banco intermediario',
              type_dest: 'Tipo destinatario',
              saisie_liste: 'Introducción de datos mediante lista',
            },
            tresorerie: {
              title: 'Tesorería',
              prevision_emmet: 'Previsión Emisor',
              prevision_tiers: 'Previsión Tercero',
              type_prev: 'Tipo de previsión',
              nature_tiers: 'Naturaleza tercero',
              nature_emmet: 'Naturaleza emisor',
              categ_tiers: 'Categoría terceros',
              categ_emmet: 'Categoría emisor',
              exonere: 'transferencia de efectivo',
              title_code_cature: 'Selección del código naturaleza',
              title_categorie: 'Selección de la categoría',
              add: 'Añadir',
              annuler: 'Cancelar',
            },
            pays_emmet: {
              title: 'Países emisores autorizados',
            },
            pays_dest: {
              title: 'Países destinatarios autorizados',
            },
            authorized_currencies: {
              title: 'Divisas autorizadas',
            },
            authorized_bank: {
              title: 'Bancos autorizados',
            },
            interface_export: {
              title: 'Interfaces de exportación específicas por banco',
              title_Modal: 'Selección del interfaz de exportación por banco',
              add: 'Añadir',
              annuler: 'Cancelar',
              bank: 'Banco',
              interf_exp: 'Interfaz de exportación',
              headerTable: {
                code: 'Código',
                interface_export: 'Interfaz de exportación',
              },
            },
            mask: {
              title_mask_remise: 'Máscaras remesas',
              title_mask_operation: 'Máscaras operaciones',
              title_mask_compta: 'Máscaras de cuenta contable',
              headerTable: {
                name: 'Nombre del campo',
                interface_export: 'Interfaz de exportación',
                type_champ: 'Tipo de campo',
                libelle: 'Texto',
                visible: 'Visible',
                obligatoire: 'Obligatorio',
                edit: 'Modificable en modo entrada',
                taille_saisie: 'Tamaño de entrada',
              },
              title_Modal: 'Máscara de entrada',
              add: 'Añadir',
              annuler: 'Cancelar',
              name_champ: 'Nombre del campo',
              maskTitle: 'Máscara',
            },
            modalSetting: {
              title: 'Ajustes',
              seuil: 'Umbral de generación',
              seuilPlaceholder:
                'Número de operaciones a partir del cual se realizará la generación al importar el archivo',
              mailBox: 'MailBox',
              flux_post: 'Flujo Post Generación',
              demate_connector: 'Conector Demat',
              demate_connector2: 'Conector Demat 2',
              accepts_operation_zero: 'Autorizar importe cero en entrada',
              control_adress_tiers: 'Control Dirección Terceros en entrada',
              add_mvt: 'Añadir movimientos en CC',
              mail_box_edit_date: 'Autorización modificación fecha',
              CheminDateModif: 'Ruta de fecha de modificación',
            },
            sous_type: 'Subtipo',
            methodeAttribution: 'Método de atribución de validadores',
            typeDoc_compte: 'Tipo de documento cuenta',
            typeDoc_societe: 'Tipo de documento sociedad',
          },
        },
      },
      customisation: {
        listes: {
          table: {
            title: 'Lista desplegable',
            columns: {
              code: 'Código',
              name: 'Nombre',
            },
          },
          fiche: {
            title: {
              edit_liste: 'Ficha de la lista {{ code }}',
              new_liste: 'Creación de una nueva lista',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
            },
            champ_titles: {
              code: 'Código',
              name: 'Nombre',
            },
          },
          detail: {
            table: {
              title: 'Lista de valores de la lista desplegable {{list_code}}',
              buttons: {
                back: 'Volver',
              },
              columns: {
                code: 'Código',
                label: 'Texto',
              },
            },
            fiche: {
              title: {
                edit: 'Ficha del campo {{value}}',
                new: 'Creación de un campo de la lista',
              },
              champ_titles: {
                value: 'Valor',
              },
              buttons: {
                back: 'Cancelar',
                save: 'Guardar',
              },
            },
          },
        },
        accounting_field: {
          table: {
            title: 'Lista de las personaizaciones contables',
            columns: {
              label: 'Texto',
              name: 'Nombre del campo',
              visible: 'Visible',
              obligatory: 'Obligatorio',
              entered_size: 'Tamaño de entrada',
            },
          },
          modal: {
            remove: {
              title: '¿Seguro que desea eliminar este campo',
            },
          },
          fiche: {
            title: {
              edit: 'Ficha del campo',
              new: 'Creación de un nuevo campo contable',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
            },
            champ_titles: {
              mask: 'Máscara',
              name: 'Nombre del campo',
            },
          },
        },
        dynamic_method: {
          table: {
            title: 'Lista de métodos dinámicos',
            columns: {
              code: 'Código',
              name: 'Nombre',
              state: 'Estado',
              update_timestamp: 'Fecha de modificación',
            },
            title_drawer: 'Lista de interfaces',
            import_rules: 'Importar',
            export_rules: 'Exportar',
            picto_name: 'Vinculación',
          },
          fiche: {
            title: {
              edit: 'Ficha del método dinámico {{code}}',
              new: 'Creación de un nuevo método dinámico',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
            },
            champ_titles: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              syntax: 'Sintaxis',
              dynamic_code: 'Código dinámico',
              keywords: 'Palabras claves',
            },
          },
        },
        fiche: {
          title: {
            edit_title: 'Modificación de un nuevo tercero personalizado',
            view_title: 'Ficha del tercero personalizado',
            new_title: 'Creación de un nuevo tercero personalizado',
            cut_off: 'Cut-Off',
          },
          buttons: {
            back: 'Cancelar',
            save: 'Validar',
            create: 'Validar',
            add: 'Añadir',
          },
          champ_titles: {
            champnom: 'Nombre del campo',
            pays: 'País',
            masque: 'Máscara',
            type_custom: 'Tipo de campo',
            custom_filtre: 'Filtro personalizado en Ficha por valor',
          },
        },
        table: {
          header: {
            title: 'Lista de personalizaciones de terceros',
            new_custom: 'Nuevo',
          },
          columns: {
            name: 'Nombre del campo',
            libelle: 'Texto',
            pays: 'País',
            isvisible: 'Visible',
            isobligatoire: 'Obligatorio',
            taille: 'Tamaño de entrada',
          },
        },
        correspondance: {
          table: {
            title: 'Lista de tablas de consulta',
            columns: {
              code: 'Código',
              nom: 'Nombre',
            },
            title_import_correspondance: 'Añadir correspondencias',
          },
          fiche: {
            title: {
              edit: 'Ficha de la table de consulta {{code}}',
              new: 'Creación de una tabla de consulta',
            },
            champ_titles: {
              code: 'Código',
              name: 'Name',
            },
          },
          fiche_champs: {
            title: {
              edit: 'Ficha de la table de consulta {{entry_val}}',
              new: 'Creación de un detalle de consulta',
            },
            champ_titles: {
              disloq_value: 'Valor de entrada',
              out_value: 'Valor de salida',
              french: 'Francés',
              english: 'Inglés',
            },
          },
          table_champs: {
            title: {
              edit: 'Lista de valores de la table de consulta {{entry_val}}',
              new: 'Creación de un detalle de consulta',
            },
            champ_titles: {
              id: 'Id',
              entry_code: 'Código entrada',
              out_code: 'Código salida',
              libelle: 'Texto',
            },
          },
        },
        email_template: {
          table: {
            title: 'Lista de plantillas',
            columns: {
              name: 'Nombre',
              object: 'Asunto',
              type: 'Tipo',
              update_timestamp: 'Fecha de modificación',
            },
          },
          fiche: {
            title: {
              edit: 'Ficha de la plantilla {{code}}',
              new: 'Creación de una plantilla de notificación',
              body: 'Cuerpo de la plantilla',
            },
            champ_titles: {
              model_name: 'Nombre de la plantilla',
              model_object: 'Asunto de la plantilla',
              webhook_url: 'URL Webhook',
              notification_type: 'Tipo de notificación',
              template_type: 'Tipo de plantilla',
            },
          },
        },
        email_rule: {
          table: {
            title: 'Lista de reglas de notificaciones',
            columns: {
              name: 'Nombre',
              code: 'Código',
              flow: 'Flujo',
              update_timestamp: 'Fecha de modificación',
            },
          },
          fiche: {
            title: {
              edit: 'Modificación de las reglas de notificación: {{code}}',
              new: 'Creaciones de nuevas reglas de notificación',
              conditions: 'Condiciones',
              smartags: 'Destinatarios',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
            },
            champ_titles: {
              code: 'Código',
              name: 'Nombre',
              flow: 'Flujo',
              template: 'Plantilla',
              batch_state: 'Estado lote',
              condition: 'Condición',
              value: 'Valor',
              emails: 'Direcciones de correo',
              smartags_users: 'Smart Tags usuarios',
              smartags_grp_users: 'Smart Tags grupos de usuarios',
              smartags_grp_admins: 'Smart Tags grupo de administradores',
              email: 'Correo electrónico',
            },
          },
        },
        email_report_rule: {
          table: {
            title: 'Lista de estados programados',
            columns: {
              name: 'Nom',
              code: 'Code',
              heure: 'Heure de lancement',
              update_timestamp: 'Date de modification',
              type: 'Tipo',
              mode_envoi: 'Modo envío',
            },
            titleModal: 'Lista de valores',
            execute_imediat: 'Ejecución inmediata',
            columnsMember: {
              name: 'Nombre',
              code: 'Código',
            },
          },
          fiche: {
            title: {
              edit: "Modification de nouvelles règles d'envoi d'états par mail: {{code}}",
              new: "Création de nouvelles règles d'envoi d'états par mail",
              conditions: 'Conditions',
              smartags: 'Destinataires',
              state: 'Tareas',
              connecteur: 'Conector',
              list_valeur: 'Lista de valores',
              titleModal_currency: 'Lista de divisas',
            },
            buttons: {
              back: 'Annuler',
              save: 'Valider',
            },
            champ_titles: {
              code: 'Code',
              name: 'Nom',
              flow: 'Flux',
              template: 'Template',
              type: 'Type',
              condition: 'Condition',
              day: 'Jours',
              treso: 'Etat trésorerie',
              emails: 'Adresses emails',
              smartags_users: 'Smart Tags utilisateurs',
              utilisateur: 'Utilisateurs',
              smartags_grp_admins: "Smart Tags groupe d'administrateurs",
              mond: 'Lundi',
              tues: 'Mardi',
              wed: 'Mercredi',
              thur: 'Jeudi',
              fri: 'Vendredi',
              sat: 'Samedi',
              sund: 'Dimanche',
              user_reference: 'Utilisateur Référent (Langue et Périmètre)',
              heure_lance: 'Heure Lancement',
              email: 'Idioma de envío en los correos electrónicos ingresados',
              reference_user: 'Usuario referente',
              mode_env: 'Modo de envío',
              type_export: 'Tipo',
              placeholder_type: '- Tipo de exportación -',
              interf: 'Interfaz',
              date: 'Fecha',
              user: 'Usuario Referente',
              last_month: 'Mes anterior',
            },
          },
        },
        custom_fields: {
          table: {
            title: 'Lista de máscaras de campo',
            columns: {
              code: 'Código',
              label: 'Texto',
              liste: 'Lista',
              visible: 'Visible',
              obligatory: 'Obligatorio',
              entered_size: 'Tamaño de entrada',
            },
          },
          buttons: {
            new: 'Nuevo Lote',
            delete: '¿Confirma la eliminación',
          },
          fiche: {
            save: 'Validar',
            create: 'Validar',
            creation_title: 'Creación de una nueva máscara de campo',
            edit: 'Ficha de la máscara de campo {{code}}',
            forme: {
              code: 'Código',
              code_label: 'Código de la máscara de campo',
              visible: 'Visible',
              size_forme: 'Tamaño de entrada',
              size_forme_label: 'Tamaño de entrada del campo',
              list: 'Lista',
              fr: 'Francés',
              fr_label: 'Texto de campo de entrada',
              fr_label_txt: 'Texto de ayuda del campo de idioma arriba',
              type_champ: 'Tipo de campo',
              obligatoire: 'Obligatorio',
              edit_saisie: 'Modificable en modo entrada',
              masque: 'Máscara de entrada',
              en: 'Inglés',
              el_placeholder: 'Texto de campo de entrada',
              en_label: 'Texto de ayuda del campo de idioma arriba',
              fr_trad: 'Francés',
              en_trad: 'Inglés',
              es_trad: 'Español',
            },
          },
        },
      },
      audit: {
        auditConnexion: {
          table: {
            header: {
              title: 'Auditoría de conexión ',
            },
            columns: {
              login: 'Login-Código API',
              date: 'Fecha',
              auth: 'Autenticación',
              ipadresse: 'Dirección IP',
              platform: 'Plataforma',
              os: 'OS',
              navigator: 'Tipo navegador',
              version: 'Versión',
            },
          },
        },
        auditService: {
          table: {
            header: {
              title: 'Auditoría de los servicios',
            },
            columns: {
              service: 'Servicios',
              state: 'Estados',
              date: 'Fecha',
              libel: 'Texto',
            },
          },
        },
        hashFile: {
          table: {
            header: {
              title: 'Ficheros importados',
            },
            columns: {
              file_name: 'Nombre del fichero',
              value_hash: 'Hash',
              date: 'Fecha',
              type_file: 'Tipo de fichero',
              user: 'Usuario',
              state: 'Estado',
              user_update: 'Modificado por',
              date_update: 'Fecha de modificación',
            },
            confirm_to_delete:
              '¿Está seguro de que desea eliminar este Hash? Atención, esta acción será irreversible',
          },
        },
        histoApi: {
          table: {
            header: {
              title: 'Llamada API',
              modal_title: 'Visor JSON',
            },
            columns: {
              key: 'Clave',
              method_name: 'Nombre del método',
              date: 'Fecha',
              code_retour: 'Código de retorno HTTP',
              label_retour: 'Etiqueta de devolución',
              param_appel: 'Parámetros',
              body_retour: 'Cuerpo de retorno',
              duree_appel: 'Tiempo de llamada',
            },
            modal: {
              balise: 'Etiqueta',
              value: 'Valor',
            },
          },
        },
        gdpr: {
          title: 'GDPR',
          journaux: 'Registros',
          search_tiers: 'Búsqueda Terceros',
          search_flux: 'Búsqueda Flujos',
          title_tiers: 'Terceros',
          title_flux: 'Lista de Flujos',
          alert_title:
            '¡Atención! Este tratamiento es irreversible. El tercero y todos sus flujos serán anonimizados. ¿Desea continuar?',
          anonym: 'Anonimización',
          placeholder: {
            search: 'Búsqueda de un tercero por código, nombre, IBAN',
          },
          column_tiers: {
            type: 'Tipo',
            code: 'Código',
            name: 'Nombre',
            num_compte: 'No. de cuenta',
            devise: 'Divisa',
            pays: 'País',
            date_modif: 'Fecha de modificación',
          },
          column_flux: {
            num_lot: 'No. lote',
            num_remise: 'No. remesa',
            flux: 'Flujo',
            libele: 'Texto',
            date_operation: 'Fecha de operación',
            state: 'Estado',
            beneficiary_name: 'Beneficiario',
            date_transmission: 'Fecha Transmisión',
          },
        },
        histoFile: {
          table: {
            header: {
              title: 'Programación de las operaciones',
            },
            columns: {
              file_name: 'Nombre archivo',
              code_compte: 'Código cuenta',
              code_society: 'Código empresa',
              code_flux: 'Código flujo',
              amount_total: 'Importe total',
              nb_flux: 'Número flujos',
              date_create: 'Fecha creación lote',
              num_lot: 'No. Lote',
              user: 'Usuario',
              currency: 'Divisa',
              placeholder_flux: '- Flujo -',
              placeholder_type_flux: '- Tipo flujo -',
              state_detail: 'Estado detalle',
            },
          },
        },
        trustedThird: {
          table: {
            header: {
              title: 'Lista de terceros de confianza',
            },
            columns: {
              currency: 'Divisa',
              name: 'Nombre',
              iban: 'IBAN',
              uptade_date: 'Fecha de modificación',
            },
            modal_detail: {
              title: 'Detalle de tercero de confianza',
              desactive_btn: 'Desactivar',
              message_confirm: '¿Desea desactivar este tercero?',
              culumn: {
                average_amount: 'Importe promedio',
                sum_amount: 'Suma de importes',
                total_amount: 'Importe total',
                month_year: 'Año Mes',
                nb_operation: 'Número de operaciones',
                amount_max: 'Importe máximo',
              },
            },
          },
        },
      },
      parametrage: {
        Categories: {
          fiche: {
            title: {
              edit_title: 'Ficha de la categoría',
              view_title: 'Ficha de la categoría {{code}}',
              new_title: 'Creación de una nueva categoría',
              operations: 'Lista de los códigos de operación vinculados',
              flows: 'Lista de los flujos bancarios vinculados',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              new: 'Nuevo',
              create: 'Crear',
              movement: 'Actualización de los Movimientos',
            },
            champ_titles: {
              code: 'Código',
              direction: '',
              libelle: 'Texto',
              default_category: 'Categoría Predeterminada',
            },
            modal: {
              update:
                '¿Desea aplicar la categoría a los movimientos de los códigos de operación seleccionados',
              title: 'Selección de códigos de operación ',
              flow_title: 'Selección de códigos de flujos',
              filters: {
                type: 'Tipo',
              },
            },
          },
          table: {
            header: {
              title: 'Lista de categorías',
              new_category: 'Nuevo',
            },
            columns: {
              code: 'Código',
              libelle: 'Texto',
              date: 'Fecha de modificación',
              default_category: 'Categoría Predeterminada',
            },
          },
        },
        GlobalUser: {
          table: {
            header: {
              title: 'Lista de usuarios de grupos',
              synthese: 'Síntesis permisos de usuario',
              new: 'Nuevo',
            },
            columns: {
              login: 'Login',
              first_name: 'Nombre',
              last_name: 'Apellido',
              email: 'Dirección de correo',
              mobile_number: 'No. móvil',
              date: 'Fecha de modificación',
              interrupteur: 'TOTP',
              totp: 'Tipo de TOTP',
              is_locked: 'Bloqueado',
            },
            error_mes: {
              text: 'Se ha alcanzado el número máximo de usuarios activos permitidos.',
            },
          },
          fiche: {
            title: {
              edit_title: 'Ficha usuario {{name}}',
              add_title: 'Creación de un nuevo usuario',
              message_confirm_initialise:
                '¿Desea reinicializar los parámetros TOTP de este usuario?',
            },
            champ_titles: {
              etat: 'Estado',
              email: 'Dirección de correo',
              login: 'Login',
              firstname: 'Nombre',
              lastname: 'Apellido',
              langue: 'Idioma',
              tel: 'Teléfono',
              fax: 'Fax',
              mobile: 'Móvil',
              recepemail: 'Correo de recepción',
            },
            group_user: {
              title: 'Grupos usuarios',
              name: 'Nombre',
              code: 'Código',
              action: 'Acción',
            },
            alert: {
              pdf_file: 'Importe un archivo en formato pdf',
              file_import: 'Se requiere importar el archivo en formato pdf',
            },
            appareil_connected: {
              title: 'Aparatos conectados',
              name: 'Nombre',
              date1: 'Fecha creación',
              date2: 'Ultima conexion ',
              action: 'Acción',
            },
            document: {
              title: 'Documentos',
              date: 'Fecha',
              doc_name: 'Nombre documento',
              doc_type: 'Tipo documento',
              state: 'Estado',
              date1: 'Fecha inicial',
              date2: 'Fecha final',
              action: 'Acción',
              confirm_delete:
                'Este documento está vinculado a varios mensajes enviados a los bancos. ¿Está seguro de que desea eliminar el documento?',
            },
            errors: {
              phoneNumber: 'El número de teléfono solo debe contener números',
              phoneMinLen:
                'El número de teléfono debe tener al menos 10 dígitos',
              phoneMaxLen:
                'El número de teléfono debe tener como máximo 15 dígitos',
              faxError: 'Fax inválido',
              mobilError: 'Móvil inválido',
            },
          },
        },
        GroupAdmin: {
          fiche: {
            title: {
              edit_title: 'Ficha del grupo de administradores {{name}}',
              view_title: 'Ficha del grupo de administradores {{name}}',
              new_title: 'Creación de un nuevo grupo de administradores',
              member: 'Miembros',
              autorisation: 'Autorizaciones',
              headerTitle: 'Ficha de grupo de administradores',
              createheaderTitle: 'Creación de un nuevo grupo',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              new: 'Nuevo',
              add: 'Añadir',
            },
            champ_titles: {
              code: 'Código',
              name: 'Apellido',
              state: 'Estado',
              prenom: 'Nombre',
              login: 'Login',
              flux: 'Flujo',
              releve: 'Extractos',
              referentiel: 'Repositorio',
              settings: 'Ajustes',
              treatment: 'Procesamientos',
              accounting: 'Contabilidad',
              accounting_export: 'Exportación contable',
              smart_tags: 'Smart Tags',
            },
          },
          table: {
            header: {
              title: 'Lista de grupos de administradores',
              new_groupadmin: 'Nuevo',
            },
            columns: {
              nom: 'Nombre',
              date: 'Fecha de modificación',
              state: 'Estado',
              code: 'Código',
            },
          },
        },
        Label: {
          fiche: {
            title: {
              edit_title: 'Ficha de la etiqueta {{label}}',
              view_title: 'Ficha de la etiqueta {{label}}',
              new_title: 'Creación de una nueva etiqueta',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
            },
            champ_titles: {
              libelle: 'Texto personalizado',
              libelle_origine: 'Texto de origen',
              rubrique_value: 'Valor sección',
              sheet: 'Ficha',
              rubrique: 'Sección',
              color: 'Color',
              add_fiche: 'Añadir ficha',
              add_rubrique: 'Añadir Sección',
              add_color: 'Añadir Color',
            },
            error: {
              err_message: 'Error',
              field_message: 'Campo obligatorio',
            },
          },
          table: {
            header: {
              title: 'Lista de etiquetas',
              new_label: 'Nuevo',
            },
            columns: {
              label: 'Etiqueta',
              date: 'Fecha de modificación',
              rubrique_value: 'Valor sección',
              sheet: 'Ficha',
            },
          },
        },
        Perimetre: {
          fiche: {
            title: {
              edit_title: 'Ficha del alcance {{name}}',
              view_title: 'Ficha del alcance {{name}}',
              new_title: 'Creación de un nuevo alcance',
              member: 'Miembro',
              autorisation: 'Autorización',
              entities_list: 'Lista de entidades',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              new: 'Nuevo',
              create: 'Crear',
            },
            champ_titles: {
              code: 'Código',
              name: 'Apellido',
              state: 'Estado',
              prenom: 'Nombre',
              login: 'Login',
              flux: 'Flujo',
              releve: 'Extractos',
              referentiel: 'Repositorio',
              settings: 'Ajustes',
              treatment: 'Procesamientos',
              accounting: 'Contabilidad',
              accounting_export: 'Exportación contable',
            },
          },
          table: {
            header: {
              title: 'Lista de alcances',
              new_perimetre: 'Nuevo',
            },
            columns: {
              label: 'Texto',
              date: 'Fecha de modificación',
              state: 'Estado',
              code: 'Código',
              first_name: 'Nombres',
            },
          },
        },
        Banques: {
          fiche: {
            title: {
              edit_title: 'Ficha del banco {{name}}',
              view_title: 'Ficha del banco',
              new_title: 'Creación de un nuevo banco',
              cut_off: 'Cut-Off',
              added_cutoff_title: 'Añadir un Cit-off',
              creation_title_banque: 'Creación de un nuevo banco',
              edit_tile_banque: 'Ficha de la cuenta {{name}}',
              tarif: 'Tarifa',
              tarif_modal: 'Seleccionar una tarifa',
              add_tarif_title: ' Añadir una tarifa',
              category: 'Categoría',
              code: 'Código',
              placeholder_category: '- Categoría -',
              message_category: 'La categoría ya existe',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
              add: 'Añadir',
            },
            champ_titles: {
              code: 'Código',
              name: 'Nombre',
              flux: 'Flujo',
              hour: 'Hora',
              exec_condition: 'Condición Ejecución',
              mounthly_fees: 'Tarifa mensual',
              annual_fees: 'Tarifa anual',
              month_annual_fees: 'Mes de tarifa anual',
              movement_commission: 'Comisión de movimiento',
              bank_fees_type: 'Tipo Gastos bancarios',
              type: 'Tipo',
            },
            columns: {
              condition: 'Condición Ejecución',
              hour: 'Hora',
              flow: 'Flujo',
              code: 'Código',
              label: 'Texto',
              tarif: 'Tarifa',
              mois: 'Mes',
              currency: 'Moneda',
            },
            columns_contact: {
              title: 'Contactos',
              name: 'Nombre',
              last_name: 'Apellido',
              phone: 'Teléfono',
              mail: 'Dirección de correo',
              adress: 'Direccion',
              agence: 'Agencia',
              flux: 'Flujos',
              pouvoir: 'Poderes',
              agenceName: 'Nombre Agencia',
            },
          },
          infos_personalise: {
            title: 'Información personal',
            birth_date: 'Fecha de nacimiento',
            birth_country: 'País de nacimiento',
            birth_place: 'Lugar de nacimiento',
            nationality: 'Nacionalidad',
            num_cin: 'Número CIN',
            date_validate_cin: 'Fecha de validación CIN',
          },
          table: {
            header: {
              title: 'Lista de bancos',
              new_bank: 'Nuevo',
              el_authorized: '( Artículos permitidos: {{nombre}} )',
              message_ele_atteint:
                'Se ha alcanzado el número máximo de bancos autorizados',
              el_authorized_treso:
                'Número de cuentas administradas en efectivo: {{nombre}}',
              message_ele_treso:
                'Se ha alcanzado el número máximo de cuentas gestionadas en efectivo',
            },
            columns: {
              name: 'Nombre',
              code: 'Código',
            },
          },
          contact: {
            title: 'Creación de un nuevo contacto',
            title_edit: 'Ficha de un contacto',
            last_name: 'Nombre',
            name: 'Apellido',
            title_civil: 'Tratamiento',
            mail: 'Correo electrónico',
            phone: 'Teléfono',
            fax: 'Fax',
            mobile: 'Móvil',
            contact_agence: 'Contacto agencia',
            contact_Flux: 'Contacto flujo',
            contact_pouvoir: 'Contacto poder',
            title_adress: 'Dirección',
            type_aress: 'Tipo de dirección',
            department: 'Departamento',
            Sub_Departement: 'Subdepartamento',
            street_name: 'Nombre de la calle',
            build_number: 'Número de la calle',
            floor: 'Piso',
            post_box: 'Apartado postal',
            room: 'Habitación',
            town_location_name: 'Lugar',
            post_code: 'Código postal',
            town_name: 'Ciudad',
            country: 'País',
            districtName: 'Distrito',
            districk_name: 'Nombre del distrito',
            country_Sub_Division: 'Región',
            civility: 'Tratamiento',
            error_champ_obligatoire:
              'Por favor complete los campos obligatorios: Nombre, Apellido, Tratamiento, País y Ciudad.',
            error_champ_ville_obligatoire:
              'El nombre de la ciudad es obligatorio',
            name_agence: 'Nombre agencia',
          },
        },
        Filiales: {
          fiche: {
            title: {
              edit_title: 'Ficha de la filial {{code}}',
              new_title: 'Creación de una nueva entidad',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
            },
            champ_titles: {
              code: 'Código',
              name: 'Nombre',
              state: 'Estado',
            },
          },
          table: {
            header: {
              title: 'Lista de entidades',
              new_filiale: 'Nuevo',
            },
            columns: {
              code: 'Código',
              state: 'Estado',
              libelle: 'Texto',
              date: 'Fecha de modificación',
            },
          },
        },
        smarttag: {
          fiche: {
            title: {
              edit_title: 'Modificación de un smart tag',
              view_title: 'Ficha de un smart tag {{code}}',
              new_title: 'Ficha del smart tag',
              add_title: 'Creación de un nuevo smart tag',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
              add: 'Añadir',
            },
            champ_titles: {
              champcode: 'Código',
              color: 'Color',
            },
          },
          table: {
            header: {
              title: 'Lista de SmartTags',
              new_smart: 'Nuevo',
            },
            columns: {
              code: 'Código',
            },
          },
        },
        groupe_tresorerie: {
          fiche: {
            title: {
              edit_title: 'Ficha del grupo tesorería {{name}}',
              view_title: 'Ficha del grupo tesorería {{name}}',
              new_title: 'Creación de un nuevo grupo tesorería',
              companies_member_list: 'Lista de empresas miembros',
              member_list: 'Miembro',
            },
            modal: {
              user_list: 'Selección de usuarios',
              company_list: 'Selección de empresas',
              account_list: 'Selección de cuentas',
              third_party_group_list: 'Selección de grupos de terceros',
            },
          },
          table: {
            title: 'Lista de grupos de tesorerías',
          },
        },
        account_statement: {
          table: {
            title: 'Gestión de los extractos de cuenta',
            etat: '- Estado -',
            search_txt:
              'Buscar una cuenta por código, nombre, número de cuenta, código de empresa, nombre de empresa...',
            headerTitle: {
              etat: 'Estado',
              code: 'Código',
              name: 'Nombre',
              iban: 'IBAN',
              company: 'Empresa',
              solde: 'Saldo',
              devise: 'Divisa',
              date_solde: 'Fecha de saldo',
              nbMvt: 'No. movimientos',
            },
            confirme_update_row: '¿Desea validar su modificación',
            select_cat: 'Selección de códigos operaciones',
            category_code: 'Código Categoría',
          },
          details: {
            title: 'Lista de días de la cuenta',
            reintegration: 'Reintegración de los extractos',
            delete_temp: 'Borrar los extractos provisionales',
            purge: 'Purga completa de los extractos de cuenta',
            all: 'Todo',
            production: 'Producción',
            temp: 'Provisional',
            new_day: 'Nuevo Día',
            delete_day: 'Eliminar el día',
            headerTitle: {
              date_debut: 'Fecha inicial',
              solde_debut: 'Saldo inicial',
              date_fin: 'Fecha final',
              solde_fin: 'Saldo final',
              prod: 'Prod.',
              last_releve: 'Último extracto integrado',
              statements: 'No. operaciones',
              currency: 'Divisa',
              balance_diff: 'Diferencia de saldo',
              mvt_total: 'Total de la jornada',
              create_timestamp: 'Fecha de creación',
              update_timestamp: 'Fecha de modificación',
            },
            confirmNewday: {
              title: 'Ficha extracto',
              txt: 'Sólo puede crear días antes o después de los extractos ya en producción. ¿Qué desea crear?',
              before: 'Antes del',
              after: 'Después del',
              cancel: 'Cancelar',
            },
          },
          new_day_time: {
            alert_date: 'La fecha inicial no debe superar la fecha final',
            valider: 'Validar',
            cancel: 'Cancelar',
            solde_initial: 'Saldo inicial',
            date_initial: 'Fecha inicial',
            solde_final: 'Saldo final',
            date_final: 'Fecha final',
            remove_day_time: '¿Seguro que desea eliminar',
            add_operation: 'Añadir una línea de operación',
            purge_account:
              '¿Seguro que desea purgar los extractos de cuenta de producción de esta cuenta',
            remove_temp:
              '¿Seguro que desea purgar los extractos de cuenta provisionales de esta cuenta',
            headerTitle: {
              libeller: 'Texto',
              operation_date: 'Fecha Operación',
              date_valeur: 'Fecha valor',
              operation_code: 'Código operación',
              num_ecriture: 'No. Asiento',
              exo: 'Exo.',
              montant: 'Importe',
            },
            modalCode: {
              title: 'Selección de los códigos de operación',
              select: 'Seleccionar',
              cancel: 'Cancelar',
              headerTitle: {
                code: 'Código',
                name: 'Nombre',
                sens: 'Sentido',
              },
            },
          },
          modal_add_balance: {
            title: 'Inicialización balance',
            date_initiale: 'Fecha inicial',
            solde_initial_balance: 'Saldo inicial',
          },
        },
        document_type: {
          fiche: {
            title: {
              new_title: 'Creación de un nuevo tipo de documento',
              edit_title: 'Ficha del nuevo tipo de documento {{name}}',
            },
            champ_titles: {
              name: 'Nombre',
              code: 'Código',
              table_type: 'Tipo de tabla',
            },
            table_type: 'Tabla',
          },
          table: {
            title: 'Lista de tipos de documento',
            columns: {
              code: 'Código tipo',
              name: 'Nombre tipo',
              table_type: 'Tipo tabla',
            },
          },
        },
        group_widget: {
          fiche: {
            title: {
              edit_title: 'Ficha del widget group {{code}}',
              view_title: 'Ficha del widget group',
              new_title: 'Ficha del smart tag',
              add_title: 'Creación de un nuevo widget group',
            },
            champ_titles: {
              code: 'Código',
              name: 'Nombre',
              user: 'Selección de usuario',
            },
          },
          table: {
            header: {
              title: 'Lista de Widget Group',
            },
          },
          table_user: {
            title: 'Lista de usuarios',
            champ_titles: {
              champlogin: 'Login',
              champname: 'Nombre',
            },
          },
          table_widget: {
            title: 'Lista de widgets',
            champ_titles: {
              champcode: 'Código',
              champname: 'Nombre',
            },
          },
          modal_widget: {
            title: 'Lista de usuarios',
            champ_titles: {
              champlogin: 'Login',
              champname: 'Nombre',
            },
          },
        },
        settings: {
          fiche: {
            title: {
              foureyes_title: 'Configuración 4 Ojos',
              foureyes_description:
                'Configuración del módulo 4 Ojos (Tablas, Campos, Historial)',
              group_setting_title: 'Configuración grupo',
              group_description: 'Configuración grupo',
              mobile_setting_title: 'Lista de cuentas miembros',
              mobile_description: 'Configuración de autenticaciones de grupo',
              signature_setting_title: 'Configuración Firma',
              signature_description: 'Configuración de la firma EBICS',
            },
            champ_titles_fouryeux: {
              table_name: 'Nombre tabla',
            },
            champ_titles_group: {
              logo: 'Logotipo',
              session: 'Mantener la sesión activa',
              currency: 'Moneda',
              code_swift: 'Código swift',
              ai_choice: 'Elección de IA',
              number_ai_calls: 'llamada AI realizada',
              paid_ai_calls: 'Llamada AI permitida',
              title_card: 'Configuración de IA',
            },
            champ_titles_mobile: {
              mobile: 'Móvil',
              authentication_token_validity:
                'Validez del token de autenticación',
              signature_token_validity: 'Validez del token de firma',
              webservice_restAPI_key: 'Clave API Webservice REST',
              state: 'Estado',
              code: 'Código',
              clientid: 'ClientID',
              modified_date: 'Fecha de modificación',
            },
            champ_titles_security: {
              title_button_active_transaction: 'Activar transacción',
              local_authentication: 'Autenticación local',
              state: 'Estado',
              sisid: 'SIS ID',
              complex: 'Complejo',
              minimum_length: 'Longitud mínima',
              minimum_length_description: 'Longitud mínima de la contraseña',
              validity_period: 'Duración de validez',
              validity_period_description:
                'Duración de validez de la contraseña',
              stored_number: 'Número recordados',
              stored_number_description: 'Número de contraseñas recordadas',
              test_number: 'Número de intentos (0 sin bloqueo)',
              test_number_description:
                'Número de intentos de contraseña antes de bloqueo',
              linkedin_authentication: 'Autenticación Linkedin',
              openidconnect: 'Autenticación OpenIDConnect',
              identifier:
                'Identificador proporcionado en la consola de desarrollador de LinkedIn',
              secret_code:
                'Código secreto proporcionado en la consola desarrollador de LinkedIn',
              urlauth_description:
                'URLAuth proporcionado en la consola desarrollador de LinkedIn',
              urltoken_description:
                'URLToken proporcionado en la consola desarrollador de LinkedIn',
              urlconfig_description: 'URL de configuración OpenIDConnect',
              urlconfig_Allowed_Domain: 'Dominio permitido para OpenIDConnect',
              Label_urlconfig_Allowed_Domain: 'Dominio permitido',
              attributupn: 'Atributo que contiene el UPN',
              number_requested_batch: 'Número de contraseñas recordadas',
              last_date: 'Fecha de la última transacción',
              docusign: 'Firma electrónica de documentos',
              legisway: 'Legisway',
              trustpair: 'Trustpair',
            },
            champ_titles_signature: {
              signature_mode: 'Modo de firma',
            },
            modalkeysapi: {
              title: 'Añadir una clave API',
              state: 'Estado',
              code: 'Código',
              clientid: 'ClientID',
              clientid_description: 'ID de la aplicación cliente',
              clientsecret: 'ClientSecret',
              clientsecret_description:
                'Código secreto proporcionado en la consola ADFS',
              attribut_upn: 'Atributo UPN',
              scope: 'Alcance',
              third: 'Terceros',
              treasury: 'Tesorería',
              import_file: 'Importación de archivos',
              number_requested_batch: 'No. solicitudes por lote',
              service: 'Servicio',
            },
            champ_titles_iban: {
              ibanCom: 'IBAN.COM',
              state: 'Estado',
              email: 'Dirección',
              client: 'Clave API',
            },
            doc_sign: {
              integration_key: 'Clave de integración',
              secret_key: 'Clave secreta',
              userId: 'ID de usuario',
              private_key: 'Clave privada',
              integration_key_desc:
                'Clave de integración proporcionada por la plataforma de firma electrónica',
              secret_key_desc:
                'Clave secreta proporcionada por la plataforma de firma electrónica',
              userId_desc:
                'ID de usuario proporcionado por la plataforma de firma electrónica',
            },
            trustpair: {
              api_token: 'Clave de API',
              api_env: 'Entorno',
              api_type: 'Tipo de API',
            },
            common_fields: {
              initialisation_date: 'Fecha de inicio de la transacción',
              oneshot: 'Ejecución única',
              launch_job: 'Iniciar transacción',
            },
          },
          table: {
            title: 'Configuración general',
            columns: {
              elements: 'elementos',
              foureyes_setup: 'Configuración 4 Ojos',
              group_setting: 'Configuración grupo',
              mobile_setting: 'Configuración móvil',
              security_settings: 'Configuración seguridad',
              signature: 'Firma',
              search: 'Buscar una sección, texto...',
            },
          },
        },
        bank_holiday: {
          title: {
            list_title: 'Lista de días festivos',
            edit_title: 'Cambio en el día festivo de {{code}}',
            view_title: 'Ficha del día festivo {{code}}',
            new_title: 'Crear une nueva día festivo',
          },
          champ_titles: {
            date: 'Día Festivo',
            specific_date: 'Día festivo para un año específico',
          },
        },
        quality: {
          title: {
            list_title: 'Lista de calidad',
            edit_title: 'Editar una calidad {{code}}',
            view_title: 'Fecha de una calidad {{code}}',
            new_title: 'Creación de una nueva calidad',
            fiche_title: 'Fecha de une calidad',
          },
          champ_document: {
            title: 'Lista de etiquetas',
            label: 'Etiqueta',
            langue: 'Idioma',
          },
          modal_add_langue: {
            title_add: 'Agregar una etiqueta',
            title_edit: 'Fecha de una etiqueta',
            error_English: 'Idioma inglés ya agregado',
            error_Fr: 'Idioma francés ya agregado',
            error_Lang: 'Idioma ya agregado',
          },
        },
        power_ebam: {
          table: {
            title: 'Lista de Descripciones de poderes',
            column: {},
          },
          fiche: {
            title: 'Creación de una nueva potencia eBAM',
            title_edit: 'Modificación de una potencia eBAM',
            table_ebam: {
              column: {
                title: 'Código eBAM',
                code: 'Código',
                num_code: 'Código eBAM',
                description: 'Descripción',
                title_modal: 'Seleccionar un código eBAM',
                label_lang: 'Idioma',
                description_attach: 'Descripción del código de familia',
                descri: '',
              },
            },
          },
        },
        ebam: {
          liste: 'Lista de códigos eBAM',
          fiche: {
            title: 'Hoja de códigos eBAM',
            type: 'Type',
            codeNum: 'Código Digital',
            code: 'Código',
            titleRegroupment: 'Agrupamiento',
            regroupement: 'Agrupamiento',
            titleLabelListe: 'Lista de etiquetas',
          },
        },
        rules_account_statement: {
          table: {
            title: 'Lista de Reglas extractos',
            columns: {
              code: 'Código',
              name: 'Nombre',
              flow: 'Flujo',
              category: 'Categoría',
              type: 'Tipo',
              update_timestamp: 'Fecha de modificación',
              state: 'Estado',
            },
          },
          fiche: {
            new_title: 'Ficha de la regla extracto',
            edit_title: ' Ficha de la regla extracto - {{name}}',
            company_liste: 'Lista de empresas',
            bank_title: 'Lista de bancos',
            card: {
              state: 'Estado',
              code: 'Código',
              name: 'Nombre',
              category: 'Categoría',
              type: 'Tipo',
              selection: 'Selección',
              comment: 'Descripción',
              language: 'Idioma',
            },
            critere: {
              title: 'Criterios búsqueda ',
              category: 'Categoría',
              label: 'Texto',
              fourchette_amount: 'Rango importe',
              min: 'Mín',
              max: 'Máx',
              reference: 'Referencia',
              rum: 'RUM',
              inclus_ref: 'Incluido en la lista',
              exclus_ref: 'Excluido de la lista',
              yes: 'Sí',
              no: 'No',
              inclus: 'Incluido',
              exclus: 'Excluido',
              integrate: 'Integrar',
              columns_reference: {
                reference: 'Referencia',
                description: 'Descripción',
                date: 'Fecha',
                user: 'Usuario',
              },
              modal_reference: {
                reference: 'Referencia',
                description: 'Descripción',
                add_ref: 'Añadir una Referencia',
              },
              columns_rum: {
                rum: 'RUM',
                description: 'Descripción',
                date: 'Fecha',
                user: 'Usuario',
              },
              modal_rum: {
                rum: 'RUM',
                description: 'Descripción',
                add_rum: 'Añadir RUM',
              },
            },
            ventilation: {
              title: 'Desglose',
              categorie_ventilation: 'Categoría de desglose',
            },
            columns: {
              code: 'Código',
              name: 'Nombre',
            },
            account_groupe_title: 'Lista de grupos de cuentas',
          },
        },
        custom_report: {
          fiche: {
            comment: 'Comentario',
            date: 'Fecha',
          },
          table: {
            title: 'Lista de comentarios',
            create_comment: 'Creación de comentario',
            update_comment: 'Modificación de comentario',
            columns: {
              comment: 'Comentario',
              user: 'Usuario',
              date: 'Fecha',
              update_timestamp: 'Fecha de modificación',
            },
          },
        },
      },
    },
    treasury: {
      remuneration: {
        personnalise_rates_ref: {
          table: {
            title: 'Lista de tipos de referencia personalizados',
            personnalise_rates_button: 'Tipos personalizados',
            columns: {
              plancher: 'Mínimo',
              name: 'Nombre',
              plancher_rates: 'Tipo Mínimo',
              plafond_rates: 'Tipo Máximo',
              plafond: 'Máximo',
            },
            message_confirm:
              'La fecha ya existe en la tabla, ¿desea continuar?',
            title_modal_rate: 'Lista de tipos de cambio',
            modal: {
              date: 'Fecha de actualización',
              name: 'Nombre',
              cours: 'Tipo de cambio',
              confirmMessage:
                ' ¿Desea actualizar los tipos de cambio a fecha {{date}}? \n Todas las líneas con un valor serán creadas o actualizadas',
            },
          },
          fiche: {
            edit_title: 'Ficha del tipo de referencia personalizado {{name}}',
            new_title: 'Creación de un nuevo tipo de referencia personalizado',
            champ_titles: {
              debut_date: 'Fecha inicial',
              finish_date: 'Fecha final',
              rate_type: 'Tipo de tasa',
              value: 'Valor',
              condition: 'Condición fixing',
              plancher_rates_floor: 'Tipo mínimo - Mínimo',
              plafond_rates_cap: 'Tipo máximo - Máximo',
              plancher_rates: 'Tipo Mínimo',
              plafond_rates: 'Tipo Máximo',
              name: 'Nombre',
              taux_value: 'Tasa Valor',
            },
          },
          cours: {
            title: 'Tasa de cambio {{name}}',
            columns: {
              update_timestamp: 'Fecha de modificación',
              rate: 'Tasa',
            },
            button: {
              update: 'Actualización',
              verify: 'Verificar tasas',
            },
            modal: {
              start_date: 'Fecha inicial',
              end_date: 'Fecha final',
              rate: 'Tasa',
              title: 'Añadir una tasa',
              update: 'Actualizar tasa',
            },
            titleDrawer: 'Lista',
            visu: 'Control de tasas',
            columnsDrawer: {
              date: 'Fecha',
              error: 'Error',
              aucunErreur: 'No se encontró ningún error',
            },
          },
        },
        personnalise_rates: {
          table: {
            title: 'Lista de tipos personalizados',
            columns: {
              name: 'Nombre',
              rates: 'Tipo director',
              rate_marge: 'Tasa/Margen',
              base_calcul: 'Base Cálculo',
              rate_type: 'Tipo Tasa',
              conv: 'Convención',
            },
            button_charg_rate: 'Cargar Tipos de cambio',
          },
          fiche: {
            edit_title: 'Ficha de la tipo personalizado {{name}}',
            new_title: 'Creación de un nuevo tipo personalizado',
            champ_titles: {
              base_calcul: 'Base Cálculo',
              conv: 'Convención',
              type: 'Tipo',
              rate_value: 'Valor ',
              rate_marge: 'Tasa/Margen',
              comment: 'Comentario',
              plancher_rates_floor: 'Tipo mínimo - Mínimo',
              plafond_rates_cap: 'Tipo máximo - Máximo',
              plancher_rates: 'Tipo Mínimo',
              plafond_rates: 'Tipo Máximo',
              name: 'Nombre',
              value_floor_rate: 'Tasa personalizada techo',
              value_rate_cap: 'Tasa personalizada suelo',
            },
            cap_floor_area: 'Mínimo y Máximo en Tasa + Margen',
          },
        },
      },
      quotidienne: {
        forecast: {
          fiche: {
            titles: {
              edit_title: 'Ficha de la previsión {{code}}',
              new_title: 'Creación de una nueva previsión',
              view_title: 'Ficha del formato {{code}}',
              general: 'General',
              characteristics: 'Características',
              date_management: 'Gestión fecha',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
              reconciliation: 'Conciliación',
              realization: 'Forzar la realización',
            },
            champ_titles: {
              account: 'Cuenta',
              label: 'Texto',
              nature: 'Naturaleza',
              amount: 'Importe {{type}}',
              op_date: 'Fecha operación',
              value_date: 'Fecha valor',
              category: 'Categoría',
              num_entry: 'No. Asiento',
              exo: 'Exonerado de comisión de movimiento',
              type: 'Tipo',
              state: 'Estado',
              first_due: 'Primer vencimiento',
              last_due: 'Ultimo vencimiento',
              next_due: 'Fecha próximo vencimiento',
              sequence: 'Periodicidad',
              in_progress: 'No. de previsiones pendientes',
              change: 'débito o crédito',
            },
            realization: {
              title: 'Ficha Previsión',
              message:
                '¿Seguro que desea forzar la realización de la previsión',
            },
            rapprochement: {
              title: 'Conciliación de tesorería',
            },
            modal: {
              title: 'Conciliación de tesorería',
              rappro_prev: 'Previsiones conciliadas',
              rappro_mvt: 'Movimientos conciliados',
              num_mvt: 'Número de movimientos',
              num_prev: 'Número de previsiones',
              amount_mvt: 'Importe de los movimientos',
              amount_prev: 'Importe de las previsiones',
              user: 'Usuario',
              date: 'Fecha',
              number: 'No. de conciliación',
              columns: {
                label: 'Texto',
                ref: 'Referencia',
                category: 'Categoría',
                ope_code: 'Código Op.',
                ope_date: 'Fecha Op.',
                value_date: 'Fecha valor',
                amount: 'Importe',
                curr: 'Div.',
                exo: 'Exo.',
                nature: 'Naturaleza',
                entry_number: 'No. Asiento',
              },
              title_user: 'Auditoría',
              creation_date: 'Fecha de creación',
              user_creation: 'Usuario de creación',
              date_modification: 'Fecha de modificación',
              user_modification: 'Usuario de modificación',
            },
          },
          table: {
            header: {
              title: 'Lista de previsiones',
              mass_update: 'Modificación masa',
              prev_generation: 'Generar Prev. provisional',
              prev_auto: 'Previsión automática',
              import: 'Importar',
              more_action: 'Otro',
              generation: 'Generación de intradías',
              generation_title: 'Lista de intradías',
              generation_btn: 'Generación de previsiones',
            },
            columns: {
              state: 'Estado',
              account: 'Cuenta',
              label: 'Texto',
              num_entries: 'No. Asiento',
              nature: 'Naturaleza',
              category: 'Categoría',
              exo: 'Exo.',
              op_date: 'Fecha de operación',
              value_date: 'Fecha de valor',
              amount: 'Importe',
              currency: 'Divisa',
              type: 'Tipo',
              origin: 'Origen',
              user: 'Usuario',
              update: 'Fecha de modificación',
              creation: 'Creación',
              ref: 'Referencia',
              id_source: 'ID Archivo Origen',
            },
            mass_update: {
              title: 'Modificación en masa de previsiones',
              nature: 'Naturaleza',
              type: 'Tipo',
              value_date: 'Fecha valor',
              t2a: 'Cambiar las previsiones provisionales a activas',
              d2a: 'Cambiar las previsiones eliminadas a activas',
              all2d: 'Cambiar las previsiones a eliminadas',
              j1_update: 'Modificar Valor D+1',
              update: 'Validar',
              close: 'Cancelar',
              category: 'Categoría',
            },
            import: {
              title: 'Importación manual de un extracto',
              model: 'Plantilla de importación',
            },
          },
          automatic: {
            table: {
              header: {
                title: 'Lista de previsiones auto.',
                new: 'Nuevo',
              },
              filters: {
                state: '-Estado-',
              },
              columns: {
                state: 'Estado',
                account: 'Código cuenta',
                label: 'Texto',
                num_entries: 'No. Asiento',
                nature: 'Naturaleza',
                category: 'Categoría',
                exo: 'Exo.',
                start_date: 'Fecha inicial',
                end_date: 'Fecha final',
                next_due_date: 'Fecha vencimiento',
                amount: 'Importe',
                currency: 'Divisa',
                type: 'Tipo',
                num_forecast: 'No. previsiones pendientes',
                user: 'Usuario',
                update: 'Modificación',
              },
            },
            fiche: {
              titles: {
                edit_title: 'Ficha previsión auto. {{code}}',
                new_title: 'Creación de una nueva previsión auto.',
              },
              buttons: {
                generate: 'Generar las previsiones',
              },
              generation: {
                title: 'Generación previsiones',
                message: '¿Desea generar de nuevo previsiones',
              },
            },
          },
          temporary_prev_generation: {
            titles: {
              main_title: 'Gestión de las previsiones provisionales',
              temporary_forecast: 'Previsiones provisionales',
              forecast_to_keep: 'Previsiones a preservar',
              active_forecast: 'Previsiones activas',
              edit_modal: 'Modificación Previsiones a preservar',
            },
            champ_titles: {
              type: 'Tipo',
              value_date: 'Fecha valor',
              label: 'Texto',
            },
            buttons: {
              generate: 'Generar',
            },
            modal: {
              title: 'Lista de previsiones',
              message:
                '¿Desea cambiar a modo activo todas las previsiones provisionales que no tienen previsiones activas comparables',
            },
          },
        },
        cashpooling: {
          title: {
            general: 'Cashpooling',
            position_value: 'Posiciones en Valor',
            flow_proposal: 'Propuestas de flujos de tesorería',
            remove: '¿Desea suprimir el flujo',
          },
          select_grp_compte_cashpooling: 'Grupo de cuentasde cash pooling',
          select_grp_compte_parametrage: 'Grupo de cuentas de configuración',
          buttons: {
            validate: 'Validar las propuestas',
            new: 'Nuevo',
          },
          columns: {
            account: 'Cuenta',
            balance: 'Saldo Antes',
            balance_after: 'Saldo Después',
            value_date: 'Fecha',
            authorized: 'Autorizado',
            currency: 'Divisa',
            date: 'Fecha',
            amount: 'Importe',
            credit_account: 'Cuenta abonada',
            debit_account: 'Cuenta cargada',
          },
          modal: {
            title: {
              new_flow: 'Creación de un nuevo flujo de tesorería',
              edit_flow: 'Modificación de un flujo de tesorería',
            },
            buttons: {
              add: 'Validar',
              close: 'Cancelar',
            },
            placeholder: {
              nature: '- Naturaleza -',
              label: 'Texto automático si vacío',
            },
            champ_titles: {
              debit_account: 'Cuenta cargada',
              credit_account: 'Cuenta abonada',
              label: 'Texto',
              current_account: 'Cuenta corriente',
              debit_nature: 'Naturaleza Debe',
              credit_nature: 'Naturaleza Haber',
              amount: 'Importe',
              value_date: 'Fecha valor',
              error_devise_compte:
                'Por favor seleccione cuentas de la misma divisa.',
            },
          },
          flow_list_placeholder: '-Flujo de tesorería por defecto-',
        },
        historique: {
          title: {
            general: 'Historial de conciliaciones de Tesorería',
            bank_mvt: 'Movimientos bancarios conciliados',
            prov: 'Previsiones conciliadas',
            detail_mvt: 'Conciliación - Detalle',
          },
          buttons: {
            show_details: 'Visualización Detalle',
            show_sessions: 'Visualización Sesión',
          },
          filters: {
            account: 'Cuenta',
            rappro_date: 'Fecha Conciliación',
            value_date: 'Fecha valor',
            group: 'Grupo',
          },
          columns: {
            account: 'Cuenta',
            category: 'Cat.',
            date: 'Fecha Val.',
            label: 'Texto',
            amount: 'Importe',
          },
          alert: {
            rappro_session: 'Ninguna desconciliación a realizar',
          },
          modal: {
            title: {
              session_list: 'Lista de sesiones',
            },
            columns: {
              date_num: 'Fecha/Num',
              user: 'Usuario',
              value_date_movement: 'Fecha Mvto.',
              value_date_prev: 'Fecha Prev.',
              category: 'Cat.',
              nature: 'Naturaleza',
              label: 'Texto',
              amount: 'Importe',
              number: 'No.',
              nb_mvt: 'Nº movimiento',
              nb_prevision: 'Nº previsión',
            },
            groups: {
              mvts: 'Movimientos a conciliar',
              prevs: 'Previsiones a conciliar',
            },
            buttons: {
              visualize: 'Visualizar',
              dereconciliation: 'Desconciliar',
            },
          },
        },
        research: {
          table: {
            header: {
              title: 'Lista de búsquedas',
              load_search: 'Iniciar búsqueda',
            },
            filters: {
              account_group: 'Grupos de cuentas',
              account: 'Cuentas',
              amount_min: 'De',
              amount_max: 'A',
            },
            columns: {
              state: 'Estado',
              account: 'Cuenta',
              label: 'Texto',
              reference: 'Referencia',
              nature: 'Naturaleza',
              category: 'Categoría',
              op_date: 'Fecha op.',
              value_date: 'Fecha Valor',
              amount: 'Importe',
              currency: 'Divisa',
              type: 'Tipo',
              entry_number: 'No. Asiento',
              nature_code: 'Código de naturaleza',
              integration_date: 'Fecha de integración',
            },
            ventilation: {
              title: 'Desglose',
              nature: 'Naturaleza',
              label: 'Texto',
              amount: 'Importe',
              total: 'Total',
              gap: 'Diferencia',
            },
            mass_update: {
              title: 'Modificación masa',
              message:
                '¿Desea cambiar el código de naturaleza y/o la categoría de los elementos seleccionados?',
            },
            visualisation: {
              headers: {
                detail: 'Detalle de la operación',
                treasury_rappro: 'Conciliación tesorería',
                accounting_rappro: 'Conciliación contable',
              },
              columns: {
                compte: 'Cuenta',
              },
            },
          },
        },
        ventilation: {
          title: {
            general: 'Desglose de Tesorería',
          },
          buttons: {
            show_ventilate_manual: 'Desglose Manual',
            show_ventilate_automatic: 'Desglose Reglas',
          },
          columns: {
            account: 'Cuenta',
            category: 'Categoría',
            date: 'Fecha Valor',
            label: 'Texto',
            amount: 'Importe',
            compte: 'Cuenta',
            devise: 'Divisa',
          },
          modal: {
            title: {
              general: 'Movimientos a conciliar',
              ventilate: '- Naturaleza -',
              error_nature_not_selected:
                'Por favor seleccione un código de naturaleza',
            },
            columns: {
              value_date_movement: 'Fecha Mvto.',
              category: 'Cat.',
              nature: 'Naturaleza',
              label: 'Texto',
              amount: 'Importe',
              number: 'No.',
            },
            buttons: {
              ventilate: 'Desglosar',
            },
          },
        },
        value: {
          title: {
            general: 'Visualización dela ficha en valor',
            state_items: 'Lista de estados',
            unfold_nodes: 'Desplegar todos los nodos',
            search_items: 'Búsqueda',
          },
          buttons: {
            sheet_in_value: 'Ficha en Valor',
          },
          columns: {
            groups: '-Grupos-',
            company: '- Empresa -',
            bank: '- Banco -',
            currency: '- Divisa -',
            country: '- País -',
            state: '-Estados -',
          },
          modal: {
            title: {
              value_sheet: 'Ficha Valor',
              details: 'Detalle del día',
            },
            footer: {
              debit: 'Total debe',
              credit: 'Total haber',
              daily: 'Total día',
            },
          },
        },
        reconciliation: {
          headers: {
            title: 'Conciliación de tesorería',
            details: 'Conciliación de tesorería - Detalle',
            accounts: 'Cuentas',
            viewType: 'Vista',
          },
          inputs: {
            total_movements: 'Total Movimientos',
            gap: 'Diferencia',
            total_forecasts: 'Total Previsiones',
            number: 'No.',
            confirmTxt: 'Hay una diferencia. ¿Valida la conciliación',
            confirmTitle: 'Conciliación',
          },
          cards: {
            movements: 'Movimientos bancarios a conciliar',
            rappro: 'Conciliación',
            forecasts: 'Previsiones a conciliar',
          },
          buttons: {
            manual: 'Ejecutar las reglas manuales',
            next_account: 'Cuenta siguiente',
            montant: 'Importe 1/1',
            montantNN: 'Importe N/N',
            reconcile: 'Conciliar',
          },
          columns: {
            selected: 'Sel.',
            category: 'Categoría',
            value_date: 'Fecha valor',
            label: 'Texto',
            amount: 'Importe',
            account: 'Cuenta',
            state: 'Estado',
            balanced: 'Equilibrado',
            unbalanced: 'No equilibrado',
          },
          message: {
            all_treated: 'Todas las cuentas han sido procesadas',
          },
        },
      },
      reporting: {
        analyse: {
          title: 'Análisis de los códigos naturaleza/categoría',
          filters: {
            groups: 'Grupos',
          },
          buttons: {
            validate: 'Mostrar',
          },
          columns: {
            year: 'Año',
            january: 'Enero',
            february: 'Febrero',
            march: 'Marzo',
            april: 'Abril',
            may: 'Mayo',
            june: 'Junio',
            july: 'Julio',
            august: 'Agosto',
            september: 'Septiembre',
            october: 'Octubre',
            november: 'Noviembre',
            december: 'Diciembre',
          },
        },
        analyseSolde: {
          title: 'Análisis de Saldos',
          filters: {
            groups: 'Grupos',
            company: 'Empresas',
            year: 'Años',
          },
          buttons: {
            validate: 'Mostrar',
          },
          column: {
            societe: 'Empresas',
            january: 'Enero',
            february: 'Febrero',
            march: 'Marzo',
            april: 'Abril',
            may: 'Mayo',
            june: 'Junio',
            july: 'Julio',
            august: 'Agosto',
            september: 'Septiembre',
            october: 'Octubre',
            november: 'Noviembre',
            december: 'Diciembre',
          },
        },
      },
      settings: {
        natural_code: {
          table: {
            title: 'Lista de los códigos Naturaleza',
            columns: {
              code: 'Código',
              name: 'Nombre',
              exo: 'Exo.',
              sense: 'Sentido',
              category: 'Categoría',
              update_timestamp: 'Fecha modificación',
            },
            btn_grp_account: 'Grupo de códigos de naturaleza',
          },
          fiche: {
            title: {
              edit_title: 'Ficha del Código Naturaleza {{code}}',
              new_title: 'Creación de un nuevo Código Naturaleza',
              organization: 'Organización',
            },
            champ_titles: {
              type: 'Tipo',
              code: 'Código',
              name: 'Nombre',
              sense: 'Sentido',
              level: 'Nivel',
              grouping: 'Combinación',
              order: 'orden',
              category: 'Categoría',
              exo: 'Exonerado de comisión de movimiento',
            },
          },
          groupe_code_nature: {
            title: 'Grupos de códigos de naturaleza',
            title_modal_membre: 'Selección de grupo de códigos de naturaleza',
            sens: 'Sentido',
            champs: {
              code: 'Código',
              name: 'Nombre',
              date_create: 'Fecha de creación',
              comment: 'Comentario',
              title_fiche: 'Ficha del grupo de códigos de naturaleza {{code}}',
            },
          },
        },
        account_group: {
          table: {
            title: 'Lista de Grupos de Cuentas',
            columns: {
              code: 'Código',
              name: 'Nombre',
              state: 'Estado',
              update_timestamp: 'Fecha modificación',
            },
            buttons: {
              type_new: 'Nuevo Tipo',
            },
            error_devise:
              'Ha seleccionado líneas que contienen divisas diferentes',
          },
          fiche: {
            title: {
              edit_title: 'Ficha del Grupo de Cuentas {{code}}',
              new_title: 'Creación de un nuevo Grupo de Cuentas',
              new_title_type: 'Creación de un nuevo Tipo de Grupo de Cuentas',
              member: 'Lista de miembros',
              nb_selected: '(Número de miembros seleccionados: {{nb}})',
              nbs_selected: '(Número de miembros seleccionados: {{nb}})',
              edit_type_title:
                'Modificación de una ficha de tipo de grupo de cuentas - {{code}}',
            },
            champ_titles: {
              type: 'Tipo',
              code: 'Código',
              name: 'Nombre',
              cashpool_level: 'Nivel de cashpooling',
              description: 'Descripción',
              state: 'Estado',
              sub_type: 'Subtipo',
              devise: 'Moneda de la autorización de descubierto',
              group_decouvert: 'Autorización de descubierto del grupo',
              add_decouvert: 'Monto',
              title_modal_add_decouvert: 'Agregar autorización de descubierto',
              generation_mode: 'Modo de generación',
              label_virement_society:
                'Descripción de transferencia intra-empresa',
              label_virement_group: 'Descripción de transferencia intra-grupo',
              label_virement_account:
                'Descripción de transferencia de Cuenta Corriente',
              account_credit_code: 'Código de cuenta de crédito',
              account_credit_name: 'Nombre de cuenta de crédito',
              account_debit_code: 'Código de cuenta de débito',
              account_debit_name: 'Nombre de cuenta de débito',
              flow: 'Flujo predeterminado',
            },
            buttons: {
              add_account_group: 'Añadir un grupo de cuenta',
            },
            columns: {
              code: 'Código',
              name: 'Nombre',
              state: 'Estado',
              code_name: 'Código-Nombre',
              iban: 'IBAN',
              company: 'Empresa',
              rounding: 'Redondeo',
              currency: 'Divisa',
              amount: 'Saldo meta',
              pivot: 'Cuenta central',
              member_decouvert: 'Autorización de descubierto',
            },
          },
          modal: {
            title: {
              account: 'Selección de cuentas bancarias',
              account_group: 'Selección de grupos de cuentas',
              update: 'Modificación del grupo de cuenta',
            },
            choice: {
              nope: 'No',
              yes: 'Sí',
            },
            buttons: {
              add: 'Añadir',
              close: 'Cancelar',
            },
            champ_titles: {
              pivot: 'Cuenta central',
              amount: 'Umbral',
              arounding: 'Redondeo',
            },
          },
        },
        reports: {
          table: {
            title: 'Lista de Estados de tesorería',
            columns: {
              code: 'Código',
              name: 'Nombre',
              update_timestamp: 'Fecha modificación',
            },
          },
          fiche: {
            title: {
              edit_title: 'Ficha del Formato {{code}}',
              new_title: 'Creación de un nuevo Estado',
              member: 'Lista de miembros',
              fiche: 'Características',
              fiche_zoom: 'Características Zoom',
              diffusion: 'Difusión',
            },
            champ_titles: {
              type: 'Tipo',
              code: 'Código',
              name: 'Nombre',
              selection: 'Selección',
              period_type: 'Tipo Periodo',
              period: 'Periodo',
              unit: 'Unidad',
              forecast: 'Previsión',
              category: 'Categoría',
              nature: 'Naturaleza',
              min_amount: 'Importe Min.',
              max_amount: 'Importe Máx.',
              label: 'Texto',
              mode: 'Modo',
              mail_adress: 'Direcciones de correo',
              user_smart_tag: 'Smart Tags usuarios',
              user_groupsmart_tag: 'Smart Tags grupo de usuarios',
              detail: 'Detalle',
              ecart: 'Diferencia',
              elem: 'Elemento',
            },
            columns: {
              code: 'Código',
              name: 'Nombre',
            },
          },
          modal: {
            title: 'Selección de miembros',
            buttons: {
              add: 'Añadir',
              close: 'Cancelar',
            },
          },
        },
        treasury_rules: {
          table: {
            title: 'Lista de Reglas de tesorería',
            columns: {
              code: 'Código',
              name: 'Nombre',
              auto: 'Auto/Manual',
              ordre: 'Orden',
              update_timestamp: 'Fecha modificación',
              state: 'Estado',
              category: 'Categoría',
              releve: 'Sobre Extracto',
              prevision: 'Sobre Previsión',
              flux: 'Sobre Flujo',
            },
          },
          fiche: {
            title: {
              edit_title: 'Ficha de la Regla de tesorería {{code}}',
              new_title: 'Creación de un nuevo Grupo de Cuentas',
              new_title_type: 'Creación de un nuevo Tipo de Grupo de Cuentas',
              new_rule_title: 'Creación de una nueva Regla',
              member: 'Lista de miembros',
              criteria_reconciliation: 'Criterios Conciliación',
              member_selection: 'Seleccionar miembros',
            },
            champ_titles: {
              type: 'Tipo',
              code: 'Código',
              name: 'Nombre',
              category: 'Categoría',
              selection: 'Selección',
              mode: 'Modo',
              execution_order: 'Orden de ejecución',
              cashpool_level: 'Nivel de cashpooling',
              description: 'Descripción',
              state: 'Estado',
              deviation_allowed: 'Diferencia autorizada',
              rappro_number: 'Conciliación por Número de documento',
              ecart_autorise: 'Diferencia autorizada',
              nature: 'Naturaleza',
              libelle: 'Texto',
              placeholder_category: 'Introducir el Código Categoría',
              placeholder_selection: '- Selección -',
              placeholder_gap: 'Diferencia en el importe autorizada',
              placeholder_rule_code: 'Código de la regla',
              placeholder_rule_name: 'Nombre de la regla',
              placeholder_montant_autorise:
                'Diferencia en el importe autorizada',
              placeholder_libelle: 'Contiene el texto',
              applique_releve: 'A aplicar en los extractos',
              applique_temporaire: 'A aplicar en las previsiones temporales',
              applique_flux: 'A aplicar en los flujos',
              flux: 'Flujo',
              ventilation: 'Criterios de Distribución',
            },
          },
        },
        etablish_externe: {
          table: {
            title: 'Lista de establecimientos externos',
            button_account_title: 'Cuentas bancarias',
            columns: {
              etablish_name: 'Establecimiento',
            },
          },
          fiche: {
            title: 'Creación de un nuevo establecimiento externo',
            titleEdit: 'Ficha del establecimiento externo {{name}}',
          },
        },
        etablish_externe_compte: {
          table: {
            title: 'Lista de cuentas bancarias de establecimientos externos',
            columns: {
              etablish_name: 'Establecimiento',
            },
          },
          fiche: {
            title: 'Creación de una nueva cuenta externa',
            titleEdit: 'Ficha de la cuenta {{name}}',
          },
        },
      },
      currentAccount: {
        Liste: {
          fiche: {
            titles: {
              edit_title: 'Ficha de la cuenta corriente {{code}}',
              new_title: 'Creación de una nueva cuenta corriente',
              view_title: 'Ficha de la cuenta corriente',
              characteristics: 'Características',
              rate_management: 'Gestión de tasas',
              interest_management: 'Gestión de los intereses',
              cashpool: 'CashPool bancario',
              billing: 'Facturación',
              agiosManagement: 'Gestión de Agios',
              flow_management: 'Flujos',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
            },
            champ_titles: {
              p_company: 'Empresa matriz',
              c_company: 'Filial',
              type: 'Tipo',
              name: 'Nombre',
              start_date: 'Fecha inicial',
              end_date: 'Fecha final',
              cashpool_management: 'Gestión del CashPool',
              state: 'Estado',
              currency: 'Divisa',
              interest_management: 'Gestión de los intereses',
              value_date: 'Fecha de valor',
              p_account: 'Cuenta empresa matriz',
              c_account: 'Cuenta filial',
              credit_note: 'Nota de crédito',
              debit_note: 'Nota de débito',
              invoice_counter: 'Contador factura',
              banking_cashpool:
                'Subida de los movimientos bancarios en la cuenta corriente',
              email: 'Correos electrónicos',
              inmail_facturation: 'Facturación por correo electrónico',
              facturation_ref: 'Referencia facturación',
            },
            table_rate: {
              title: 'Selección',
              name: 'Nombre',
              margin: 'Margen',
              margin_rate: 'Margen/Tasa',
              basis: 'Base',
              fix_var: 'Fijo/Var.',
              start_date: 'Fecha inicial',
              end_date: 'Fecha final',
              debit: 'Debe',
              credit: 'Haber',
            },
            table_account: {
              title: 'Selección de cuentas bancarias',
              state: 'Estado',
              name: 'Código-Nombre',
              iban: 'IBAN',
              company: 'Empresa',
              bank: 'Banco',
              category: 'Categoría',
              label: 'Texto',
              sense: 'Sentido',
              start_date: 'Fecha inicial',
            },
            modal_rate: {
              title: 'Modificación del vínculo de la tasa',
              start_date: 'Fecha inicial',
              end_date: 'Fecha final',
              debtor: 'Tipo de interés deudor',
              creditor: 'Tipo de interés acreedor',
              floor: 'Monto mínimo',
              cap: 'Monto máximo',
            },
            modal_account: {
              title: 'Modificación del vínculo de la cuenta',
              category: 'Categoría buscada',
              label: 'Texto buscado',
              inverse_sign: 'Revertir el sentido del movimiento',
              start_date: 'Fecha inicial',
              value_date: 'Selección fecha',
            },
            info_modal: {
              title: 'Lista de palabras claves',
              label: {
                now: '<DATE>',
                year: '<DATEQUANTIEME>',
                hour1: '<HEURE>',
                hour2: '<HEURE_LONG>',
                p_company: '<CODESOCIETE_MERE>',
                c_company: '<CODESOCIETE_FILLE>',
                name: '<NOM>',
              },
              value: {
                now: 'Fecha del día formato AAMMDD',
                year: 'Año en 2 caracteres seguido de la fecha',
                hour1: 'Hora en formato HHMMSS',
                hour2: 'Hora en formato HHMMSSCCC',
                p_company: 'Código de la empresa matriz',
                c_company: 'Código de la filial',
                name: 'Nombre de la cuenta corriente',
              },
            },
          },
          table: {
            header: {
              title: 'Lista de cuentas corrientes',
              new_account: 'Nuevo',
              confirme_purge:
                'Va a purgar los extractos de las cuentas corrientes seleccionadas. ¡Atención! Esta operación es definitiva. ¿Desea continuar?',
              purge: 'Purgar',
            },
            filters: {
              state: '-Estado-',
              type: '-Tipo',
            },
            searchInput: {
              caption:
                'Buscar una cuenta corriente por código, nombre o sociedad',
            },
            columns: {
              state: 'Estado',
              name: 'Nombre de la cuenta corriente',
              parent_company: 'Empresa matriz',
              child_company: 'Filial',
              type: 'Tipo',
              balance: 'Saldo',
              currency: 'Divisa',
              end_date: 'Fecha de saldo',
              date: 'Fecha de modificación',
              credit_rate: 'Tasas de crédito',
              debit_rate: 'Tasa Débit',
              periode: 'Periodo de cálculo',
            },
            button: {
              history: 'Historial',
              statement: 'Extracto',
            },
          },
          releve: {
            header: {
              title: 'Visualización del extracto de cuenta corriente {{name}}',
              addfile: 'Importar',
              modal: 'Detalle de la operación',
              import: 'Importación de un extracto de cuenta corriente',
            },
            fields: {
              label: 'Texto de la operación',
              amount: 'Importe',
              valueDate: 'Fecha de valor',
            },
          },
          history: {
            header: {
              title: 'Historial de la cuenta corriente {{name}}',
            },
            columns: {
              label: 'Texto',
              start_date: 'Fecha inicial',
              end_date: 'Fecha final',
              amount: 'Importe',
              currency: 'Divisa',
            },
            modal: {
              title: 'Visualización del cálculo de intereses',
              start_date: 'Fecha de inicio del periodo ',
              num_days: 'No. días ',
              position: 'Posición',
              rate: 'Tasa',
              debtor_interest: 'Interés deudor',
              creditor_interest: 'Interés acreedor',
            },
          },
        },
        Calculation: {
          table: {
            header: {
              title: 'Cálculo de cuentas corrientes',
              calculate: 'Ejecutar el cálculo',
            },
            filters: {
              type: '-Tipo',
            },
            columns: {
              name: 'Nombre de la cuenta corriente',
              parent_company: 'Empresa matriz',
              child_company: 'Filial',
              type: 'Tipo',
            },
            modal: {
              title: 'Cálculo de la cuenta corriente',
              month_end_calculation: 'Cálculo de final de mes',
              calculate: 'Calcular',
              close: 'Cancelar',
              errorMessage: 'Indique la fecha inicial y final',
              period: 'Período de cálculo',
              last_balance_date:
                'Fecha del último saldo (para cálculo avanzado)',
              last_rate_date: 'Fecha de la última tasa (para cálculo avanzado)',
            },
          },
        },
        AccountRemunerer: {
          table: {
            header: {
              title: 'Lista de cuentas remuneradas',
              new_account: 'Nuevo',
            },
            filters: {
              state: '-Estado-',
              type: '-Tipo',
            },
            searchInput: {
              caption:
                'Buscar una cuenta remunerada por código, nombre o empresa',
            },
            columns: {
              state: 'Estado',
              name: 'Nombre de la cuenta',
              etab: 'Institución',
              company: 'Empresa',
              credit_rate: 'Tasa de crédito',
              balance: 'Saldo',
              currency: 'Divisa',
              end_date: 'Fecha del saldo',
              date: 'Fecha de modificación',
            },
            button: {
              history: 'Historia',
              statement: 'Declaración',
            },
          },
          fiche: {
            new_title: 'Ficha de cuenta remunerada',
            edit_title: 'Cuenta remunerada {{code}} ficha',
            titles: {
              characteristics: 'Características',
              rate_management: 'Gestión de tasas',
              interest_management: 'Gestión de intereses',
              agiosManagement: 'Gestión de agios',
              flow_management: 'Flujo',
              cashpool: 'CashPool bancario',
              billing: 'Facturación',
            },
            champ_titles: {
              p_company: 'Entidad financiera',
              c_company: 'Empresa',
              name: 'Nombre',
              start_date: 'Fecha de inicio',
              end_date: 'Fecha final',
              state: 'Estado',
              currency: 'Divisa',
              interest_management: 'Gestión de intereses',
              value_date: 'Fecha valor',
              p_account: 'Cuenta empresa matriz',
              c_account: 'Cuenta filial',
              credit_note: 'Nota de crédito',
              debit_note: 'Nota de débito',
              invoice_counter: 'Contador factura',
              banking_cashpool:
                'Subida de los movimientos bancarios en la cuenta corriente',
              email: 'Correos electrónicos',
              inmail_facturation: 'Facturación por correo electrónico',
              facturation_ref: 'Referencia facturación',
              interest: 'Interés',
              modeCalcul: 'Modo de cálculo',
              compteSocieter: 'Cuenta de la empresa',
              remote: 'Transferencia de movimientos bancarios a la cuenta',
            },
            compl_fields: {
              first_interest_date: 'Fecha del primer interés',
              init_stmt_btn: 'Inicializar estado',
              init_amount: 'Saldo inicial',
              confirm_purge:
                'Esta cuenta ya tiene estados.\n¿Desea eliminarlos todos?\n\nAtención: esta acción es irreversible.',
            },
          },
          visualisation: {
            title: 'Ver extracto de la cuenta remunerada {{name}} ',
            columns: {
              label: 'Etiqueta',
              complementary_label: 'Etiqueta complementaria',
              reference: 'Referencia',
              tiers: 'Tercero',
              document_number: 'Documento N°',
              category: 'Categoría',
              transaction_code: 'Código',
              operation_date: 'Fecha de la operación',
              value_date: 'Fecha valor',
              debit: 'Débito',
              credit: 'Crédito',
              currency: 'Divisa',
              devise: 'Moneda',
            },
          },
        },
        AccountCapital: {
          table: {
            header: {
              title: 'Lista de contratos de capitalización',
              new_account: 'Nuevo',
            },
            searchInput: {
              caption:
                'Buscar un contrato de capitalización por código, nombre o empresa',
            },
            columns: {
              name: 'Nombre del contrato de capitalización',
              rate: 'Tasa',
              date: 'Fecha de inicio',
              end_date: 'Fecha final',
              state: 'Estado',
              etab: 'Establecimiento',
              company: 'Compañía',
              balance: 'Saldo',
              currency: 'Moneda',
              date_modification: 'Fecha de modificación',
            },
            filters: {
              state: '-Estado-',
              type: '-Tipo-',
            },
            button: {
              history: 'Historial',
              statement: 'Estado de cuenta',
            },
          },
          fiche: {
            new_title: 'Ficha de contrato de capitalización',
            edit_title: 'Contrato de capitalización {{code}} ficha',
            champ_titles: {
              liq: 'Liquidez',
            },
          },
          visualisation: {
            title: 'Ver estado del contrato de capitalización',
          },
        },
        Analyse: {
          balance_title: 'Saldos de cuentas corrientes',
          analysis_title: 'Análisis de cuentas corrientes',
          header: {
            balance_date: 'Fecha de saldo',
            interest_date: 'Período de intereses',
          },
          columns: {
            debit: 'Condición de la empresa prestataria',
            credit: 'Condición de la empresa prestamista',
            provision_interest: 'Interés provisionado',
            final_interest: 'Interés final',
            current_account: 'Cuentas corrientes',
          },
        },
      },
      evenement: {
        listes: {
          title: 'Lista de eventos',
          fiche: {
            title_fiche: 'Ficha del evento {{label}} No. {{number}}',
            title_cache: 'Transferencias de Cash Pooling',
            title_compte: 'Intereses de las cuentas corrientes',
            title_echeance: 'Pago vencimiento',
            title_placement: 'Inversión',
            imprime: 'Imprimir',
            champs: {
              type: ' Tipo',
              sub_type: 'Subtipo',
              etat: 'Estado',
            },
            modal: {
              title: 'Modificación del cálculo',
              amount: 'Importe',
              date: 'Fecha',
              batch_warning:
                'IMPORTANTE: El flujo está presente en el libro de firmas, por favor, elimínelo del lote.',
            },
            culumns: {
              name: 'Nombre',
              emetter: 'Emisor',
              benefic: 'Beneficiario',
              amount: 'Importe',
              devise: 'Divisa',
              etat: 'Estado',
              date: 'Fecha',
            },
            generate_entries: 'Generación asientos',
            validate_entries: 'Validar',
            archivage: 'Realizar',
            envoi_mail: 'Enviar por correo electrónico',
            msg_confirm_mail:
              '¿Desea enviar el estado por correo electrónico? ',
          },
        },
        liste: {
          table: {
            title: 'Lista de tipos de referencia personalizados',
            columns: {
              event_num: 'No. Evto.',
              type: 'Tipo',
              sub_type: 'Subtipo',
              libelle: 'Texto',
              nb: 'No.',
              amount: 'Importe',
              currency: 'Divisa',
              state: 'Estado',
              date: 'Fecha de creación',
              login: 'Login',
            },
          },
          fiche: {
            edit_title: 'Ficha del tipo de referencia personalizado {{name}}',
            new_title: 'Creación de un nuevo tipo de referencia personalizado',
            champ_titles: {},
          },
        },
      },
      debt: {
        list: {
          title: {
            credit_line: 'Lista de líneas de crédito',
          },
          columns: {
            name: 'Nombre',
            type: 'Tipo',
            lender_company: 'Empresa Prestamista',
            borrowing_company: 'Empresa Prestataria',
            currency: 'Divisa',
            amount: 'Importe',
            available_amount: 'Importe disponible',
            state: 'Estado',
            start_date: 'Fecha inicial',
            end_date: 'Fecha final',
          },
          buttons: {
            delete: 'Eliminar',
            addTirage: 'Nuevo',
            btn_paiement: 'Pago de vencimientos',
          },
        },
        detail: {
          drawer: {
            title: 'Detalle del vencimiento',
            champ_titles: {
              state: 'Estado',
              timeline: 'Vencimiento',
              start_date: 'Fecha Inicio',
              end_date: 'Fecha Fin',
              payment_date: 'Fecha Pago',
              timeline_date: 'Fecha Vencimiento',
              capital_amount_paid: 'Importe Capital abonado o reembolsado',
              capital: 'Importe Capital',
              interests_amount: 'Importe Interés',
              capital_interests: 'Capital Intereses',
              flow: 'Flujo',
              compte_mere: 'Cuenta madre de la empresa',
              compte_fils: 'Cuenta hija de la empresa',
            },
            buttons: {
              save_continue: 'Validar - Siguiente',
            },
            card_payement: 'Pago',
          },
          modal: {
            title: 'Nuevo',
            change_date: 'Cambiar la fecha del primer vencimiento',
            alert:
              '¿Desea añadir un vencimiento después del vencimiento seleccionado? Se desplazarán todos los vencimientos siguientes',
            buttons: {
              yes: 'sí',
              no: 'no',
            },
          },
          columns: {
            timeline_number: 'No. Vto.',
            period: 'Periodo',
            description: 'Descripción',
            number_day: 'No. Día',
            timeline_date: 'Fecha Vencimiento',
            payment_date: 'Fecha Pago',
            capital: 'Capital',
            k_movement: 'Movimiento K',
            interests: 'Intereses',
            accumulated_interest: 'Intereses acumulados',
            remaining_capital: 'Capital Pendiente',
            due_amount: 'Vencimiento',
            state: 'Estado',
          },
          title: 'Visualización del calendario de vencimientos {{name}}',
          buttons: {
            add: 'Añadir',
            calcul: 'Ejecutar el cálculo de intereses',
            calculInteret: 'Calcular vencimientos',
            calculEchues: 'Calcular vencimientos no vencidos',
            calculEcheances: 'Calcular todos los vencimientos',
            mes1: '¿Está seguro de que desea realizar el cálculo de los vencimientos no vencidos?',
            mes2: '¿Está seguro de que desea realizar el cálculo de TODOS los vencimientos?',
            mes3: '¿Está seguro de que desea reemplazar TODOS sus vencimientos con el archivo seleccionado',
            mes4: '{{errorMessage}}\n ¿Desea continuar de todos modos',
          },
          titleCalculInt: 'Cálculo de intereses',
          msgCalcul:
            '¿Está seguro de que desea realizar el cálculo de intereses?',
        },
        fiche: {
          title: {
            timeline: {
              new: 'Creación de un nuevo vencimiento',
              edit: 'Ficha de la Deuda {{name}}',
              renew: 'Renovación del objeto Deuda {{name}}',
            },
            echeance: {
              new: 'Creación de un nuevo vencimiento',
              edit: '{{name}}',
            },
            credit_line: {
              new: 'Creación de una nueva línea de crédito',
              edit: 'Ficha de la línea de crédito {{name}}',
            },
            characteristic: 'Características',
            interest_management: 'Gestión de los intereses',
            rate_management: 'Gestión del tipo',
            capital_amortization: 'Amortización del Capital',
            forecast_management: 'Gestión de previsiones',
            mail_alert: 'Alertas por e-mail',
            readonly: 'Solo lectura',
            doc: 'Documentos',
          },
          buttons: {
            add: 'Añadir',
            validate: 'Validar',
            close: 'Cancelar',
            join: 'Adjuntar',
          },
          modal: {
            title: {
              rate: 'Selección de Tasas',
              edit_rate: 'Modificación del vínculo de la tasa',
              doc: 'Documento',
              confirm_evt: '¿Desea generar el evento de pago',
              confirm_pymt: '¿Desea pagar estos plazos',
            },
            columns: {
              margin: 'Margen/Tasa',
              base: 'Base',
              fixe_variable: 'Fijo/Var.',
            },
            champ_titles: {
              start_date: 'Fecha inicial',
              end_date: 'Fecha final',
              doc_type: 'Tipo de documento',
              doc_name: 'Nombre Documento',
              state: 'Estado',
              pdf_doc: 'Documento PDF',
            },
          },
          columns: {
            margin: 'Margen',
            date: 'Fecha',
            doc_name: 'Nombre Documento',
            doc_type: 'Tipo Documento',
            state: 'Estado',
            visualization: 'Visualización',
          },
          champ_titles: {
            type: 'Tipo',
            name: 'Nombre',
            start_date: 'Fecha Inicial',
            end_date: 'Fecha Final',
            first_maturity_date: 'Fecha 1er vencimiento',
            amount: 'Importe',
            rate: 'Tasa',
            break: 'Fracción de acciones',
            interests: 'Intereses',
            period: 'Periodo',
            debit_nature: 'Naturaleza débito',
            credit_nature: 'Naturaleza crédito',
            commission: 'Comisión',
            borrowing_company: 'Empresa prestamista',
            lender_company: 'Empresa prestataria',
            state: 'Estado',
            currency: 'Divisa',
            flow: 'Flujo',
            child_account: 'Cuenta Empresa Matriz',
            parent_account: 'Cuenta Filial',
            emails: 'Correos electrónicos',
            liquidity: 'Liquidez',
            without_amort: 'Sin amortización',
            with_amort: 'Con amortización',
            interest_calculation_mode: 'Método de cálculo de intereses',
          },
          placeholder: {
            flow: '<Pagos excepto flujos Opencash>',
          },
          alert: {
            break_change:
              'La primera fecha de vencimiento se fijará automáticamente en función de la nueva fracción de acciones elegida.',
          },
        },
        payement: {
          payed: 'Pagar los vencimientos',
          icne: 'Cálculo de los intereses devengados',
          titleSelectDate: 'Selección de la fecha',
          date: 'Fecha',
          column: {
            tirage_name: 'Emisión',
            credit_line_name: 'Línea de crédito',
            num: 'No.',
            periode: 'Periodo',
            nbrJ: 'No. Día',
            dateEch: 'Fecha Calendario de vencimientos',
            dateP: 'Fecha Pago',
            capital: 'Capital',
            echeance: 'Vencimiento',
            interet: 'Intereses',
            mouvement: 'Movimiento K',
            capitalRest: 'Capital Pendiente',
            cumulRes: 'Acumulación Pendiente',
            cumulInt: 'Intereses acumulados',
            status: 'Estado',
          },
        },
        emprunt: {
          titlecreation: 'Creación de un nuevo préstamo',
          edit: 'Ficha de un préstamo {{name}}',
          title: 'Lista de préstamos',
          newTirage: 'Nuevo calendario',
          capital: 'Capital',
        },
        placement: {
          compteTitre: {
            title: 'Lista de cuentas de valores',
            lender_company: 'Establecimiento financiero',
            borrowing_company: 'Compañía',
            valeur: 'Valor',
            titleDrawer: 'Agregar un nuevo valor',
            titleEdit: 'Modificar un valor',
            visualisation: {
              title: 'Visualización del estado de cuenta de valores {{name}}',
              column: {
                label: 'Etiqueta',
                quantite: 'Cantidad',
                date_v: 'Fecha valor',
                cours: 'Precio/Precio de compra promedio',
                amount: 'Monto',
                position: 'Posición',
                value: '+/- Valor',
                devise: 'Moneda',
              },
              drawer: {
                title: 'Creación de un nuevo movimiento',
                edit: 'Modificación de un movimiento',
                achat: 'Compra',
                vente: 'Venta',
                dateOperation: 'Fecha de operación',
                dateValeur: 'Fecha de valor',
                prix: 'Precio',
                messQuantite: 'Por favor ingrese el monto o la cantidad.',
                quantite: 'Cantidad',
                montantT: 'Monto total',
                erreur_msg: 'Cantidad disponible en stock: {{quantiteMax}}',
              },
            },
          },
          fiche: {
            title: 'Ficha de la Cuenta título',
            payementManagement: 'Gestión de Pagos',
            etabFinance: 'Establecimiento financiero',
            emprunteur: 'Empresa',
            compteEtablissement: 'Cuenta de establecimiento',
            compteSocieté: 'Cuenta de la empresa',
          },
          compteTerme: {
            title: 'Lista de cuentas a plazo',
            ficheTitle: 'Ficha de la cuenta a plazo',
            payment: 'Pago',
            timeline: 'Gestión de vencimientos',
            generate_event: 'Generar Evento',
            message: '¿Desea generar los eventos?',
            renew: 'Renovar',
          },
        },
        consultation: {
          title: 'Consulta de vencimientos',
          titlePlct: 'Consulta de colocaciones',
          column: {
            timeline_name: 'Calendario',
            company_code: 'Empresa',
            start_date: 'Inicio',
            end_date: 'Fin',
            counterpart: 'Contraparte',
            society: 'Compañía',
            market_room: 'Parqué de operaciones',
            intermediare: 'Empresa intermediaria',
            directing_rate: 'Tasa',
            rate_margin: 'Margen',
            calculation_base: 'Base',
            rate_type: 'Tipo de Tasa',
            f_capital: 'Frecuencia de capital',
            depreciation_type: 'Tipo de amortización',
            f_interest: 'Frecuencia de interés',
            nominal: 'Nominal',
            amount: 'Monto',
            next_due_date: 'Próxima fecha de vencimiento',
            interest: 'Interés',
            icne: 'Cálculo ICNE',
            depreciated_capital: 'Capital amortizado',
            period: 'Período',
            price: 'Precio de compra',
            quantity: 'Cantidad',
            value: '+/- Latente',
            last_rate: 'Precio actual',
            nbJr: 'N° días',
            nbJrICNE: 'N° días ICNE',
            nbJrCome: 'Nº Días restantes',
            nbJrICNECome: 'Intereses por devengar',
            periode: 'Periodo de cálculo',
            nbJour: 'Nº días',
            date_interet: 'Fecha de Interés',
          },
        },
        analyse_plct: {
          title: 'Análisis de colocaciones',
          period_1: 'Período de referencia 1',
          period_2: 'Período de referencia 2',
          column: {
            return: 'Rendimiento',
            net_change: 'Movimientos netos',
            period_1: 'Período 1',
            period_2: 'Período 2',
          },
        },
        value_gestion: {
          table: {
            title: 'Lista de valores',
            button_chargement_cours: 'Carga de Precios',
            columns: {
              status: 'Estado',
              type: 'Tipo',
              code: 'Código ISN',
              mnemonic: 'Mnemotécnico',
              lastrate: 'Último Precio',
              ratedate: 'Fecha Precio',
              favorite: 'Favoritos',
            },
          },
          fiche: {
            title_new: 'Agregar un nuevo valor',
            title_edit: 'Ficha de un nuevo valor: {{code}}',
            first_card_title: 'General',
            code_isin: 'Código ISIN',
            code_nemonic: 'Mnemotécnico',
            name: 'Nombre',
            second_card_title: 'Características',
            type: 'Tipo',
            place_cotation: 'Lugar de Cotización',
            third_tilte: 'Auditoría',
            date_creation: 'Fecha de Creación',
            date_modif: 'Fecha de Modificación',
          },
          visualise: {
            table: {
              title: 'Precio del valor',
              rate: 'Precio',
              date: 'Fecha Precio',
            },
            modal: {
              title: 'Agregar un precio',
            },
          },
          chargement: {
            table: {
              title: 'Lista de valores',
              column: {
                rate: 'Precio',
                date: 'Fecha de Modificación',
                code: 'Código',
                type: 'Tipo',
                name: 'Nombre',
              },
            },
            modal: {
              title: 'Agregar un precio',
              date: 'Fecha de actualización',
            },
          },
        },
        analyse_dept: {
          title: 'Análisis de Deuda',
          placement_etab: 'Deuda por entidad financiera',
          repartition_type: 'Distribución por tipo',
          placement_societe: 'Deuda por empresa',
        },
      },
      Budgets: {
        scenario: {
          list: {
            title: 'Lista de escenarios presupuestarios',
            culumn: {
              etat: 'Estado',
              code: 'Código',
              name: 'Nombre',
              type: 'Tipo',
              period: 'Periodo',
              user: 'Usuario',
              date_modif: 'Fecha de modificación',
            },
          },
          fiche: {
            titleNew: 'Creación de un nuevo escenario',
            editTitle: 'Ficha de un escenario {{code}}',
            title_code_list: 'Lista de códigos de naturaleza',
            title_category_list: 'Lista de códigos de categoría',
            code_natureAll_placehoder: '- Todos los Códigos de Naturaleza -',
            code_categoryAll_placehoder: '- Todos los Códigos de Categoría -',
            champs: {
              etat: 'Estado',
              code: 'Código',
              descri: 'Descripción',
              caracteristic: 'Características',
              annee: 'Año',
              type: 'Tipo de selección',
              type_code: 'Tipo de código',
              periode: 'Periodo',
              month: 'Mes de Inicio',
              filtre_code: 'Filtro por código',
            },
            message_validation:
              'Las condiciones han sido modificadas. Los periodos serán eliminados. ¿Desea continuar? ',
            import_budget: 'Importar',
            message_confirme_purge_budget:
              '¿Desea eliminar todos los datos de « Presupuesto » de su escenario?',
            message_confirme_purge_realisé:
              '¿Desea eliminar todos los datos de « Realizado » de su escenario?',
            purge_budget: 'Purgar presupuesto',
            purge_realisé: 'Purgar realizado',
          },
          visualise: {
            title: 'Visualización del escenario',
            type_placeholder: '- Tipo -',
            period_placeholder: '- Periodo -',
            code_nature_placehoder: '- Código de Naturaleza -',
            applique: 'Aplicar',
            action: {
              import_annuel: 'Importar datos de años anteriores',
              import: 'Importar Excel',
              action: 'Acción',
              recherche: 'Buscar por año',
            },
            modal_import: {
              title: 'Importar datos de años anteriores',
              annee: 'Año',
            },
          },
        },
        analyste: {
          title: 'Análisis Presupuestario',
          titleDrawer:
            'Escenario: Presupuesto {{year}} - {{ name }} {{label}} {{year}}',
          devise: 'Divisa',
          scenario: '- Escenario -',
          total_treso: 'Total Tesorería',
          total_depense: 'Total Gastos',
          total_recette: 'Total Ingresos',
          culumn: {
            nature: 'Naturaleza',
            label: 'Descripción',
            devise: 'Divisa',
            montant_bud: 'Importe presupuestado',
            montant_realiser: 'Importe realizado',
            montant_prev: 'Importe previsto',
            avancement_realiser: 'Avance realizado',
            avancement_realiserPrev: 'Avance realizado y previsiones',
          },
        },
      },
    },
    document: {
      document: {
        document_signataire: {
          title: 'Lista de colegios de documentos',
          fiche: {
            title: 'Creación de un nuevo colegio de documentos',
            edit_title: 'Modificación de un colegio de documentos',
          },
        },
        authority_signataire: {
          title: 'Lista de credenciales documentos',
          fiche: {
            title: 'Creación de un nuevo poder de firma documento',
            edit_title: 'Modificación de un poder de firma documento',
          },
        },
        generation_document: {
          title: 'Actualizar Poder Bancario',
          btn_generate: 'Generar',
          bank_placeholder: '- Banco -',
          fiche: {
            bank: 'Banco',
            iban: 'IBAN',
            devise: 'Divisa',
            pouvoir_bancaire: 'Poder Bancario',
            date_modif: 'Fecha de modificación',
            flow_name: 'Flujo',
          },
          gliss_placeholder: '- Arrastre aquí para agrupar -',
          flux_filter: '- Documento -',
          pouvoir_filter: '- Poder -',
          mandateUser_filter: '- Mandantes personas físicas -',
          mandateCompany_filter: '- Mandantes personas jurídicas -',
          direct_mandate: 'Mandante directo',
        },
        validation_document: {
          title: 'Lista de poderes',
          column: {
            num: 'N°',
            state: 'Estado',
            account: 'Cuenta ',
            society: 'Empresa',
            pouvoir: 'Poder',
            currency: 'Divisa',
            login: 'Login',
            date: 'Fecha',
            signatories: 'Firmante',
            bank: 'Banco',
            code: 'Código de cuenta',
            flow: 'Flujo',
          },
          audit_validation: {
            date: 'Fecha',
            login: 'Login',
            action: 'Action',
          },
          actions: {
            upload: 'Cargar el documento firmado',
          },
          btn_imprime: 'Imprimir',
          btn_sendsignatory: 'Enviar firmantes',
          btn_signature: 'Validar',
          btn_attribut: 'Asignar',
          btn_carton: 'Cartones de firmas',
          btn_identity: 'Documentos de identidad',
          message_confirm_attibute: '¿Realmente desea asignar esta cuenta?',
        },
        sign_document: {
          title: 'Lista de documentos firmados',
        },
        histo_document: {
          title: 'Lista de documentos históricos',
          date_sign: 'Fecha de firma',
          date_envoi: 'Fecha de envío al banco',
          date_recep: 'Fecha de recepción',
          date_retour: 'Fecha de retorno del banco',
          button_action: {
            title: 'Acción',
            envoi: 'Enviado al banco',
            retour: 'Validación del banco',
            recep: 'Recepción del banco',
            refus: 'Rechazo del banco',
          },
          send_bank_modal: {
            email: 'Correos electrónicos',
            bank: 'Banco',
            subject: 'Asunto',
            send: 'Enviar',
          },
        },
        document_authority: {
          titles: {
            by_account: {
              generation: 'Generación de Documentos de Cuenta',
              validation: 'Lista de Documentos de Cuenta',
            },
            by_company: {
              generation: 'Generación de Documentos de Empresa',
              validation: 'Lista de Documentos de Empresa',
            },
          },
        },
        gestion_document: {
          table: {
            title: 'Lista de Signatarios',
            tilte_send_mail_bank: 'Envío email Banquero',
            tilte_send_mail_signataire: 'Envío email Signatario',
            head_filtre_placeholder: '- Todos los colegios -',
            email_bank: 'Email',
            icon_mail_bank: 'Enviar email al banco',
            icon_mail_signataire: 'Enviar email al signatario',
            culumn: {
              state: 'Estado',
              login: 'Login',
              name: 'Nombre',
              lastname: 'Apellido',
              mail: 'Email',
              numphone: 'No. móvil',
              date: 'Fecha de Validez',
              cn: 'DNI',
              passport: 'Pasaporte',
              signature: 'Firma',
              date_birth: 'Fecha de nacimiento',
              country_birth: 'País de nacimiento',
              place_birth: 'Lugar de nacimiento',
              nationality: 'Nacionalidad',
              num_cin: 'Número DNI',
              date_cin: 'Fecha validación',
              civility: 'Tratamiento',
              function: 'Función',
            },
          },
        },
        mandant: {
          title: 'Lista de Mandantes',
          filter: {
            societe: 'Empresas',
            societe_mandat: 'Empresas Mandantes',
            mandant_pers: 'Mandante Personas físicas',
            direct_mandant: 'Mandante directo',
          },
          column: {
            state: 'Estado',
            code: 'Código',
            name: 'Nombre',
            pays: 'País',
            ordre: 'Orden',
            type_lien: 'Tipo de Vínculo del Mandante',
            name_mandat: 'Nombre del Mandante',
            type_mandant: 'Tipo de Mandante',
            fonction: 'Función',
            date_start: 'Fecha de inicio',
            date_end: 'Fecha de fin',
            action: 'Acciones',
          },
        },
      },
    },
    user: {
      profile: {
        dashboard_modal: {
          account: 'Mi cuenta',
          logout: 'Cerrar sesión',
          settings: 'Ajustes',
          change_log: 'Registro de cambios',
        },
        title: 'Mi cuenta',
        buttons: {
          save: 'Validar',
          blocked_device: 'Bloquear el aparato',
          authorized_device: 'Autorizar el aparato',
          change: 'Cambiar la contraseña',
          qrCode: 'Activar 2FA',
          edit_qrCode: 'Ver/Modificar',
          disable_qrCode: 'Desactivar 2FA',
          totpTxt:
            'Escanee el código QR con una aplicación de autenticación e introduzca el código de 6 dígitos.',
        },
        tabs: {
          title: {
            informations: 'Mis datos',
            password: 'Contraseña',
            entities: 'Mis entidades',
            connected_devices: 'Mis aparatos conectados',
            download: 'Descarga',
            card_title_download: 'Descarga OpenCash Parapheur',
            button_name: 'Descargar',
            card_title_download_pouvoir: 'Descarga OpenCash Poder',
          },
          champ_titles: {
            login: 'Login',
            email: 'Dirección de correo',
            last_name: 'Apellido',
            first_name: 'Nombre',
            phone_number: 'Teléfono',
            fax: 'Fax',
            mobile_number: 'Móvil',
            receive_email: 'Recepción correo electrónico',
            language: 'Idioma',
            new_password: 'Nueva contraseña',
            current_password: 'Contraseña actual',
            confirm_password: 'Confirmar la contraseña',
            otp_type: 'Tipo',
          },
          columns: {
            code: 'Código',
            name: 'Nombre',
            defined: 'Marcar como favorito',
          },
        },
      },
    },
    composant: {
      modal_select_filiale: {
        title: 'Selección dela filial para la creación',
        code: 'Code',
        nom: 'Nombre',
        left_title: 'Signatario solo',
        middle_title: 'Signatarios doble',
        right_title: 'Móviles',
        other_title: '',
      },
      details_operation: {
        title: 'Detalle de la operación {{name}}',
        libelle: 'Texto de la operación',
        libelle_complementaire: 'Texto adicional',
        motif: 'Motivo',
        montant: 'Importe',
        exempted: 'Exonerado',
        date_operation: 'Fecha de la operación',
        date_valeur: 'Fecha de valor',
        reference: 'Referencia',
        endtoend: 'Referencia de cliente a cliente',
        category: 'Categoría',
        code_operation: 'Código operación',
        nom_payeur: 'Nombre del pagador',
        id_payeur: 'Id del pagador',
        nom_payeur_final: 'Nombre del pagador final',
        nom_beneficiaire: 'Nombre del beneficiario',
        id_beneficiaire: 'Id del beneficiario',
        nom_beneficiaire_final: 'Nombre del beneficiario final',
        id_beneficiaire_final: 'Id del beneficiario final',
        reference_remise: 'Referencia de la remesa',
        reference_transaction: 'Referencia de la transacción',
        montant_origine: 'Importe de origen',
        taux_change: 'Tipo de cambio',
        compte_beneficiaire: 'Cuenta beneficiaria',
        compte_debiteur: 'Cuenta deudora',
        num_ecriture: 'No. asiento',
        nature_paiement: 'Naturaleza de pago',
        rum: 'RUM',
        libelle_retour: 'Texto ',
      },
      reconciliation: {
        rappro_mvt: 'Movimientos conciliados',
        rappro_prev: 'Previsiones conciliadas',
        rappro_entry: 'Asientos conciliados',
        columns: {
          label: 'Texto',
          category: 'Categoría',
          nature: 'Naturaleza',
          value_date: 'Fecha valor',
          flux: 'Flujo Contable',
          op_date: 'Fecha Operación',
          amount: 'Importe',
          currency: 'Divisa',
          compte: 'Cuenta',
        },
        footerRows: {
          num_mvt: 'Número de movimientos',
          amount_mvt: 'Importe de movimientos',
          num_prev: 'Número de previsiones',
          amount_prev: 'Importe de las previsiones',
          num_entries: 'Número de asientos',
          amount_entries: 'Importe de los asientos',
        },
        user: 'Usuario',
        date: 'Fecha',
        reconciliation_num: 'No. de Conciliación',
        nature_code: 'Código Naturaleza',
      },
      modal_structured_adress: {
        title: 'Generación de direcciones estructuradas',
        placeholder: 'Introduzca aquí la dirección',
        cancel: 'Cancelar',
        send: 'Generar',
        generate: 'Generar dirección estructurada',
      },
    },
    total: 'Totales',
    Initialise: 'Inicializar',
    aSupprimer: 'Eliminar',
    Enter: 'Detalles',
    Admin: 'Administrar',
    error_required: '* Este campo es obligatorio.',
    error_maxLength: '* El número máximo de caracteres permitidos es {{max}}.',
    error_minLength: '* El número mínimo de caracteres permitidos es {{min}}.',
    Json_params: 'Ver parámetro JSON',
    Json: 'Ver JSON',
    Json_return: 'Ver respuesta JSON',
    down_Json_params: 'Descargar parámetro JSON',
    down_Json_return: 'Descargar respuesta JSON',
    Administraion: 'Administración',
    Unlock: 'Desbloquear',
    Action_validation: 'Validación de la acción',
    yes: 'Sí',
    no: 'No',
    date_validation: 'Fecha de la acción',
    Message_validation: '¿Desea validar la acción: ',
    remplace_document: '¿Desea reemplazar el documento?',
    ValidDelete: 'Confirmar eliminación',
    Refuser: '¿Desea rechazar este mensaje?',
    Signer: '¿Desea firmar este mensaje?',
    AdminChange: 'Cambio de cliente',
    listUserClientDispo: 'Cliente',
    listUserAdminDispo: 'Admin',
    search_user: 'Buscar un nombre de usuario',
    backOffice: {
      title: 'Back Office',
      user: {
        title: 'Lista de usuarios del Back Office',
        column: {
          state: 'Estado',
          login: 'Inicio de sesión',
          name: 'Nombre',
          firstName: 'Primer nombre',
          email: 'Correo electrónico',
          dateConn: 'Fecha de conexión',
        },
        fiche: {
          title: 'Ficha del usuario',
          title_pwd: 'Contraseña',
          title_pwd_edit: 'Modificar la contraseña',
          state: 'Estado',
          mail: 'Correo electrónico',
          login: 'Inicio de sesión',
          firstName: 'Primer nombre',
          name: 'Nombre',
          profil_user: 'Perfil de usuario',
          password: 'Contraseña',
          passwordConfirm: 'Confirmación de contraseña',
          errormail: 'Su correo electrónico no es válido',
          errorPasswrd: 'La contraseña es obligatoria',
          errorConfirmPass:
            'La confirmación de la contraseña es obligatoria y debe ser válida',
        },
      },
      groupUser: {
        title: 'Lista de grupos de administradores',
        column: {
          state: 'Estado',
          code: 'Código',
          name: 'Nombre',
          dateModif: 'Fecha de modificación',
        },
      },
      profil: {
        fiche: {
          title:
            'Ficha del grupo de administradores Grupo Super Administradores',
          titleModal: 'Agregar un usuario',
          addProfile: {
            title: 'Acceso al Cliente',
            admin_account: 'Perfil de administrador',
            groupModal: 'Grupo:',
            userModal: 'Usuario',
            column: {
              client_name: 'Nombre del cliente',
              login: 'Inicio de sesión',
              mail: 'Correo electrónico',
              dateModif: 'Fecha de modificación',
              dateCreation: 'Fecha de creación',
            },
          },
        },
      },
      gestionGroup: {
        title: 'Lista de entidades',
        fiche: {
          title: {
            creation: 'Creación de un grupo',
            edit: 'Ficha del grupo {{code}}',
            label_module: 'Lista de módulos',
            module: 'Módulo',
            placeholder_modul: '- Módulo -',
            to_prod_btn: 'Pasar a producción',
          },
          modal_module: {
            title: 'Selección de formato',
            title_table: 'Lista de módulos',
            title_modale_add: 'Agregar un módulo',
            title_modale_edit: 'Modificación de un módulo',
            column: {
              module: 'Módulo',
              nb: 'Nombre',
              date: 'Fecha de creación',
              user: 'Usuario Backoffice',
            },
          },
        },
        administer: {
          title: 'Administración del grupo {{name}}',
          title_card: 'Control de saldos en valor',
          button_solde_value: 'Recalcular saldo de cuentas seleccionadas',
          button_verification_value: 'Verificación de valor',
          control_remise: 'Control de descuentos',
          control_valeur: 'Control de saldo en valor',
          column: {
            state: 'Estado',
            code: 'Código',
            name: 'Nombre',
            dateOP: 'Fecha de operación',
            soldeOP: 'Saldo de operación',
            dateValue: 'Fecha de valor',
            soldeValue: 'Saldo de valor',
          },
        },
        initialiser: {
          title: 'Inicialización del grupo {{name}}',
          title_filiale: 'Sucursal',
          code: 'Código',
          name: 'Nombre',
          list: 'Lista',
          first_title: 'Sucursal',
          title_initialise: 'Inicialización de las tablas',
          label_initialise:
            'Creación del Perfil SuperAdministrador/Administrador Doble/Etiquetas/4 Ojos/Categoría',
          button_create: 'Crear',
          title_create_format: 'Creación de formatos',
          title_import: 'Importar empresas/cuentas',
          title_imp_bank: 'Importar bancos',
          title_beneficiaire: 'Importar beneficiarios',
          title_mandant: 'Importar mandante',
          title_imp_treso: 'Importar plan de tesorería',
          title_cpt_courant: 'Importar cuenta corriente',
          title_mvt: 'Importar movimientos de cuenta corriente',
          title_compta: 'Importar cuentas contables',
          title_soc_tiers_compte:
            'Integración Cubicus Script 1 (Empresas/Cuentas/Usuarios/Perfiles)',
          title_delete_tiers_compte:
            'Integración Cubicus Script 2 (Terceros/Grupo de Terceros)',
          title_tiers: 'Integración Cubicus Script 3 (Historial de lotes)',
          title_histo: 'Importar historial',
          delete_script: 'Eliminar integración Script 1',
          import_users: 'Importar usuarios',
          btn: {
            validate_btn: 'Validar',
            create_btn: 'Crear',
            import_btn: 'Importar',
          },
          modal_format: {
            title: 'Selección de formato',
            title_select: 'Grupo',
          },
          import_societe: 'Importar Empresas',
          import_compte: 'Importar Cuentas',
          title_exodon: 'Integración Exodon',
          title_releve: 'Importar extracto bancario',
        },
        column: {},
      },
      adminGenerale: {
        title: {
          admin: 'Administración general',
          controleBd: 'Control BDD',
          controleAcces: 'Control de accesos',
          controleLabs: 'Control de etiquetas',
          controleWidgets: 'Control de widgets',
          controleChamp: 'Control de campos',
          integrationCubus: 'Integración Cubicus',
          ebam: 'eBAM',
          selectGroup: 'Seleccionar un grupo',
          renew_cert: 'Renovación Certificado HPB',
          select_hostId: 'Seleccionar el HOSTID',
          date: 'Fecha y hora de lanzamiento',
        },
        btn: {
          admin: 'Administración',
          controleBd: 'Verificación BDD',
          controleAcces: 'Control de acceso',
          controleLabs: 'Control de etiquetas',
          controleWidgets: 'Control de widgets',
          controleChamp: 'Control de campos',
          ebam: 'eBAM',
          create_job: 'Crear el trabajo',
        },
      },
      currency: {
        table: {
          title: 'Lista de divisas',
          DeviseISO: 'Divisa ISO',
          label: 'Etiqueta',
          nb_decimal: 'Número decimal',
          code_cdf: 'Código BDF',
        },
        fiche: {
          title: 'Ficha de divisa',
          currency: 'Divisa',
          label: 'Nombre',
        },
      },
      pays: {
        title: 'Lista de países Back Office',
        column: {
          name: 'Nombre',
          dansSepa: 'En Sepa',
          dansFrance: 'En Francia',
          iban: 'IBAN',
          devise: 'Divisa',
          ssid: 'Control SISID',
          codeP: 'Código país',
        },
        fiche: {
          ficheTitle: 'Ficha del país',
          name: 'Nombre',
          devise: 'Divisa',
          dans_sepa: 'En Sepa',
          dans_france: 'En Francia',
          iban: 'IBAN',
          SISIDControl: 'Control SISID',
          code_pays: 'Código de país',
          bbanRegex: 'Formato de regex BBAN',
          bbanExample: 'Ejemplo BBAN',
          bbanRegexiban: 'Formato de regex IBAN',
          bbanExampleiban: 'Ejemplo IBAN',
        },
      },
      codeOperation: {
        title: 'Lista de códigos de operación Back Office',
        table: {
          column: {
            name: 'Etiqueta original',
            sense: 'Sentido',
          },
        },
        fiche: {
          title: 'Ficha de un código de operación',
          code: 'Código',
          label: 'Etiqueta original',
          sense: 'Sentido',
        },
      },
      audit: {
        title: 'Auditoría de acciones de usuarios',
        table_list: '- Tabla -',
        label_or_key: '- Etiqueta -',
        table: {
          column: {
            name: 'Nombre de la tabla',
            key: 'Clave',
            date: 'Fecha',
            label: 'Etiqueta',
            login: 'Login',
          },
        },
        fiche: {
          title: 'Ficha del código de operación',
          code: 'Código',
          label: 'Etiqueta original',
          sense: 'Sentido',
        },
      },
      releve_compte: {
        title: 'Extractos de cuenta',
        placeholder: '- Grupo -',
        detail_title: 'Detalles extractos de cuenta {{name}}',
      },
    },
    vue_simple: 'Vista simple',
    vue_detail: 'Vista detallada',
    next: 'Siguiente',
    prev: 'Anterior',
    Taux: 'Tasa',
    ComboFichier: '- Tipo Archivo -',
    copied: 'Copiar',
    coller: 'Pegar',
    valid: 'Validar',
    selection: '- Seleccionar -',
    risk: {
      operationChange: {
        Liste: {
          table: {
            title: 'Lista de operaciones de cambio',
            paid: 'Paid',
            message_confirm_deal: '¿Desea validar este deal {{code}}?',
            message_confirm_denouer: '¿Desea liquidar este deal {{code}}?',
            message_confirm_soulte: '¿Desea validar esta soulte ?',
            or: 'O',
            and: 'Y',
            tree: 'Arbre',
            list: 'Liste',
            culumn: {
              event: 'Evento',
              state: 'Estado',
              code_deal: 'Referencia externa',
              date_spot: 'Fecha Spot',
              compte_dept: 'Cuenta debitada',
              amount1: 'Importe 1',
              availableAmount: 'Importe restante Divisa 1',
              dev1: 'Divisa 1',
              account_credt: 'Cuenta acreditada',
              amount2: 'Importe 2',
              dev2: 'Divisa 2',
              cotation: 'Cotización',
              soult: 'Ajuste divisa 2',
              accountdev1: 'Cuenta Divisa 1',
              accountdev2: 'Cuenta Divisa 2',
              sens: 'Sentido',
              taux1: 'Spot',
              taux2: 'Plazo',
              py_terme: 'Puntos a plazo',
              lib: 'Concepto',
              date_opera: 'Fecha de operación',
              date_term: 'Fecha de vencimiento',
              value_date: 'Fecha valor',
              balance_date: 'Fecha de vencimiento',
              accrual_date: 'Fecha de liquidación',
              business_code: 'Código de negocio',
              update_timestamp: 'Fecha de modificación',
              create_timestamp: 'Fecha de creación',
              log: 'Usuario',
              society: 'Empresa',
              account1: 'Cuenta 1',
              account2: 'Cuenta 2',
              b2b: 'B2B',
              b2baccount1: 'Cuenta B2B 1',
              b2baccount2: 'Cuenta B2B 2',
              type: 'Tipo',
              origin: 'Origen',
              code: 'Contrato',
            },
            actions: {
              visualise: 'Verview',
              anticipation: 'Anticipar',
              denouement: 'Desenlace',
              proro: 'Prorrogar',
              paid_soult: 'Pago de la compensación',
              print_contract: 'Confirmación',
            },
            audit_action: 'Lista de acciones realizadas',
            calendar: 'Calendario',
          },
          fiche: {
            titles: {
              edit_title: 'Ficha de operación cambio {{code}}',
              new_title: 'Creación de una nueva operación cambio',
              view_title: 'Ficha de la cuenta corriente',
            },
            champs: {
              state: 'Estado',
              code_deal: 'Referencia externa',
              business_code: 'Código Deal',
              date_spot: 'Fecha Spot',
              compte_dept: 'Cuenta debitada',
              amount1: 'Importe 1',
              dev1: 'Divisa 1',
              date_term: 'Fecha de vencimiento',
              account_credt: 'Cuenta acreditada',
              amount2: 'Importe 2',
              dev2: 'Divisa 2',
              sens: 'Sentido',
              taux1: 'Tasa spot',
              taux2: 'Tasa plazo',
              py_terme: 'Puntos de Plazo',
              lib: 'Texto',
              log: 'Login',
              description: 'Descripción',
              type: 'Tipo',
              date_opera: 'Fecha de la operación',
              comment: 'Comentario',
              balance: 'Balance',
              paiement: 'Modo de pago',
              template: 'Plantilla',
            },
            buttons: {
              back: 'Cancelar',
              save: 'Validar',
              create: 'Crear',
            },
          },
          drawer_denoue: {
            title: 'Validación del deal {{code}}',
            title_maket_room: 'Flujo hacia sala de mercados ',
            title_company: 'Flujo hacia empresa',
            champs: {
              flow: 'Flujo',
              account_company: 'Cuenta empresa',
              room_market: 'Cuenta sala mercados',
              account_company2: 'Cuenta holding',
              room_market2: 'Cuenta empresa',
              label: 'Texto',
              nature_debit: 'Naturaleza Débito',
              nature_credit: 'Naturaleza Crédito',
              amount: 'Importe',
              value_date: 'Fecha Valor',
              account_intermediary: 'cuenta intermediaria',
            },
            title_intermediaire_company: 'Flujo hacia intermediario',
          },
          drawer_soult: {
            title: 'Modificación de compensación',
          },
        },
      },
      cotationChange: {
        Liste: {
          table: {
            title: 'Lista de contratos',
            culumn: {
              state: 'Estado',
              market_room: 'Sala de mercados',
              company: 'Empresa',
              company_intermediaire: 'Empresa intermediaria',
              date_start: 'Fecha inicio',
              date_end: 'Fecha fin',
              date_edit: 'Fecha de modificación',
            },
          },
          fiche: {
            title: 'Creación de un contrato',
            edit_title: 'Ficha del contrato {{code}}',
            champs: {
              name: 'Nombre',
              market_room: 'Sala de mercados',
              code: 'Código',
            },
          },
        },
      },
    },
    visu: 'Visualizar',
    expired_session:
      'Sesión expirada. Su token de autenticación ya no es válido. Vuelva a iniciar sesión para continuar.',
  },
}

